export default {
"累计发电量": "累计发电量",
"累计用电量": "累计用电量",
  'exportTime':'导出时间',
  'uploadtime':'上传时间',
  'createtime':'创建时间',
  'filename': '文件名',
  'MOS温度': 'MOS温度',
  '充电MOS': '充电MOS',
  '放电MOS': '放电MOS',
  '叉车':'叉车',
  '无从机系统':'无从机系统',
  "总体高压1": "总体高压1",
  "总体高压2": "总体高压2",
  "总体高压3": "总体高压3",
  "总体低压1": "总体低压1",
  "总体低压2": "总体低压2",
  "总体低压3": "总体低压3",
  "充电过流2~3": "充电过流2~3",
  "放电过流2~3": "放电过流2~3",
  "快充口高温1": "快充口高温1",
  "快充口高温2": "快充口高温2",
  "快充口高温3": "快充口高温3",
  "慢充电口高温1": "慢充电口高温1",
  "慢充电口高温2": "慢充电口高温2",
  "慢充电口高温3": "慢充电口高温3",
  "放电口高温1": "放电口高温1",
  "放电口高温2": "放电口高温2",
  "放电口高温3": "放电口高温3",
  "正极端子高温1": "正极端子高温1",
  "正极端子高温2": "正极端子高温2",
  "正极端子高温3": "正极端子高温3",
  "负极端子高温1": "负极端子高温1",
  "负极端子高温2": "负极端子高温2",
  "负极端子高温3": "负极端子高温3",
  "Ntc采样异常1": "Ntc采样异常1",
  "Ntc采样异常2": "Ntc采样异常2",
  "Ntc采样异常3": "Ntc采样异常3",
  "电芯采样异常1": "电芯采样异常1",
  "电芯采样异常2": "电芯采样异常2",
  "电芯采样异常3": "电芯采样异常3",
  "PACK电压": "PACK电压",
  "PACK温度": "PACK温度",
  "电芯温度个数": "电芯温度个数",
  "PACK端子温度数量": "PACK端子温度数量",
  "PACK端子温度": "PACK端子温度",
  "单体高压1": "单体高压1",
  "单体高压2": "单体高压2",
  "单体高压3": "单体高压3",
  "单体低压1": "单体低压1",
  "单体低压2": "单体低压2",
    "单体低压3": "单体低压3",
    "电池簇总体高压1": "电池簇总体高压1",
    "电池簇总体高压2": "电池簇总体高压2",
    "电池簇总体高压3": "电池簇总体高压3",
    "电池簇总体低压1": "电池簇总体低压1",
    "电池簇总体低压2": "电池簇总体低压2",
    "充电过流3": "充电过流3",
    "放电过流3": "放电过流3",
    "电池簇总体低压3": "电池簇总体低压3",
      "充电高温1": "充电高温1",
      "充电高温2": "充电高温2",
      "充电高温3": "充电高温3",
      "充电低温1": "充电低温1",
      "充电低温2": "充电低温2",
      "充电低温3": "充电低温3",
      "放电高温1": "放电高温1",
      "放电高温2": "放电高温2",
      "放电高温3": "放电高温3",
      "放电低温1": "放电低温1",
      "放电低温2": "放电低温2",
      "放电低温3": "放电低温3",
      "充电温差1": "充电温差1",
      "充电温差2": "充电温差2",
      "充电温差3": "充电温差3",
      "放电温差1": "放电温差1",
      "放电温差2": "放电温差2",
      "放电温差3": "放电温差3",
      "电芯温升1": "电芯温升1",
      "电芯温升2": "电芯温升2",
      "电芯温升3": "电芯温升3",
      "SOC高1": "SOC高1",
      "SOC高2": "SOC高2",
      "SOC高3": "SOC高3",
      "SOC低1": "SOC低1",
      "SOC低2": "SOC低2",
      "SOC低3": "SOC低3",
      "正极绝缘漏电1": "正极绝缘漏电1",
      "正极绝缘漏电2": "正极绝缘漏电2",
      "正极绝缘漏电3": "正极绝缘漏电3",
      "负极绝缘漏电1": "负极绝缘漏电1",
      "负极绝缘漏电2": "负极绝缘漏电2",
      "负极绝缘漏电3": "负极绝缘漏电3",
      "环境高温1": "环境高温1",
      "环境高温2": "环境高温2",
      "环境高温3": "环境高温3",
      "环境低温1": "环境低温1",
      "环境低温2": "环境低温2",
      "环境低温3": "环境低温3",
      "充电压差1": "充电压差1",
      "充电压差2": "充电压差2",
      "充电压差3": "充电压差3",
      "放电压差1": "放电压差1",
      "放电压差2": "放电压差2",
      "放电压差3": "放电压差3",
      "端子高温1": "端子高温1",
      "端子高温2": "端子高温2",
      "端子高温3": "端子高温3",
  "设置": "设置",
  '待机模式':'待机模式',
  '禁充禁放':'禁充禁放',
  'CAN逆变器':'CAN逆变器',
  'MOS环境温度':'MOS环境温度',
  'pack总压':'pack总压',
  '前7天':'前7天',
    "请导出小于七天的数据":'请导出小于七天的数据',
  '设备SN':'设备SN',
  'PACK地址':'PACK地址',
  '设备ID':'设备ID',
  '角色ID':'角色ID',
  'MD5地址': 'MD5地址',
  'BMU地址':'BMU地址',
  'URL地址': 'URL地址',
  '协议列表名称(英文)': '协议列表名称(英文)',
  "数据保留期限": "数据保留期限",
  "儿童隐私": "儿童隐私",
  "本隐私政策的变更": "本隐私政策的变更",
  "联系我们": "联系我们",
  "智慧燃气平台": "智慧燃气平台",
  "平台设备列表": "平台设备列表",
  "您的浏览器不支持": "您的浏览器不支持",
  "元素。": "元素。",
  "报警消息列表": "报警消息列表",
  "待处理报警数量": "待处理报警数量",
  "前往处理": "前往处理",
  "告警排行分析": "告警排行分析",
  "模拟数据列表": "模拟数据列表",
  "多选": "多选",
  "请选择导出设备": "请选择导出设备",
  "数据为空": "数据为空",
  "我的查询条件": "我的查询条件",
  "商户列表": "商户列表",
  "确认删除": "确认删除",
  "显示标记的数据": "显示标记的数据",
  "所属商户": "所属商户",
  "请选择商户": "请选择商户",
  "请输入报警级别": "请输入报警级别",
  "，获取级联的": "，获取级联的",
  "按需获取信息": "按需获取信息",
  "这里是获取节点名称": "这里是获取节点名称",
  "提交弹窗时": "提交弹窗时",
  "取消和关闭弹窗时": "取消和关闭弹窗时",
  "开关弹窗时": "开关弹窗时",
  "图片格式有误": "图片格式有误",
  "或者": "或者",
  "格式的照片": "格式的照片",
  "文件过大，超出": "文件过大，超出",
  "仅上传一张照片": "仅上传一张照片",
  "您确定要删除序号为": "您确定要删除序号为",
  "的数据吗？": "的数据吗？",
  "出货区域不能为空": "出货区域不能为空",
  "获取区域列表": "获取区域列表",
  "等待提交的临时数据": "等待提交的临时数据",
  "单个删除": "单个删除",
  "同时删除临时对象中的数据": "同时删除临时对象中的数据",
  "获取节点所在数组的位置": "获取节点所在数组的位置",
  "这里按照你的需求来存放最后返回的内容吧": "这里按照你的需求来存放最后返回的内容吧",
  "这里的": "这里的",
  "是表示我是根据": "是表示我是根据",
  "去查询父级的，你可以修改成你的需求，其他不变": "去查询父级的，你可以修改成你的需求，其他不变",
  "返回数据": "返回数据",
  "请选择": "请选择",
  "经销商": "经销商",
  "请输入经销商": "请输入经销商",
  "出货区域": "出货区域",
  "请输入出货区域": "请输入出货区域",
  "报警数量": "报警数量",
  "请输入报警数量": "请输入报警数量",
  "楼层数": "楼层数",
  "请输入楼层数": "请输入楼层数",
  "平面图": "平面图",
  "上传平面图": "上传平面图",
  "分配数量不能为": "分配数量不能为",
  "产测时间不能为空": "产测时间不能为空",
  "产品型号不能为空": "产品型号不能为空",
  "所属防制区域：": "所属防制区域：",
  "请选择所属防制区域": "请选择所属防制区域",
  "防制区域名称：": "防制区域名称：",
  "所属建筑物：": "所属建筑物：",
  "地图标记：": "地图标记：",
  "经纬度：": "经纬度：",
  "平面图：": "平面图：",
  "项目编码": "项目编码",
  "平面图名称": "平面图名称",
  "详细地址": "详细地址",
  "所属防制区域名称不能为空": "所属防制区域名称不能为空",
  "平面图名称不能为空": "平面图名称不能为空",
  "地图标注不能为空": "地图标注不能为空",
  "经纬度不能为空": "经纬度不能为空",
  "详细地址不能为空": "详细地址不能为空",
  "平面图不能为空": "平面图不能为空",
  "文件大小超出限制": "文件大小超出限制",
  "请上传小于": "请上传小于",
  "的图片": "的图片",
  "维保开始日期": "维保开始日期",
  "合同开始日期": "合同开始日期",
  "根据点位获取地理位置": "根据点位获取地理位置",
  "其他": "其他",
  "去分配": "去分配",
  "导出历史数据记录": "导出历史数据记录",
  "分配经销商": "分配经销商",
  "的数据吗": "的数据吗",
  "采样频率设置": "采样频率设置",
  "这里显示堆信息": "这里显示堆信息",
  "运行监视": "运行监视",
  "容量统计": "容量统计",
  "容量分析": "容量分析",
  "地址": "地址",
  "电压": "电压",
  "温度": "温度",
  "℃": "℃",
  "电芯温度数量": "电芯温度数量：",
  "电芯数量": "电芯数量：",
  "电芯电压": "电芯电压",
  "电芯温度": "电芯温度",
  "更多": "更多",
  "二级数据": "二级数据",
  "更新时间": "更新时间",
  "串口逆变器": "串口逆变器",
  "网络逆变器": "网络逆变器",
  "当前已是最新版本": "当前已是最新版本",
  "检测新版本": "检测新版本",
  "开始更新固件": "开始更新固件",
  "当前已是最新版本": "当前已是最新版本",
  "检测到新固件": "：检测到新固件",
  "立即升级": "立即升级",
  "升级进度": "升级进度",
  '升级成功':'升级成功',
  "定位到指定": "定位到指定",
  "是否显示二维码": "是否显示二维码",
  "二维码地址": "二维码地址",
  "电池": "电池",
  "设备位置": "设备位置",
  "参数名": "参数名",
  "当前值": "当前值",
  "值": "值",
  "设置值": "设置值",
  "风扇控制": "风扇控制",
  "满充参数": "满充参数",
  "均衡参数": "均衡参数",
  "容量": "容量",
  "短路保护": "短路保护",
  "掉电开关": "掉电开关",
  "继电器控制": "继电器控制",
  "基础控制": "基础控制",
  "保护功能": "保护功能",
  "趋势数据": "趋势数据",
  "电芯电压（": "电芯电压（",
  "去掉辅助线首尾圆点和箭头": "去掉辅助线首尾圆点和箭头",
  "实线": "实线",
  "纵坐标的值，决定横向辅助线在": "纵坐标的值，决定横向辅助线在",
  "轴的位置": "轴的位置",
  "最高限制": "最高限制",
  "最低限制": "最低限制",
  "横坐标的值，决定纵向辅助线在": "横坐标的值，决定纵向辅助线在",
  "纵向辅助线": "纵向辅助线",
  "测试单体数据": "测试单体数据",
  "电芯温度（℃）": "电芯温度（℃）",
  "我的名字": "我的名字",
  "中心点": "中心点",
  "有历史估计，按经纬度显示地图": "有历史估计，按经纬度显示地图",
  "全部设备信息": "全部设备信息",
  "循环找到逆变器": "循环找到逆变器",
  "设置发送刷新命令": "设置发送刷新命令",
  "升级固件": "升级固件",
  "升级": "升级",
  "您确定要升级通道": "您确定要升级通道",
  "的固件吗？": "的固件吗？",
  "拉取进度": "拉取进度",
  "运行数据": "运行数据",
  "最高电压": "最高电压",
  "最低电压": "最低电压",
  "最高温度": "最高温度",
  "最低温度": "最低温度",
  "暂无可升级的固件": "暂无可升级的固件",
  "暂无可更新固件": "暂无可更新固件",
  "检测新的固件版本": "检测新的固件版本",
  "获取设备信息": "获取设备信息",
  "检测成功": "检测成功",
  "毫秒": "毫秒",
  "固件升级超时，升级失败": "固件升级超时，升级失败",
  "升级通知": "升级通知",
  "这里": "这里",
  "设置成功": "设置成功",
  "默认值": "默认值",
  "已复制": "已复制",
  "鼠标悬浮时显示小手": "鼠标悬浮时显示小手",
  "添加过渡效果": "添加过渡效果",
  "堆信息": "堆信息",
  "汇总数据": "汇总数据",
  "详情数据": "详情数据",
  "总压：": "总压：",
  "境温度：": "境温度：",
  "环境温度：": "环境温度：",
  "老数据": "老数据",
  "一级数据": "一级数据",
  "进度测试": "进度测试",
  "已经是最新版本": "已经是最新版本",
  "检测出可升级的固件": "检测出可升级的固件",
  "图标位置": "图标位置",
  "使用自定义图标": "使用自定义图标",
  "添加到地图": "添加到地图",
  "更新图表数据": "更新图表数据",
  "中的": "中的",
  "最大值": "最大值",
  "的长度生成": "的长度生成",
  "轴标签": "轴标签",
  "轴线颜色": "轴线颜色",
  "轴标签颜色": "轴标签颜色",
  "轴分割线颜色": "轴分割线颜色",
  "是数组，使用深度监听": "是数组，使用深度监听",
  "重新设置图表选项": "重新设置图表选项",
  "显示时间": "显示时间",
  "添加颜色原点": "添加颜色原点",
  "充电电流": "充电电流",
  "放电电流": "放电电流",
  "压差": "压差",
  "监测充电数据变化": "监测充电数据变化",
  "监测放电数据变化": "监测放电数据变化",
  "保护": "保护",
  "指示": "指示",
  "请输入申诉内容": "请输入申诉内容",
  "张三": "张三",
  "采样频率不能为空": "采样频率不能为空",
  "采样频率": "采样频率",
  "刷新频率设置": "刷新频率设置",
  "实时监测": "实时监测",
  "铃铛": "铃铛",
  "跳转": "跳转",
  "是否打开蜂鸣器声音": "是否打开蜂鸣器声音",
  "运作": "运作",
  "静止": "静止",
  "实际容量": "实际容量",
  "功率": "功率",
  "当前连接状态": "当前连接状态",
  "会影响电池包正常是否确认": "会影响电池包正常是否确认",
  "均衡": "均衡",
  "电池串数": "电池串数",
  "设备数据": "设备数据",
  "选择时间": "选择时间",
  "返回今日": "返回今日",
  "返回旧页面": "返回旧页面",
  "数据导出": "数据导出",
  "历史数据详情": "历史数据详情",
  "单体电池视图": "单体电池视图",
  "平均电压": "平均电压",
  "示例数据": "示例数据",
  "初始图片源": "初始图片源",
  "控制是否可以点击": "控制是否可以点击",
  "触发对话框逻辑": "触发对话框逻辑",
  "我的值": "我的值",
  "恢复原图片": "恢复原图片",
  "恢复点击": "恢复点击",
  "我的信息": "我的信息",
  "左侧数据": "左侧数据",
  "提示": "提示",
  "会影响电池包正常是否确认？": "会影响电池包正常是否确认？",
  "保留当前路径": "保留当前路径",
  "保留其他查询参数": "保留其他查询参数",
  "地图": "地图",
  "添加标记": "添加标记",
  "标记位置": "标记位置",
  "将标记添加到地图": "将标记添加到地图",
  "创建信息窗口": "创建信息窗口",
  "信息窗口位置": "信息窗口位置",
  "向上偏移": "向上偏移",
  "点击标记显示时间": "点击标记显示时间",
  "打开信息窗口": "打开信息窗口",
  "默认打开信息窗口": "默认打开信息窗口",
  "在地图加载时打开信息窗口": "在地图加载时打开信息窗口",
  "背景": "背景",
  "最大值背景": "最大值背景",
  "最小值背景": "最小值背景",
  "其他值背景": "其他值背景",
  "折线图": "折线图",
  "月份从": "月份从",
  "开始": "开始",
  "复制信息": "复制信息",
  "假设地图在第一个标签": "假设地图在第一个标签",
  "不换行": "不换行",
  "隐藏超出部分": "隐藏超出部分",
  "省略号": "省略号",
  "允许换行": "允许换行",
  "垂直居中对齐": "垂直居中对齐",
  "元素间距": "元素间距",
  "每项之间的间距": "每项之间的间距",
  "图片与文字之间的间距": "图片与文字之间的间距",
  "使背景图像覆盖整个": "使背景图像覆盖整个",
  "居中显示背景图像": "居中显示背景图像",
  "每个元素固定宽度为": "每个元素固定宽度为",
  "计算元素间距，最多": "计算元素间距，最多",
  "个元素": "个元素",
  "每行最后一个元素不需要右边距": "每行最后一个元素不需要右边距",
  "电芯温度个数：": "电芯温度个数：",
  "端子温度数量：": "端子温度数量：",
  "判断启用禁用": "判断启用禁用",
  "端子温度（℃）": "端子温度（℃）",
  "不显示原点": "不显示原点",
  "根据条件显示数据": "根据条件显示数据",
  "中国区": "中国区",
  "香港区": "香港区",
  "欧洲区": "欧洲区",
  "美国区": "美国区",
  "设为默认": "设为默认",
  "您确定要设置": "您确定要设置",
  "为默认吗？": "为默认吗？",
  "联网方式必须": "联网方式必须",
  "实时监测预览": "实时监测预览",
  "单体过压": "单体过压",
  "另一个状态": "另一个状态",
  "折线图数据": "折线图数据",
  "确认下载？": "确认下载？",
  "导出接口": "导出接口",
  "长显的": "长显的",
  "条件": "条件",
  "收起的查询条件": "收起的查询条件",
  "需要点击": "需要点击",
  "按钮显示的": "按钮显示的",
  "是否重新进行分配": "是否重新进行分配",
  "错误信息": "错误信息",
  "详细数据": "详细数据",
  "用户点击确定后的逻辑": "用户点击确定后的逻辑",
  "沛城平台账号": "沛城平台账号",
  "产测时间和产测状态": "产测时间和产测状态",
  "搜索参数名": "搜索参数名",
  "选择参数名": "选择参数名",
  "批量发送": "批量发送",
  "取消全选": "取消全选",
  "输入值非法": "输入值非法",
  "拉取": "拉取",
  "及其内容": "及其内容",
  "不存在": "不存在",
  "存在": "存在",
  "休眠": "休眠",
  "功能参数": "功能参数",
  "掉电关机": "掉电关机",
  "慢充电口高温": "慢充电口高温",
  "加热膜参数": "加热膜参数",
  "小谢": "小谢",
  "设计容量不能小于满充容量": "设计容量不能小于满充容量",
  "满充容量不能小于剩余容量": "满充容量不能小于剩余容量",
  "判断是否设置弹框参数": "判断是否设置弹框参数",
  "多选操作": "多选操作",
  "加热膜控制": "加热膜控制",
  "自动": "自动",
  "常闭": "常闭",
  "常开": "常开",
  "定时开关": "定时开关",
  "判断大小": "判断大小",
  "单个发送": "单个发送",
  "单体抵押": "单体抵押",
  "设置加热膜": "设置加热膜",
  "加热膜控制：": "加热膜控制：",
  "请选择加热膜状态": "请选择加热膜状态",
  "定时计划：": "定时计划：",
  "您确定要删除这条数据吗": "您确定要删除这条数据吗",
  "新增计划": "新增计划",
  "增加定时计划": "增加定时计划",
  "加热膜控制状态：": "加热膜控制状态：",
  "重复：": "重复：",
  "仅一次不选周": "仅一次不选周",
  "周期必选周，可多选": "周期必选周，可多选",
  "周天": "周天",
  "写入计划": "写入计划",
  "时间必须": "时间必须",
  "仅一次": "仅一次",
  "所属项目": "所属项目",
  "请输入平面图名称": "请输入平面图名称",
  "申诉内容": "申诉内容",
  "所属建筑物": "所属建筑物",
  "请输入所属建筑物": "请输入所属建筑物",
  "地图标记": "地图标记",
  "经纬度": "经纬度",
  "请输入经纬度": "请输入经纬度",
  "请输入详细地址": "请输入详细地址",
  "分配编码": "分配编码",
  "申诉内容不能为空": "申诉内容不能为空",
  "是否使用": "是否使用",
  "请选择是否使用": "请选择是否使用",
  "区域名称不能为空": "区域名称不能为空",
  "上级编码不能为空": "上级编码不能为空",
  "添加选中设备": "添加选中设备",
  "添加到提交的对象中": "添加到提交的对象中",
  "清空全选或选择状态？": "清空全选或选择状态？",
  "删除选择": "删除选择",
  "选中后修改": "选中后修改",
  "修改状态": "修改状态",
  "您确认要": "您确认要",
  "请选择项目名称": "请选择项目名称",
  "建筑物选择": "建筑物选择",
  "请选择建筑物选择": "请选择建筑物选择",
  "所在楼层": "所在楼层",
  "请输入所在楼层": "请输入所在楼层",
  "建筑物列表": "建筑物列表",
  "建筑物编码": "建筑物编码",
  "平面图路径": "平面图路径",
  "项目名称不能为空": "项目名称不能为空",
  "建筑物不能为空": "建筑物不能为空",
  "所在楼层不能为空": "所在楼层不能为空",
  "合同编号": "合同编号",
  "合同期限": "合同期限",
  "维保周期": "维保周期",
  "维保开始时间": "维保开始时间",
  "影像图": "影像图",
  "合同结束日期": "合同结束日期",
  "合同时间": "合同时间",
  "维保人员的": "维保人员的",
  "影像图的": "影像图的",
  "客户负责人不能为空": "客户负责人不能为空",
  "联系电话格式不正确": "联系电话格式不正确",
  "合同编号不能为空": "合同编号不能为空",
  "合同时间不能为空": "合同时间不能为空",
  "维保人员不能为空": "维保人员不能为空",
  "维保开始日期不能为空": "维保开始日期不能为空",
  "影像图不能为空": "影像图不能为空",
  "维保周期不能为空": "维保周期不能为空",
  "项目名称筛选": "项目名称筛选",
  "建筑物名称筛选": "建筑物名称筛选",
  "楼层": "楼层",
  "建筑物名称": "建筑物名称",
  "楼吗？": "楼吗？",
  "防制区域名称": "防制区域名称",
  "请输入防制区域名称": "请输入防制区域名称",
  "所属项目不能为空": "所属项目不能为空",
  "低压": "低压",
  "所在服务器": "所在服务器",
  "经销商筛选": "经销商筛选",
  "产品型号筛选": "产品型号筛选",
  "请输入协议列表名称": "请输入协议列表名称",
  "请输入协议列表名称(中文)": "请输入协议列表名称(中文)",
  "请输入协议列表名称(英文)": "请输入协议列表名称(英文)",
  "产品名称不能为空": "产品名称不能为空",
  "协议列表名称不能为空": "协议列表名称不能为空",
  "你确定要删除": "你确定要删除",
  "新增协议列表": "新增协议列表",
  "协议列表中文名称不能为空": "协议列表中文名称不能为空",
  "协议列表英文名称不能为空": "协议列表英文名称不能为空",
  "协议列表名称：": "协议列表名称：",
  "姓名筛选": "姓名筛选",
  "组别": "组别",
  "联系方式": "联系方式",
  "请输入联系方式": "请输入联系方式",
  "请输入组别": "请输入组别",
  "登录名": "登录名",
  "维保项目": "维保项目",
  "请选择维保项目": "请选择维保项目",
  "授权菜单": "授权菜单",
  "请选择授权菜单": "请选择授权菜单",
  "维保服务": "维保服务",
  "维保管理": "维保管理",
  "需要授权的菜单": "需要授权的菜单",
  "组别不能为空": "组别不能为空",
  "联系方式不能为空": "联系方式不能为空",
  "联系方式格式不正确": "联系方式格式不正确",
  "登录名不能为空": "登录名不能为空",
  "维保项目不能为空": "维保项目不能为空",
  "星期一": "星期一",
  "星期二": "星期二",
  "星期三": "星期三",
  "星期四": "星期四",
  "星期五": "星期五",
  "星期六": "星期六",
  "星期日": "星期日",
  "功能开发中": "功能开发中",
  "获取选中项目": "获取选中项目",
  "去重操作": "去重操作",
  "保存经销商权限": "保存经销商权限",
  "下级代理商": "下级代理商",
  "编辑代理商": "编辑代理商",
  "转移代理商": "转移代理商",
  "操作状态": "操作状态",
  "（": "（",
  "账号（手机号）": "账号（手机号）",
  "打开选择接口配置": "打开选择接口配置",
  "所选中的项": "所选中的项",
  "需要改接口状态": "需要改接口状态",
  "应用": "应用",
  "请输入应用": "请输入应用",
  "请输入区域": "请输入区域",
  "请输入售后联系": "请输入售后联系",
  "不能为空": "不能为空",
  "手机号不能为空": "手机号不能为空",
  "选中的遍历选择": "选中的遍历选择",
  "设置默认角色权限": "设置默认角色权限",
  "是否有密码管理权限": "是否有密码管理权限",
  "有权限": "有权限",
  "无权限": "无权限",
  "是否有管理密码权限必须": "是否有管理密码权限必须",
  "请选择默认权限": "请选择默认权限",
  "新增时": "新增时",
  "您在": "您在",
  "的位置单击了地图！": "的位置单击了地图！",
  "根据经纬度查询地址失败": "根据经纬度查询地址失败",
  "构造地点查询类": "构造地点查询类",
  "展现结果的地图实例": "展现结果的地图实例",
  "关键字查询": "关键字查询",
  "经纬度信息": "经纬度信息",
  "这里是": "这里是",
  "上级经销商": "上级经销商",
  "请输入经销商名称": "请输入经销商名称",
  "请选择上级经销商": "请选择上级经销商",
  "上级经销商不能为空": "上级经销商不能为空",
  "所属项目筛选": "所属项目筛选",
  "设备编号筛选": "设备编号筛选",
  "全部报警类型": "全部报警类型",
  "全部防制分类": "全部防制分类",
  "防制分类": "防制分类",
  "报警类型": "报警类型",
  "设备编号": "设备编号",
  "报警时间": "报警时间",
  "所属区域": "所属区域",
  "处理报警": "处理报警",
  "处理告警": "处理告警",
  "您确定要处理": "您确定要处理",
  "的告警吗": "的告警吗",
  "建筑物": "建筑物",
  "现场位置": "现场位置",
  "处理方式": "处理方式",
  "请选择处理方式": "请选择处理方式",
  "已存在坐标": "已存在坐标",
  "楼层列表": "楼层列表",
  "项目记录": "项目记录",
  "设备分类": "设备分类",
  "设备用途": "设备用途",
  "设备编码": "设备编码",
  "设备分类编码": "设备分类编码",
  "设备用途编码": "设备用途编码",
  "楼层编码": "楼层编码",
  "设备图": "设备图",
  "处理人不能为空": "处理人不能为空",
  "处理方式不能为空": "处理方式不能为空",
  "获取楼层": "获取楼层",
  "获取坐标": "获取坐标",
  "项目改变": "项目改变",
  "改变建筑物": "改变建筑物",
  '回车输入多个设备ID': '输入设备ID，回车输入多个设备ID',
  "上传进度": "上传进度",
  "获取设备分类和用途": "获取设备分类和用途",
  "获取当前时间和处理人": "获取当前时间和处理人",
  "请选择硬件版本号": "请选择硬件版本号",
  "固件版本号": "固件版本号",
  '主版本号子版本号': '主版本号.子版本号.修正版本号.Build版本号_YYMMDD;每个版本号字段占用2位10进制数据；',
  '主版本号子版本号1': '比如: 1.02.03.01_180701;主版本号:1;子版本号: 02, 修正版本号:03, Build版本为: 01, 编译时间: 180701',
  "型号": "型号",
  "当前版本状态": "当前版本状态",
  "最新版本": "最新版本",
  "非最新版本": "非最新版本",
  "新增固件版本": "新增固件版本",
  "编辑固件版本": "编辑固件版本",
  "请先选择产品型号,硬件版本号。": "请先选择产品型号,硬件版本号。",
  "硬件版本号。": "硬件版本号。",
  "例如": "例如",
  "请填写固件版本号": "请填写固件版本号",
  "例": "例",
  "主版本号": "主版本号",
  "子版本号": "子版本号",
  "修正版本号": "修正版本号",
  "每个版本号字段占用": "每个版本号字段占用",
  "位": "位",
  "进制数据；": "进制数据；",
  "比如": "比如",
  "版本为": "版本为",
  "编译时间": "编译时间",
  "升级方式": "升级方式",
  "请选择升级方式": "请选择升级方式",
  "上传固件版本": "上传固件版本",
  "版本说明（中文）": "版本说明（中文）",
  "请输入版本说明（中文）": "请输入版本说明（中文）",
  "版本说明（英文）": "版本说明（英文）",
  "请输入版本说明（英文）": "请输入版本说明（英文）",
  "请求升级": "请求升级",
  "强制升级": "强制升级",
  "项目号不能为空": "项目号不能为空",
  "固件版本号不能为空": "固件版本号不能为空",
  "请输入正确的固件版本号": "请输入正确的固件版本号",
  "升级方式不能为空": "升级方式不能为空",
  "固件版本不能为空": "固件版本不能为空",
  "固件大小不可超过": "固件大小不可超过",
  "检测中": "检测中",
  "改变后需要重新上传": "改变后需要重新上传",
  "对应的对象": "对应的对象",
  "检查上传": "检查上传",
  "测试数据": "测试数据",
  "获取第三个项目号": "获取第三个项目号",
  "允许在单词内换行": "允许在单词内换行",
  "同上，现代浏览器推荐使用这个属性别名": "同上，现代浏览器推荐使用这个属性别名",
  "允许自动换行": "允许自动换行",
  "原版本": "原版本",
  "开始版本": "开始版本",
  "结束版本": "结束版本",
  "目标版本": "目标版本",
  "请输入目标版本": "请输入目标版本",
  "开始升级时间：": "开始升级时间：",
  "请选择开始升级时间": "请选择开始升级时间",
  "升级范围": "升级范围",
  "请选择升级范围": "请选择升级范围",
  "方式": "方式",
  "请选择方式": "请选择方式",
  "输入设备": "输入设备",
  "，回车输入多个设备": "，回车输入多个设备",
  "上传设备": "上传设备",
  "文件": "文件",
  "原版本的数据源": "原版本的数据源",
  "大于": "大于",
  "大于等于": "大于等于",
  "等于": "等于",
  "小于": "小于",
  "小于等于": "小于等于",
  "指定设备": "指定设备",
  "全部设备": "全部设备",
  "导入设备": "导入设备",
  "开始升级时间必须": "开始升级时间必须",
  "升级范围不能为空": "升级范围不能为空",
  "方式不能为空": "方式不能为空",
  "文件不能为空": "文件不能为空",
  "检查目标版本开始": "检查目标版本开始",
  "判断当前可选的目标版本和": "判断当前可选的目标版本和",
  "的原版本": "的原版本",
  "过滤目标版本的可选": "过滤目标版本的可选",
  "及获取结束原版本的可选": "及获取结束原版本的可选",
  "重置结束原版本与目标版本": "重置结束原版本与目标版本",
  "供拆分的过滤数组": "供拆分的过滤数组",
  "被删除的数据": "被删除的数据",
  "判断被符号": "判断被符号",
  "目标版本与结束原版本所获得的结果": "目标版本与结束原版本所获得的结果",
  "过滤可选的目标版本": "过滤可选的目标版本",
  "检查目标结束版本": "检查目标结束版本",
  "判断目标版本的可选项": "判断目标版本的可选项",
  "重置开始原版本与目标版本": "重置开始原版本与目标版本",
  "判断原版本的选中是否有效果": "判断原版本的选中是否有效果",
  "开始目标版本与原版本所获得的结果": "开始目标版本与原版本所获得的结果",
  "过滤可选的开始原版本": "过滤可选的开始原版本",
  "判断开始与结束的原版本，以获取可选择的目标版本": "判断开始与结束的原版本，以获取可选择的目标版本",
  "需要重新选择目标版本": "需要重新选择目标版本",
  "过滤开始的原版本": "过滤开始的原版本",
  "判断目标版本是否有可选的范围中": "判断目标版本是否有可选的范围中",
  "需要选择原版本开始版本": "需要选择原版本开始版本",
  "时间改变": "时间改变",
  "输入": "输入",
  "开始升级时间": "开始升级时间",
  "生效中": "生效中",
  "失效": "失效",
  "保存原版本的数据": "保存原版本的数据",
  "你确定要删除此条规则吗？": "你确定要删除此条规则吗？",
  "新增升级规则": "新增升级规则",
  "请选择升级规则": "请选择升级规则",
  "编辑升级规则": "编辑升级规则",
  "文件名不能为空": "文件名不能为空",
  "代理商名称不能为空": "代理商名称不能为空",
  "分配数量": "分配数量",
  "请输入分配数量": "请输入分配数量",
  "请选择经销商": "请选择经销商",
  "请选择出货区域": "请选择出货区域",
  "经销商不能为空": "经销商不能为空",
  "分配区域": "分配区域",
  "超出区域报警设备数量": "超出区域报警设备数量",
  "设备新增激活统计": "设备新增激活统计",
  "请选择起始月份": "请选择起始月份",
  "请选择结束月份": "请选择结束月份",
  "每月激活设备": "每月激活设备",
  "（经销商）": "（经销商）",
  "（区域）": "（区域）",
  "设备激活曲线": "设备激活曲线",
  "拉取统计数据": "拉取统计数据",
  "设备累计上线统计": "设备累计上线统计",
  "每月上线设备": "每月上线设备",
  "每上线设备": "每上线设备",
  "设备上线曲线": "设备上线曲线",
  "我的数据": "我的数据",
  "我的数据用户": "我的数据用户",
  "设备名称筛选": "设备名称筛选",
  "查看设备": "查看设备",
  "申诉": "申诉",
  "您确定要删除设备": "您确定要删除设备",
  "服务器": "服务器",
  "用户手机号": "用户手机号",
  "手机号筛选": "手机号筛选",
  "用户邮箱": "用户邮箱",
  "邮箱筛选": "邮箱筛选",
  "注册时间": "注册时间",
  "上次登录": "上次登录",
  "在线状态": "在线状态",
  "防制区域": "防制区域",
  "楼层管理": "楼层管理",
  "请输入项目名称": "请输入项目名称",
  "请输入客户负责人": "请输入客户负责人",
  "请输入合同编号": "请输入合同编号",
  "请选择合同期限": "请选择合同期限",
  "请选择维保人员": "请选择维保人员",
  "请输入维保周期": "请输入维保周期",
  "请选择维保开始时间": "请选择维保开始时间",
  "上传影像图": "上传影像图",
  "切换成宫格": "切换成宫格",
  "切换成表格": "切换成表格",
  "公司名称搜索": "公司名称搜索",
  "暂无公司": "暂无公司",
  "进入项目": "进入项目",
  "删除防制分类": "删除防制分类",
  "新增防制分类": "新增防制分类",
  "分类名称": "分类名称",
  "请输入分类名称": "请输入分类名称",
  "分类名称不能为空": "分类名称不能为空",
  "行号": "行号",
  "失败原因": "失败原因",
  "平面图列表": "平面图列表",
  "获取设置时的宽度高度": "获取设置时的宽度高度",
  "改变平面图": "改变平面图",
  "请输入设备名称": "请输入设备名称",
  "请输入设备编号": "请输入设备编号",
  "通信方式": "通信方式",
  "请选择通信方式": "请选择通信方式",
  "请选择设备用途": "请选择设备用途",
  "请选择平面图": "请选择平面图",
  "请选择楼层": "请选择楼层",
  "上传设备图": "上传设备图",
  "平面图编码": "平面图编码",
  "设备名称不能为空": "设备名称不能为空",
  "设备编码不能为空": "设备编码不能为空",
  "通信方式不能为空": "通信方式不能为空",
  "设备用途不能为空": "设备用途不能为空",
  "项目不能为空": "项目不能为空",
  "楼层不能为空": "楼层不能为空",
  "现场位置不能为空": "现场位置不能为空",
  "设备图不能为空": "设备图不能为空",
  "设置平面图": "设置平面图",
  "平面图修改": "平面图修改",
  "设置楼层": "设置楼层",
  "控制设置": "控制设置",
  "开灯时间": "开灯时间",
  "请选择开灯时间": "请选择开灯时间",
  "继续添加": "继续添加",
  "定时拍摄": "定时拍摄",
  "请选择定时拍摄": "请选择定时拍摄",
  "灯管寿命": "灯管寿命",
  "请输入灯管寿命": "请输入灯管寿命",
  "粘板寿命": "粘板寿命",
  "请输入粘板寿命": "请输入粘板寿命",
  "粘板报警值": "粘板报警值",
  "请输入单板报警值": "请输入单板报警值",
  "只": "只",
  "密度预警差值": "密度预警差值",
  "请输入密度预警差值": "请输入密度预警差值",
  "事件记录": "事件记录",
  "暂无事件记录": "暂无事件记录",
  "运行状态": "运行状态",
  "最近": "最近",
  "紫外线灯已运行": "紫外线灯已运行",
  "紫外线强度": "紫外线强度",
  "闭": "闭",
  "粘板已使用": "粘板已使用",
  "蝇害密度分析": "蝇害密度分析",
  "实时查看": "实时查看",
  "关联控制": "关联控制",
  "防制趋势图": "防制趋势图",
  "检查固件版本": "检查固件版本",
  "更换": "更换",
  "请输入更换": "请输入更换",
  "最近一个月": "最近一个月",
  "最近三个月": "最近三个月",
  "最近半年": "最近半年",
  "最近一年": "最近一年",
  "最近三年": "最近三年",
  "虫害各类": "虫害各类",
  "数量": "数量",
  "与上次对比": "与上次对比",
  "增长率": "增长率",
  "飞虫列表数据": "飞虫列表数据",
  "是否可以升级": "是否可以升级",
  "开机时间不能为空": "开机时间不能为空",
  "定时拍摄不能为空": "定时拍摄不能为空",
  "灯管寿命不能为空": "灯管寿命不能为空",
  "粘板寿命不能为空": "粘板寿命不能为空",
  "单板报警值不能为空": "单板报警值不能为空",
  "密度预警差值不能为空": "密度预警差值不能为空",
  "加载是否有版本更新": "加载是否有版本更新",
  "分类": "分类",
  "密度分析时间修改": "密度分析时间修改",
  "跑马灯": "跑马灯",
  "拼接多曲线数据": "拼接多曲线数据",
  "较上次增长": "较上次增长",
  "抓拍时间不能为空": "抓拍时间不能为空",
  "趋势图": "趋势图",
  "调用事件记录接口": "调用事件记录接口",
  "运动状态": "运动状态",
  "在离线": "在离线",
  "运行时间": "运行时间",
  "紫外线开关": "紫外线开关",
  "判断是左侧还是右侧进入": "判断是左侧还是右侧进入",
  "高温恢复": "高温恢复",
  "无方法": "无方法",
  "左向侵入": "左向侵入",
  "右向侵入": "右向侵入",
  "心跳": "心跳",
  "获取固件信息": "获取固件信息",
  "获取控制配置信息": "获取控制配置信息",
  "所属防治区域筛选": "所属防治区域筛选",
  "导入结果列表": "导入结果列表",
  "所属防治区域": "所属防治区域",
  "电池电量": "电池电量",
  "请选添加防制分类": "请选添加防制分类",
  "导入数据": "导入数据",
  "失败详情": "失败详情",
  "导入状态": "导入状态",
  "上传成功": "上传成功",
  "导入中": "导入中",
  "导入成功": "导入成功",
  "部分导入成功": "部分导入成功",
  "全部导入失败": "全部导入失败",
  "导入开始时间": "导入开始时间",
  "导入结束时间": "导入结束时间",
  "维保人员筛选": "维保人员筛选",
  "全部维保类型": "全部维保类型",
  "当前所选项": "当前所选项",
  "定期维保": "定期维保",
  "临时维保": "临时维保",
  "执行中": "执行中",
  "未审核": "未审核",
  "已审核": "已审核",
  "批量下载": "批量下载",
  "维保报告": "维保报告",
  "维保类型": "维保类型",
  "开始照片": "开始照片",
  "结束照片": "结束照片",
  "维保状态": "维保状态",
  "请选择需要加载的维保信息": "请选择需要加载的维保信息",
  "选择发生变化": "选择发生变化",
  "暂无图片": "暂无图片",
  "下载维保": "下载维保",
  "您确定要下载此的维保吗": "您确定要下载此的维保吗",
  "审核结果": "审核结果",
  "审核详情": "审核详情",
  "项目：": "项目：",
  "负责人：": "负责人：",
  "联系电话：": "联系电话：",
  "服务报告——": "服务报告——",
  "定期": "定期",
  "临时": "临时",
  "服务人员：": "服务人员：",
  "服务日期：": "服务日期：",
  "开始时间：": "开始时间：",
  "结束时间：": "结束时间：",
  "区域环境检查": "区域环境检查",
  "发现": "发现",
  "风险害虫": "风险害虫",
  "风险级别": "风险级别",
  "处理建议": "处理建议",
  "照片": "照片",
  "暂无内容": "暂无内容",
  "维保信息汇总": "维保信息汇总",
  "防治分类": "防治分类",
  "活动迹象": "活动迹象",
  "更换物品": "更换物品",
  "有": "有",
  "粘板": "粘板",
  "饵剂": "饵剂",
  "配件": "配件",
  "物料更换统计": "物料更换统计",
  "物料名称": "物料名称",
  "规格": "规格",
  "使用位置": "使用位置",
  "防治设备分类": "防治设备分类",
  "设备详情": "设备详情",
  "害虫": "害虫",
  "维保时间": "维保时间",
  "种类、数量": "种类、数量",
  "更换、数量": "更换、数量",
  "施药防控信息": "施药防控信息",
  "登记证号": "登记证号",
  "生产批号": "生产批号",
  "使用量": "使用量",
  "有效成分": "有效成分",
  "靶标害虫": "靶标害虫",
  "应用方法": "应用方法",
  "应用位置": "应用位置",
  "合同号": "合同号",
  "服务项目": "服务项目",
  "服务日期": "服务日期",
  "服务类型": "服务类型",
  "人员签字": "人员签字",
  "人员签字【手写】": "人员签字【手写】",
  "客户签字": "客户签字",
  "客户签字【手写】": "客户签字【手写】",
  "《沛城能源管理平台》": "《沛城能源管理平台》",
  "打开之前": "打开之前",
  "执行了打印": "执行了打印",
  "关闭了打印工具": "关闭了打印工具",
  "负责人": "负责人",
  "服务人员": "服务人员",
  "获取维保报告": "获取维保报告",
  "环境检测信息": "环境检测信息",
  "请选择审核状态": "请选择审核状态",
  "审核说明": "审核说明",
  "请输入审核说明": "请输入审核说明",
  "审核人员": "审核人员",
  "请输入审核人员": "请输入审核人员",
  "审核未通过": "审核未通过",
  "审核状态不能为空": "审核状态不能为空",
  "审核说明不能为空": "审核说明不能为空",
  "审核人员不能为空": "审核人员不能为空",
  "出库": "出库",
  "请上传资料": "请上传资料",
  "确认": "确认",
  "只有在验证通过时关闭对话框": "只有在验证通过时关闭对话框",
  "请填写所有必填项": "请填写所有必填项",
  "提示用户": "提示用户",
  "编辑硬件版本": "编辑硬件版本",
  "请求接口的链接": "请求接口的链接",
  "用户相关接口": "用户相关接口",
  "登录接口": "登录接口",
  "修改账号状态": "修改账号状态",
  "获取当前用户信息": "获取当前用户信息",
  "获取地区省市县": "获取地区省市县",
  "登录成功获取当前用户菜单": "登录成功获取当前用户菜单",
  "解除锁屏": "解除锁屏",
  "修改密码": "修改密码",
  "获取呼叫方式": "获取呼叫方式",
  "获取当前用户的角色信息": "获取当前用户的角色信息",
  "根据姓名获取账号信息": "根据姓名获取账号信息",
  "修改查看工资密码": "修改查看工资密码",
  "设置登录人座右铭": "设置登录人座右铭",
  "设置头像": "设置头像",
  "注册商家账号": "注册商家账号",
  "获取短信验证码": "获取短信验证码",
  "保存基本信息": "保存基本信息",
  "变更账号": "变更账号",
  "实名认证提交": "实名认证提交",
  "企业认证": "企业认证",
  "企业认证倒计时": "企业认证倒计时",
  "实名认证倒计时": "实名认证倒计时",
  "共用的接口": "共用的接口",
  "上传图片文件": "上传图片文件",
  "上传其他文件": "上传其他文件",
  "获取客户资质标签数据": "获取客户资质标签数据",
  "获取可导入客户部门列表": "获取可导入客户部门列表",
  "根据文件标识获取文件信息": "根据文件标识获取文件信息",
  "获得组织树": "获得组织树",
  "根据部门": "根据部门",
  "获取部门的下一级部门列表和部门及下属所有部门的人员信息": "获取部门的下一级部门列表和部门及下属所有部门的人员信息",
  "反馈开始": "反馈开始",
  "添加反馈": "添加反馈",
  "回复反馈": "回复反馈",
  "查询反馈列表": "查询反馈列表",
  "反馈结束": "反馈结束",
  "新增机构": "新增机构",
  "机构列表": "机构列表",
  "编辑机构": "编辑机构",
  "删除机构": "删除机构",
  "保存机构介绍": "保存机构介绍",
  "新增机构密码": "新增机构密码",
  "编辑机构密码": "编辑机构密码",
  "删除机构编码": "删除机构编码",
  "导入机构密码文件": "导入机构密码文件",
  "新增咨询师": "新增咨询师",
  "获取咨询师列表": "获取咨询师列表",
  "编辑咨询师": "编辑咨询师",
  "删除咨询师": "删除咨询师",
  "新增专题": "新增专题",
  "专题列表": "专题列表",
  "编辑专题": "编辑专题",
  "删除专题": "删除专题",
  "获取密码列表和专题列表": "获取密码列表和专题列表",
  "获取题库列表": "获取题库列表",
  "删除题库": "删除题库",
  "下载题库": "下载题库",
  "评测记录列表": "评测记录列表",
  "导出试卷": "导出试卷",
  "下载试卷": "下载试卷",
  "咨询师分析": "咨询师分析",
  "用户分析": "用户分析",
  "导出数据详情": "导出数据详情",
  "预约记录": "预约记录",
  "公开课列表": "公开课列表",
  "新增公开课": "新增公开课",
  "启用禁用": "启用禁用",
  "编辑公开课": "编辑公开课",
  "删除公开课": "删除公开课",
  "导出预约记录": "导出预约记录",
  "审核预约记录": "审核预约记录",
  "新增分类": "新增分类",
  "获取模块列表": "获取模块列表",
  "编辑模块": "编辑模块",
  "获取接口列表": "获取接口列表",
  "根据模块名称获取接口列表": "根据模块名称获取接口列表",
  "新增菜单或页面": "新增菜单或页面",
  "获取菜单列表": "获取菜单列表",
  "菜单列表接口配置时获取基本数据": "菜单列表接口配置时获取基本数据",
  "菜单接口配置时执行保存操作": "菜单接口配置时执行保存操作",
  "角色权限配置获取基本数据": "角色权限配置获取基本数据",
  "新增子账号": "新增子账号",
  "禁用启用子账号": "禁用启用子账号",
  "编辑子账号": "编辑子账号",
  "获取子账号列表": "获取子账号列表",
  "账号管理": "账号管理",
  "权限配置页面（获取菜单列表和接口列表）": "权限配置页面（获取菜单列表和接口列表）",
  "配置账号的权限": "配置账号的权限",
  "获取自己的角色列表": "获取自己的角色列表",
  "设置默认角色": "设置默认角色",
  "新增项目": "新增项目",
  "编辑项目": "编辑项目",
  "删除项目": "删除项目",
  "获取人员列表": "获取人员列表",
  "删除人员": "删除人员",
  "新增建筑物": "新增建筑物",
  "编辑建筑物": "编辑建筑物",
  "删除建筑物": "删除建筑物",
  "新增楼层": "新增楼层",
  "编辑楼层": "编辑楼层",
  "删除楼层": "删除楼层",
  "防制分类列表": "防制分类列表",
  "编辑防制分类": "编辑防制分类",
  "新增设备": "新增设备",
  "编辑设备": "编辑设备",
  "删除设备": "删除设备",
  "获取告警相关下": "获取告警相关下",
  "获取告警列表": "获取告警列表",
  "删除告警": "删除告警",
  "维保管理列表": "维保管理列表",
  "审核维保记录": "审核维保记录",
  "下载维保报告": "下载维保报告",
  "查看维保报告": "查看维保报告",
  "左上角设备统计": "左上角设备统计",
  "中边中部报警统计": "中边中部报警统计",
  "获取左下角近一年新增设备": "获取左下角近一年新增设备",
  "右侧底部项目列表（中部经纬度）统计": "右侧底部项目列表（中部经纬度）统计",
  "获取下载": "获取下载",
  "当前用户修改密码": "当前用户修改密码",
  "打包下载维保报告": "打包下载维保报告",
  "导入的文件列表": "导入的文件列表",
  "查看失败的行": "查看失败的行",
  "获取控制设置内容": "获取控制设置内容",
  "秒后拉取图片到本地": "秒后拉取图片到本地",
  "获取公司列表": "获取公司列表",
  "设备分销管理列表接口": "设备分销管理列表接口",
  "区域列表": "区域列表",
  "经销商列表": "经销商列表",
  "分配详情": "分配详情",
  "设备详细信息列表": "设备详细信息列表",
  "新增经销商": "新增经销商",
  "编辑经销商": "编辑经销商",
  "删除经销商": "删除经销商",
  "获取分类": "获取分类",
  "新增字典": "新增字典",
  "删除字典": "删除字典",
  "字典列表": "字典列表",
  "设置默认": "设置默认",
  "编辑字典": "编辑字典",
  "删除历史记录": "删除历史记录",
  "首页数据": "首页数据",
  "设置设备信息": "设置设备信息",
  "拉取一级，二级数据": "拉取一级，二级数据",
  "下发命令": "下发命令",
  "监测新固件": "监测新固件",
  "下发升级固件命令": "下发升级固件命令",
  "协议列表": "协议列表",
  "上传固件": "上传固件",
  "固件升级进度": "固件升级进度",
  "关于设备下拉": "关于设备下拉",
  "设置时区": "设置时区",
  "列表": "列表",
  "修改平台": "修改平台",
  "获取有效时间": "获取有效时间",
  "获取有效时间表格数据": "获取有效时间表格数据",
  "生成配网二维码": "生成配网二维码",
  "下载记录": "下载记录",
  "删除下载": "删除下载",
  "获取左侧数据": "获取左侧数据",
  "获取右侧折线图": "获取右侧折线图",
  "获取右侧下角": "获取右侧下角",
  "生产管理列表": "生产管理列表",
  "生产管理项目号下拉列表": "生产管理项目号下拉列表",
  "生产管理预览": "生产管理预览",
  "生产管理关联": "生产管理关联",
  "获取菜单": "获取菜单",
  "首页总览统计数据": "首页总览统计数据",
  "服务统计数据": "服务统计数据",
  "用户统计数据": "用户统计数据",
  "产品统计数据": "产品统计数据",
  "删除子账号": "删除子账号",
  "获取所有角色列表": "获取所有角色列表",
  "角色权限配置": "角色权限配置",
  "保存操作": "保存操作",
  "删除角色": "删除角色",
  "获取角色列表": "获取角色列表",
  "获取模块列表（新增接口时）": "获取模块列表（新增接口时）",
  "删除区域": "删除区域",
  "删除商户": "删除商户",
  "首页统计": "首页统计",
  "计划列表": "计划列表",
  "删除计划": "删除计划",
  "编辑计划": "编辑计划",
  "检测固件新版本": "检测固件新版本",
  "下发升级固件指令": "下发升级固件指令",
  "设置采样频率": "设置采样频率",
  "设置逆变器": "设置逆变器",
  "轨迹信息设备列表": "轨迹信息设备列表",
  "获取设备当前位置": "获取设备当前位置",
  "获取容量趋势图": "获取容量趋势图",
  "获取运行趋势图": "获取运行趋势图",
  "轨迹信息轨迹": "轨迹信息轨迹",
  "协议新增": "协议新增",
  "协议删除": "协议删除",
  "产品新增": "产品新增",
  "产品列表": "产品列表",
  "项目密码管理": "项目密码管理",
  "设备密码管理": "设备密码管理",
  "新增硬件版本号": "新增硬件版本号",
  "硬件版本号列表": "硬件版本号列表",
  "产品删除": "产品删除",
  "硬件版本号编辑": "硬件版本号编辑",
  "硬件版本号删除": "硬件版本号删除",
  "固件版本列表": "固件版本列表",
  "固件版本删除": "固件版本删除",
  "升级规则列表": "升级规则列表",
  "升级规则删除": "升级规则删除",
  "设备下拉相关": "设备下拉相关",
  "获取通讯组列表": "获取通讯组列表",
  "获取所有枚举": "获取所有枚举",
  "获取文件": "获取文件",
  "请求接口公用": "请求接口公用",
  "机构密码列表": "机构密码列表",
  "专题列表添加": "专题列表添加",
  "导入试题文件（": "导入试题文件（",
  "评测记录详情": "评测记录详情",
  "专题分析": "专题分析",
  "导出测评记录": "导出测评记录",
  "编辑人员": "编辑人员",
  "新增人员": "新增人员",
  "获取告警相关下拉": "获取告警相关下拉",
  "在离线记录": "在离线记录",
  "拉取图片到": "拉取图片到",
  "服务器接口": "服务器接口",
  "改变": "改变",
  "如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用": "如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用",
  "调用接口": "调用接口",
  "获取用户相关信息": "获取用户相关信息",
  "此方法用来获取未读消息条数，接口只返回数值，不返回消息列表": "此方法用来获取未读消息条数，接口只返回数值，不返回消息列表",
  "获取消息列表，其中包含未读、已读、回收站三个列表": "获取消息列表，其中包含未读、已读、回收站三个列表",
  "根据当前点击的消息的": "根据当前点击的消息的",
  "获取内容": "获取内容",
  "把一个未读消息标记为已读": "把一个未读消息标记为已读",
  "删除一个已读消息到回收站": "删除一个已读消息到回收站",
  "还原一个已删除消息到已读消息": "还原一个已删除消息到已读消息",
  "检查客户号码是否属于当前账号": "检查客户号码是否属于当前账号",
  "添加客户基本信息": "添加客户基本信息",
  "获取子项目的": "获取子项目的",
  "判断是否是数组": "判断是否是数组",
  "获取路由": "获取路由",
  "首页名称": "首页名称",
  "首页列表": "首页列表",
  "所有的微服务的菜单": "所有的微服务的菜单",
  "设置首页名称": "设置首页名称",
  "设置菜单": "设置菜单",
  "获取所有的菜单": "获取所有的菜单",
  "所有枚举类型": "所有枚举类型",
  "导入部门列表": "导入部门列表",
  "客户标签": "客户标签",
  "消息列表": "消息列表",
  "可允许的跟进时间": "可允许的跟进时间",
  "组织树": "组织树",
  "添加一个消息列表": "添加一个消息列表",
  "删除一条队列消息": "删除一条队列消息",
  "设置客户来源": "设置客户来源",
  "设置导入部门数据": "设置导入部门数据",
  "获取配置项值": "获取配置项值",
  "设置级联树": "设置级联树",
  "获取所有枚举类型": "获取所有枚举类型",
  "获取客户来源": "获取客户来源",
  "请求参数": "请求参数",
  "获取配置项": "获取配置项",
  "确定要关闭这一页吗": "确定要关闭这一页吗",
  "查看维保": "查看维保",
  "叉车": "叉车",
  "设备轨迹": "设备轨迹",
  "设备轨迹查询": "设备轨迹查询",
  "告警管理": "告警管理",
  "逆变器字典": "逆变器字典",
  "硬件版本": "硬件版本",
  "报警总览": "报警总览",
  "维保总览": "维保总览",
  "有权限，可访问": "有权限，可访问",
  "无权限，重定向到": "无权限，重定向到",
  "未登录且要跳转的页面不是登录页": "未登录且要跳转的页面不是登录页",
  "未登录且要跳转的页面是登录页": "未登录且要跳转的页面是登录页",
  "跳转到登录页": "跳转到登录页",
  "已登录且要跳转的页面是登录页": "已登录且要跳转的页面是登录页",
  "跳转到": "跳转到",
  "除了原生参数外可配置的参数": "除了原生参数外可配置的参数",
  "显示在侧边栏、面包屑和标签栏的文字": "显示在侧边栏、面包屑和标签栏的文字",
  "多语言字段": "多语言字段",
  "形式结合多语言使用，例子看多语言的路由配置": "形式结合多语言使用，例子看多语言的路由配置",
  "可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由": "可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由",
  "后此级路由将不会出现在面包屑中，示例看": "后此级路由将不会出现在面包屑中，示例看",
  "群路由配置": "群路由配置",
  "后在左侧菜单不会显示该页面选项": "后在左侧菜单不会显示该页面选项",
  "后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件": "后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件",
  "属性和路由配置的": "属性和路由配置的",
  "一致": "一致",
  "可访问该页面的权限数组，当前路由设置的权限会影响子路由": "可访问该页面的权限数组，当前路由设置的权限会影响子路由",
  "该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线": "该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线",
  "设置该字段，则在关闭当前": "设置该字段，则在关闭当前",
  "页时会去": "页时会去",
  "里寻找该字段名对应的方法，作为关闭前的钩子函数": "里寻找该字段名对应的方法，作为关闭前的钩子函数",
  "首页": "首页",
  "设备导入列表": "设备导入列表",
  "错误收集": "错误收集",
  "产品图": "产品图",
  "产品型号": "产品型号",
  "设备": "设备",
  "状态": "状态",
  "操作": "操作",
  "自动根据浏览器系统语言设置语言": "自动根据浏览器系统语言设置语言",
  "写法": "写法",
  "协议列表名称筛选": "协议列表名称筛选",
  "通道": "通道",
  "未分配": "未分配",
  "已分配": "已分配",
  "产品类型不能为空": "产品类型不能为空",
  "硬件版本号不能为空": "硬件版本号不能为空",
  "备注不能为空": "备注不能为空",
  "产品名称必须": "产品名称必须",
  "产品项目号必须": "产品项目号必须",
  "硬件版本号必须": "硬件版本号必须",
  "协议配置必须": "协议配置必须",
  "协议列表名称必须": "协议列表名称必须",
  "说明": "说明",
  "请选择协议列表名称": "请选择协议列表名称",
  "协议列表名称": "协议列表名称",
  "新建产品（产品模型）": "新建产品（产品模型）",
  "协议配置": "协议配置",
  "产品名称": "产品名称",
  "产品项目号": "产品项目号",
  "请输入产品项目号": "请输入产品项目号",
  "高压户储": "高压户储",
  "低压户储": "低压户储",
  "逆变器": "逆变器",
  "请选择产品名称": "请选择产品名称",
  "请选择协议配置": "请选择协议配置",
  "默认": "默认",
  "自定义": "自定义",
  "全部": "全部",
  "新增硬件版本": "新增硬件版本",
  "请选择产品类型": "请选择产品类型",
  "产品类型": "产品类型",
  "请输入硬件版本号": "请输入硬件版本号",
  "硬件版本号筛选": "硬件版本号筛选",
  "请选择产品型号": "请选择产品型号",
  "导出产测成功设备": "导出产测成功设备",
  "暂无数据": "暂无数据",
  "请选择代理商": "请选择代理商",
  "请输入设备": "请输入设备",
  "设备名称": "设备名称",
  "批量分配": "批量分配",
  "搜索": "搜索",
  "生产管理": "生产管理",
  "出库管理": "出库管理",
  "资料下载": "资料下载",
  "告警内容": "告警内容",
  "告警时间": "告警时间",
  "？": "？",
  "设备信息": "设备信息",
  "堆数据": "堆数据",
  "刷新频率更改": "刷新频率更改",
  "簇数据": "簇数据",
  "单体数据": "单体数据",
  "固件升级": "固件升级",
  "产品品类": "产品品类",
  "当前选择的": "当前选择的",
  "家储": "家储",
  "基站": "基站",
  "高压": "高压",
  "无从机系统": "无从机系统",
  "有从机系统，且本机为主机": "有从机系统，且本机为主机",
  "有从机系统，且本机为从机": "有从机系统，且本机为从机",
  "项目号": "项目号",
  "用作设备管理显示": "用作设备管理显示",
  "协议版本号": "协议版本号",
  "外部软件版本号": "外部软件版本号",
  "内部软件版本号": "内部软件版本号",
  "软件开发版本号": "软件开发版本号",
  "系统": "系统",
  "配网显示名称": "配网显示名称",
  "配网": "配网",
  "当前选择的串口逆变器": "当前选择的串口逆变器",
  "当前选择的网络逆变器": "当前选择的网络逆变器",
  "参数设置": "参数设置",
  "历史记录": "历史记录",
  "告警数据": "告警数据",
  "密码管理": "密码管理",
  "历史轨迹": "历史轨迹",
  "无": "无",
  'MOS高温':'MOS高温',
  "单体高压": "单体高压",
  "保护值": "保护值",
  "保护延时": "保护延时",
  "保护恢复值": "保护恢复值",
  "保护恢复延时": "保护恢复延时",
  "单体低压": "单体低压",
  "电池簇总体高压": "电池簇总体高压",
  "电池簇总体低压": "电池簇总体低压",
  "充电过流": "充电过流",
  "充电过流1": "充电过流1",
  "充电过流2": "充电过流2",
  "放电过流": "放电过流",
  "放电过流1": "放电过流1",
  "放电过流2": "放电过流2",
  "充电高温": "充电高温",
  "充电低温": "充电低温",
  "放电高温": "放电高温",
  "放电低温": "放电低温",
  "充电温差": "充电温差",
  "放电温差": "放电温差",
  "电芯温升": "电芯温升",
  "高": "高",
  "低": "低",
  "正极绝缘漏电": "正极绝缘漏电",
  "负极绝缘漏电": "负极绝缘漏电",
  "环境高温": "环境高温",
  "环境低温": "环境低温",
  "充电压差": "充电压差",
  "放电压差": "放电压差",
  "端子高温": "端子高温",
  "开启风扇": "开启风扇",
  "环境温度": "环境温度",
  "端子温度": "端子温度",
  "关闭风扇": "关闭风扇",
  "电芯故障": "电芯故障",
  "满充截止电压": "满充截止电压",
  "满充截止电流": "满充截止电流",
  "低告警值": "低告警值",
  "满充": "满充",
  "释放值": "释放值",
  "均衡开启电压": "均衡开启电压",
  "均衡开启压差": "均衡开启压差",
  "设计容量": "设计容量",
  "剩余容量": "剩余容量",
  "满充容量": "满充容量",
  "短路保护延时": "短路保护延时",
  "掉电单体电压": "掉电单体电压",
  "掉电总体电压": "掉电总体电压",
  "掉电延时时间": "掉电延时时间",
  "单体高压告警值": "单体高压告警值",
  "单体高压保护值": "单体高压保护值",
  "单体高压保护延时": "单体高压保护延时",
  "单体高压恢复值": "单体高压恢复值",
  "单体低压告警值": "单体低压告警值",
  "单体低压保护值": "单体低压保护值",
  "单体低压保护延时": "单体低压保护延时",
  "单体低压恢复值": "单体低压恢复值",
  "总体高压告警": "总体高压告警",
  "总体高压保护值": "总体高压保护值",
  "总体高压保护延时": "总体高压保护延时",
  "总体高压恢复值": "总体高压恢复值",
  "总体低压告警": "总体低压告警",
  "总体低压保护值": "总体低压保护值",
  "总体低压保护延时": "总体低压保护延时",
  "总体低压恢复值": "总体低压恢复值",
  "充电过流告警值": "充电过流告警值",
  "充电过流保护值": "充电过流保护值",
  "充电过流保护延时": "充电过流保护延时",
  "放电过流告警值": "放电过流告警值",
  "放电过流保护值": "放电过流保护值",
  "放电过流保护延时": "放电过流保护延时",
  "充电高温告警值": "充电高温告警值",
  "充电高温保护值": "充电高温保护值",
  "充电高温恢复值": "充电高温恢复值",
  "充电低温告警值": "充电低温告警值",
  "充电低温保护值": "充电低温保护值",
  "充电低温恢复值": "充电低温恢复值",
  "放电高温告警值": "放电高温告警值",
  "放电高温保护值": "放电高温保护值",
  "放电高温恢复值": "放电高温恢复值",
  "放电低温告警值": "放电低温告警值",
  "放电低温保护值": "放电低温保护值",
  "放电低温恢复值": "放电低温恢复值",
  "环境高温告警值": "环境高温告警值",
  "环境高温保护值": "环境高温保护值",
  "环境高温恢复值": "环境高温恢复值",
  "环境低温告警值": "环境低温告警值",
  "环境低温保护值": "环境低温保护值",
  "环境低温恢复值": "环境低温恢复值",
  "高温告警值": "高温告警值",
  "高温保护值": "高温保护值",
  "高温保护恢复值": "高温保护恢复值",
  "休眠单体电压": "休眠单体电压",
  "休眠延时时间": "休眠延时时间",
  "弱电开关": "弱电开关",
  "蜂鸣器": "蜂鸣器",
  "限流": "限流",
  "告警": "告警",
  "上电": "上电",
  "编码": "编码",
  "上电绝缘检测": "上电绝缘检测",
  "上电并机控制": "上电并机控制",
  "绝缘检测使能": "绝缘检测使能",
  "总体高压": "总体高压",
  "总体低压": "总体低压",
  "充电继电器高温": "充电继电器高温",
  "放电继电器高温": "放电继电器高温",
  "负极继电器高温": "负极继电器高温",
  "电芯采样": "电芯采样",
  "采样异常": "采样异常",
  "电流故障检测": "电流故障检测",
  "充电继电器控制": "充电继电器控制",
  "放电继电器控制": "放电继电器控制",
  "预充继电器控制": "预充继电器控制",
  "负极继电器控制": "负极继电器控制",
  "加热膜继电器控制": "加热膜继电器控制",
  "充电继电器使能": "充电继电器使能",
  "放电继电器使能": "放电继电器使能",
  "预充继电器使能": "预充继电器使能",
  "负极继电器使能": "负极继电器使能",
  "加热膜继电器使能": "加热膜继电器使能",
  "电芯高温": "电芯高温",
  "电芯低温": "电芯低温",
  "高温": "高温",
  "预留": "预留",
  "系统锁功能": "系统锁功能",
  "充电继电器粘连": "充电继电器粘连",
  "充电继电器失效": "充电继电器失效",
  "放电继电器粘连": "放电继电器粘连",
  "放电继电器失效": "放电继电器失效",
  "预充继电器粘连": "预充继电器粘连",
  "预充继电器失效": "预充继电器失效",
  "负极继电器粘连": "负极继电器粘连",
  "负极继电器失效": "负极继电器失效",
  "加热膜继电器粘连": "加热膜继电器粘连",
  "加热膜继电器失效": "加热膜继电器失效",
  "异常": "异常",
  "预充故障": "预充故障",
  "加热膜继电器": "加热膜继电器",
  "绝缘板通信故障": "绝缘板通信故障",
  "采样板通信故障": "采样板通信故障",
  "电流分流器故障": "电流分流器故障",
  "故障": "故障",
  "急停": "急停",
  "水浸": "水浸",
  "烟感": "烟感",
  "总压故障": "总压故障",
  "通讯故障": "通讯故障",
  "霍尔故障": "霍尔故障",
  "参数配置失败": "参数配置失败",
  "高压回路故障": "高压回路故障",
  "继电器开关频率高故障": "继电器开关频率高故障",
  "充电继电器": "充电继电器",
  "放电继电器": "放电继电器",
  "预充继电器": "预充继电器",
  "负极继电器": "负极继电器",
  "加热膜": "加热膜",
  "使用": "使用",
  "供电": "供电",
  "充电器反接": "充电器反接",
  "充电器接入": "充电器接入",
  "关机状态": "关机状态",
  "强充指示": "强充指示",
  "预充失败": "预充失败",
  "固件更新成功标志": "固件更新成功标志",
  "并机开始标志": "并机开始标志",
  "并机结束标志": "并机结束标志",
  "并机成功标志": "并机成功标志",
  "并机异常标志": "并机异常标志",
  "绝缘开始标志": "绝缘开始标志",
  "绝缘结束标志": "绝缘结束标志",
  "绝缘检查完成": "绝缘检查完成",
  "绝缘检查异常": "绝缘检查异常",
  "异常掉电": "异常掉电",
  "对外通讯失败": "对外通讯失败",
  "单机模式": "单机模式",
  "并机模式": "并机模式",
  "开关机状态": "开关机状态",
  "满充标志": "满充标志",
  "过放标志": "过放标志",
  "禁充": "禁充",
  "禁放": "禁放",
  "模拟数据测试模式": "模拟数据测试模式",
  "继电器并入禁止": "继电器并入禁止",
  "主回路维护模式": "主回路维护模式",
  "继电器开关频率高告警": "继电器开关频率高告警",
  "允许并入": "允许并入",
  "请求并入": "请求并入",
  "补电模式": "补电模式",
  "总电压": "总电压",
  "负载电压": "负载电压",
  "最大": "最大",
  "最小": "最小",
  "差值": "差值",
  "地址": "地址",
  "电流": "电流",
  "最大电流": "最大电流",
  "最小电流": "最小电流",
  "平均电流": "平均电流",
  "单体电压最大值": "单体电压最大值",
  "最大单体电压": "最大单体电压",
  "最大单体电压在": "最大单体电压在",
  "中的地址": "中的地址",
  "单体电压最小值": "单体电压最小值",
  "最小单体电压": "最小单体电压",
  "最小单体电压在": "最小单体电压在",
  "单体最大压差": "单体最大压差",
  "电池温度最大值": "电池温度最大值",
  "电池温度最大值在": "电池温度最大值在",
  "单体最大温差": "单体最大温差",
  "最大电压值": "最大电压值",
  "最小电压值": "最小电压值",
  "最大电压": "最大电压",
  "最大电压地址": "最大电压地址",
  "最小电压": "最小电压",
  "最小电压地址": "最小电压地址",
  "总体电压最大值": "总体电压最大值",
  "总体电压最小值": "总体电压最小值",
  "总体最大压差": "总体最大压差",
  "在线": "在线",
  "个数": "个数",
  "循环次数": "循环次数",
  "历史充电容量": "历史充电容量",
  "历史放电容量": "历史放电容量",
  "地址编号": "地址编号",
  "系统状态": "系统状态",
  "电池状态": "电池状态",
  "电池温度最小值": "电池温度最小值",
  "电池温度最小值在": "电池温度最小值在",
  "单体过压保护": "单体过压保护",
  "单体过放保护": "单体过放保护",
  "总压过压保护": "总压过压保护",
  "总压过放保护": "总压过放保护",
  "充电过流保护": "充电过流保护",
  "放电过流保护": "放电过流保护",
  "短路": "短路",
  "充电器高压": "充电器高压",
  "充电高温保护（电芯）": "充电高温保护（电芯）",
  "放电高温保护（电芯）": "放电高温保护（电芯）",
  "充电低温保护（电芯）": "充电低温保护（电芯）",
  "放电低温保护（电芯）": "放电低温保护（电芯）",
  "高温保护": "高温保护",
  "环境高温保护": "环境高温保护",
  "环境低温保护": "环境低温保护",
  "（充满）": "（充满）",
  "充电": "充电",
  "放电": "放电",
  "温度传感器故障": "温度传感器故障",
  "采样芯片故障": "采样芯片故障",
  "限流故障": "限流故障",
  "总压过压": "总压过压",
  "温差": "温差",
  "检流电阻": "检流电阻",
  "脱扣器状态": "脱扣器状态",
  "脱扣器": "脱扣器",
  "主从机掉线状态": "主从机掉线状态",
  "限流指示": "限流指示",
  "充电指示": "充电指示",
  "放电指示": "放电指示",
  "供电指示": "供电指示",
  "充电器反接指示": "充电器反接指示",
  "关机": "关机",
  "加热膜指示": "加热膜指示",
  "单体汇总": "单体汇总",
  "蓝牙连接": "蓝牙连接",
  "后台连接": "后台连接",
  "限流关闭": "限流关闭",
  "硬件过压保护": "硬件过压保护",
  "电池包锁定": "电池包锁定",
  "过压": "过压",
  "单体过压告警": "单体过压告警",
  "充电高温告警": "充电高温告警",
  "单体低压告警": "单体低压告警",
  "总压过压告警": "总压过压告警",
  "总压低压告警": "总压低压告警",
  "充电过流告警": "充电过流告警",
  "放电过流告警": "放电过流告警",
  "放电高温告警": "放电高温告警",
  "充电低温告警": "充电低温告警",
  "放电低温告警": "放电低温告警",
  "环境高温告警": "环境高温告警",
  "环境低温告警": "环境低温告警",
  "高温告警": "高温告警",
  "低电量告警": "低电量告警",
  "独立汇总": "独立汇总",
  "（独立电流）": "（独立电流）",
  "屏蔽告警": "屏蔽告警",
  "限流屏蔽": "限流屏蔽",
  "限流挡位": "限流挡位",
  "蜂鸣器告警功能": "蜂鸣器告警功能",
  "均衡状态": "均衡状态",
  "累计充电容量": "累计充电容量",
  "累计放电容量": "累计放电容量",
  "快充口高温": "快充口高温",
  "慢充口高温": "慢充口高温",
  "放电口高温": "放电口高温",
  "正极端子高温": "正极端子高温",
  "负极端子高温": "负极端子高温",
  "级保护状态": "级保护状态",
  "故障状态": "故障状态",
  "开关控制状态": "开关控制状态",
  "开关响应状态": "开关响应状态",
  "继电器真实状态": "继电器真实状态",
  "传感器状态": "传感器状态",
  "特殊状态": "特殊状态",
  "端子温度数量": "端子温度数量",
  "电芯温度最大值": "电芯温度最大值",
  "电芯温度最小值": "电芯温度最小值",
  "最大电芯温度": "最大电芯温度",
  "最小电芯温度": "最小电芯温度",
  "最大电芯温度在": "最大电芯温度在",
  "最小电芯温度在": "最小电芯温度在",
  "电压最大值": "电压最大值",
  "电压最小值": "电压最小值",
  "电压": "电压",
  "快充继电器": "快充继电器",
  "慢充继电器": "慢充继电器",
  "快充继电器使能": "快充继电器使能",
  "慢充继电器使能": "慢充继电器使能",
  "预充": "预充",
  "霍尔传感器": "霍尔传感器",
  "正极端子高温保护": "正极端子高温保护",
  "负极端子高温保护": "负极端子高温保护",
  "电芯采样异常": "电芯采样异常",
  "加热膜开启温度": "加热膜开启温度",
  "加热膜关闭温度": "加热膜关闭温度",
  "时区设置": "时区设置",
  "个人中心": "个人中心",
  "重置密码": "重置密码",
  "退出登录": "退出登录",
  "时区": "时区",
  "亚洲": "亚洲",
  "北美洲": "北美洲",
  "欧洲": "欧洲",
  "南美洲": "南美洲",
  "非洲": "非洲",
  "中国": "中国",
  "日本": "日本",
  "韩国": "韩国",
  "印度": "印度",
  "新加坡": "新加坡",
  "马来西亚": "马来西亚",
  "泰国": "泰国",
  "越南": "越南",
  "台湾地区": "台湾地区",
  "香港地区": "香港地区",
  "澳门地区": "澳门地区",
  "菲律宾": "菲律宾",
  "阿联酋（迪拜）": "阿联酋（迪拜）",
  "美国（东部）": "美国（东部）",
  "加拿大（东部）": "加拿大（东部）",
  "加拿大（西部）": "加拿大（西部）",
  "墨西哥": "墨西哥",
  "英国": "英国",
  "德国": "德国",
  "法国": "法国",
  "意大利": "意大利",
  "西班牙": "西班牙",
  "俄罗斯（莫斯科）": "俄罗斯（莫斯科）",
  "荷兰": "荷兰",
  "瑞士": "瑞士",
  "澳大利亚（东部）": "澳大利亚（东部）",
  "澳大利亚（中部）": "澳大利亚（中部）",
  "新西兰": "新西兰",
  "巴西（圣保罗）": "巴西（圣保罗）",
  "阿根廷": "阿根廷",
  "南非": "南非",
  "埃及": "埃及",
  "肯尼亚": "肯尼亚",
  "时区不能为空": "时区不能为空",
  "原密码": "原密码",
  "新密码": "新密码",
  "重复新密码": "重复新密码",
  "原密码不能为空": "原密码不能为空",
  "新密码不能为空": "新密码不能为空",
  "重复新密码不能为空": "重复新密码不能为空",
  "导出": "导出",
  "代理商管理": "代理商管理",
  "设备总数": "设备总数",
  "在线设备数": "在线设备数",
  "代理商总数": "代理商总数",
  "平台名称": "平台名称",
  "中文": "中文",
  "英文": "英文",
  "平台": "平台",
  "刷新频率": "刷新频率",
  "请输入": "请输入",
  "保存": "保存",
  "行程开始时间": "行程开始时间",
  "行程结束时间": "行程结束时间",
  "开始地址": "开始地址",
  "结束地址": "结束地址",
  "区域管理": "区域管理",
  "告警列表": "告警列表",
  "设备管理": "设备管理",
  "用户管理": "用户管理",
  "逆变器字典管理": "逆变器字典管理",
  "物联网用户列表": "物联网用户列表",
  "设备列表": "设备列表",
  "权限管理": "权限管理",
  "帐号管理": "帐号管理",
  "角色管理": "角色管理",
  "角色名称": "角色名称",
  "请输入角色名称": "请输入角色名称",
  "菜单管理": "菜单管理",
  "接口管理": "接口管理",
  "控制台": "控制台",
  "项目管理": "项目管理",
  "维保人员管理": "维保人员管理",
  "账号权限": "账号权限",
  "模块管理": "模块管理",
  "查看": "查看",
  "控制": "控制",
  "沛城能源管理平台": "沛城能源管理平台",
  "大屏数据": "大屏数据",
  "后台管理": "后台管理",
  "添加": "添加",
  "导入": "导入",
  "下载": "下载",
  "新增出库": "新增出库",
  "新增文件": "新增文件",
  "刷新": "刷新",
  "查询": "查询",
  "重置": "重置",
  "编辑": "编辑",
  "删除": "删除",
  "无数据": "无数据",
  "您确定要删除": "您确定要删除",
  "吗": "吗",
  "序号": "序号",
  "确定": "确定",
  "取消": "取消",
  "协议管理": "协议管理",
  "产品": "产品",
  "自定义协议": "自定义协议",
  "硬件版本管理": "硬件版本管理",
  "固件管理": "固件管理",
  "固件版本": "固件版本",
  "升级规则": "升级规则",
  "资料": "资料",
  "区域分类": "区域分类",
  "区域名称": "区域名称",
  "添加下级区域": "添加下级区域",
  "新增区域": "新增区域",
  "编辑区域": "编辑区域",
  "上级区域": "上级区域",
  "请选择上级区域": "请选择上级区域",
  "请输入区域名称": "请输入区域名称",
  "请输入说明": "请输入说明",
  "代理商": "代理商",
  "区域": "区域",
  "请选择区域": "请选择区域",
  "请输入代理商": "请输入代理商",
  "代理商列表": "代理商列表",
  "代理商名称": "代理商名称",
  "文件名称": "文件名称",
  "请输入文件名称": "请输入文件名称",
  "添加子代理商": "添加子代理商",
  "禁用": "禁用",
  "启用": "启用",
  "转移": "转移",
  "权限": "权限",
  "新增代理商": "新增代理商",
  "请输入代理商名称": "请输入代理商名称",
  "联系人": "联系人",
  "请输入联系人": "请输入联系人",
  "请输入地址": "请输入地址",
  "地图坐标": "地图坐标",
  "请单击地图获取地址": "请单击地图获取地址",
  "请输入经度": "请输入经度",
  "请输入纬度": "请输入纬度",
  "请输入搜索名称": "请输入搜索名称",
  "售后联系": "售后联系",
  "登录账号（手机号或邮箱）": "登录账号（手机号或邮箱）",
  "请输入登录账号（手机号或邮箱）": "请输入登录账号（手机号或邮箱）",
  "登录密码": "登录密码",
  "请输入登录密码": "请输入登录密码",
  "参数设置密码": "参数设置密码",
  "请输入参数设置密码": "请输入参数设置密码",
  "备注": "备注",
  "请输入备注": "请输入备注",
  "名称不能为空": "名称不能为空",
  "联系人不能为空": "联系人不能为空",
  "区域不能为空": "区域不能为空",
  "地址不能为空": "地址不能为空",
  "售后联系不能为空": "售后联系不能为空",
  "手机号或邮箱不能为空": "手机号或邮箱不能为空",
  "登录密码不能为空": "登录密码不能为空",
  "地图坐标不能为空": "地图坐标不能为空",
  "上传时间": "上传时间",
  "创建时间": "创建时间",
  "报警管理": "报警管理",
  "请选择状态": "请选择状态",
  "未处理": "未处理",
  "已处理": "已处理",
  "批量处理": "批量处理",
  "所属代理商": "所属代理商",
  "数据类型": "数据类型",
  "告警原因": "告警原因",
  "处理人": "处理人",
  "处理时间": "处理时间",
  "处理": "处理",
  "告警处理": "告警处理",
  "请输入处理人": "请输入处理人",
  "请选择处理时间": "请选择处理时间",
  "处理人名称不能为空": "处理人名称不能为空",
  "处理时间不能为空": "处理时间不能为空",
  "设备状态": "设备状态",
  "设备分配状态": "设备分配状态",
  "筛选": "筛选",
  "记录时间": "记录时间",
  "选择日期": "选择日期",
  "日期": "日期",
  "版本号": "版本号",
  "硬件版本号": "硬件版本号",
  "软件版本号": "软件版本号",
  "产测状态": "产测状态",
  "产测时间": "产测时间",
  "最后上线时间": "最后上线时间",
  "激活时间": "激活时间",
  "导出历史记录": "导出历史记录",
  "查看轨迹": "查看轨迹",
  "分配": "分配",
  "取消分配": "取消分配",
  "联网方式": "联网方式",
  "操作人": "操作人",
  "告警记录": "告警记录",
  "离线": "离线",
  "未知": "未知",
  "时间筛选": "时间筛选",
  "起始时间、结束时间": "起始时间、结束时间",
  "时间筛选不能为空": "时间筛选不能为空",
  "批量分配代理商": "批量分配代理商",
  "分配代理商": "分配代理商",
  "文件": "文件",
  "请上传": "请上传",
  "下载示例文件": "下载示例文件",
  "请输入新密码": "请输入新密码",
  "新密码必须": "新密码必须",
  "您确定要取消分配": "您确定要取消分配",
  "代理商必选": "代理商必选",
  "协议类型": "协议类型",
  "协议编号": "协议编号",
  "协议名称": "协议名称",
  "逆变器类型": "逆变器类型",
  "编辑逆变器字典": "编辑逆变器字典",
  "查看详情": "查看详情",
  "请选择协议类型": "请选择协议类型",
  "请输入协议编号": "请输入协议编号",
  "请输入协议名称": "请输入协议名称",
  "请选择逆变器类型": "请选择逆变器类型",
  "协议名称筛选": "协议名称筛选",
  "新增逆变器字典": "新增逆变器字典",
  "协议类型不能为空": "协议类型不能为空",
  "协议编号不能为空": "协议编号不能为空",
  "协议名称不能为空": "协议名称不能为空",
  "逆变器类型不能为空": "逆变器类型不能为空",
  "请选择上传": "请选择上传",
  "上传": "上传",
  "文件不可为空": "文件不可为空",
  "文件类型不正确": "文件类型不正确",
  "您确定要导出当前数据吗？": "您确定要导出当前数据吗？",
  "请选择导出时间": "请选择导出时间",
  "吗？": "吗？",
  "登录": "登录",
  "请输入账号（邮箱": "请输入账号（邮箱",
  "手机号）": "手机号）",
  "账号不能为空": "账号不能为空",
  "请输入密码": "请输入密码",
  "密码不能为空": "密码不能为空",
  "忘记密码": "忘记密码",
  "已经有账号": "已经有账号",
  "邮箱找回密码": "邮箱找回密码",
  "重复密码不能为空": "重复密码不能为空",
  "请输入邮箱": "请输入邮箱",
  "邮箱不能为空": "邮箱不能为空",
  "请输入验证码": "请输入验证码",
  "获取邮箱验证码": "获取邮箱验证码",
  "邮箱格式错误": "邮箱格式错误",
  "秒后重新获取": "秒后重新获取",
  "请填写必填项": "请填写必填项",
  "请选择项目号": "请选择项目号",
  "导入结果预览": "导入结果预览",
  "关联": "关联",
  "总条数": "总条数",
  "您确定要导出当前数据吗": "您确定要导出当前数据吗",
  "长时间未操作": "长时间未操作，刷新频率改为60分钟",
  "分钟": "分钟",
  "最新上线时间": "最新上线时间",
  "列设置": "列设置",
  "全选": "全选",
  "展开查询": "展开查询",
  "收起查询": "收起查询",
  "激活趋势": "激活趋势",
  "查看大图": "查看大图",
  "导出成功，请在下载记录菜单中查看": "导出成功，请在下载记录菜单中查看",
  "文件生成中": "文件生成中",
  "导出成功": "导出成功",
  "叉车导出开发中": "叉车导出开发中",
  "导出下载": "导出下载",
  "轨迹列表": "轨迹列表",
  "首頁": "首頁",
  "组件": "组件",
  "数字渐变": "数字渐变",
  "多功能表格": "多功能表格",
  "分割窗口": "分割窗口",
  "編輯器": "編輯器",
  "富文本編輯器": "富文本編輯器",
  "自定義圖標": "自定義圖標",
  "圖片編輯器": "圖片編輯器",
  "上傳數據": "上傳數據",
  "群": "群",
  "文檔": "文檔",
  "上傳": "上傳",
  "粘貼表格數據": "粘貼表格數據",
  "多级菜单": "多级菜单",
  "指令": "指令",
  "導出": "導出",
  "工具函數": "工具函數",
  "拖拽列表": "拖拽列表",
  "多語言": "多語言",
  "模態框題目": "模態框題目",
  "這是模態框內容": "這是模態框內容",
  "顯示模態框": "顯示模態框",
  "注：僅此頁做了多語言，其他頁面沒有在多語言包中添加語言內容": "注：僅此頁做了多語言，其他頁面沒有在多語言包中添加語言內容",
  "錯誤收集": "錯誤收集",
  "錯誤日誌": "錯誤日誌",
  "帶參路由": "帶參路由",
  "動態路由": "動態路由",
  "圖片裁剪": "圖片裁剪",
  "消息中心": "消息中心",
  "樹狀表格": "樹狀表格",
  "基础模块": "基础模块",
  "不能和": "不能和",
  "标签重复的组件，添加别名": "标签重复的组件，添加别名",
  "除了": "除了",
  "在使用中必须是": "在使用中必须是",
  "其他都可以不加": "其他都可以不加",
  "循环注册全局组件": "循环注册全局组件",
  "所写的": "所写的",
  "共用": "共用",
  "属性和方法": "属性和方法",
  "表单校验": "表单校验",
  "封装": "封装",
  "的基本数据": "的基本数据",
  "表格": "表格",
  "默认需要": "默认需要",
  "减去的高度": "减去的高度",
  "选中项": "选中项",
  "请求的": "请求的",
  "参数": "参数",
  "页面数据总数量": "页面数据总数量",
  "填充的数据": "填充的数据",
  "从本地取": "从本地取",
  "获取页面功能权限": "获取页面功能权限",
  "选择所选项": "选择所选项",
  "页码": "页码",
  "点击": "点击",
  "时请求参数的拼装": "时请求参数的拼装",
  "重置当前页为": "重置当前页为",
  "重置当前的": "重置当前的",
  "搜索框——查询客户名称函数": "搜索框——查询客户名称函数",
  "的共用属性和方法": "的共用属性和方法",
  "是否显示模态框": "是否显示模态框",
  "显示与隐藏模态框": "显示与隐藏模态框",
  "带下一步操作": "带下一步操作",
  "删除邮件": "删除邮件",
  "您确定要删除选择的": "您确定要删除选择的",
  "封邮件吗": "封邮件吗",
  "发送请求": "发送请求",
  "删除邮件成功！": "删除邮件成功！",
  "请选择要删除的邮件！": "请选择要删除的邮件！",
  "这里是上一页时间": "这里是上一页时间",
  "配置显示在浏览器标签的": "配置显示在浏览器标签的",
  "在": "在",
  "中存储的天数，默认": "中存储的天数，默认",
  "天": "天",
  "是否使用国际化，默认为": "是否使用国际化，默认为",
  "如果不使用，则需要在路由中给需要在菜单中展示的路由设置": "如果不使用，则需要在路由中给需要在菜单中展示的路由设置",
  "用来在菜单中显示文字": "用来在菜单中显示文字",
  "请求基础路径": "请求基础路径",
  "测试": "测试",
  "默认打开的首页的路由": "默认打开的首页的路由",
  "值，默认为": "值，默认为",
  "需要加载的插件": "需要加载的插件",
  "设为": "设为",
  "后不会在顶部显示错误日志徽标": "后不会在顶部显示错误日志徽标",
  "后在开发环境不会收集错误信息，方便开发中排查错误": "后在开发环境不会收集错误信息，方便开发中排查错误",
  "加密": "加密",
  "硬件故障": "硬件故障",
  "劫持报警": "劫持报警",
  "锁": "锁",
  "防撬报警": "防撬报警",
  "非法钥匙插入报警": "非法钥匙插入报警",
  "非法开锁报警": "非法开锁报警",
  "门未关好报警": "门未关好报警",
  "多次密码输错报警": "多次密码输错报警",
  "开锁次数超过上限": "开锁次数超过上限",
  "低电量报警": "低电量报警",
  "设备恢复出厂值": "设备恢复出厂值",
  "画面移动侦测": "画面移动侦测",
  "声音侦测": "声音侦测",
  "画面遮挡": "画面遮挡",
  "外部人员入侵": "外部人员入侵",
  "周界入侵": "周界入侵",
  "拌线入侵": "拌线入侵",
  "语音抓拍": "语音抓拍",
  "感应到人体": "感应到人体",
  "烟雾报警": "烟雾报警",
  "可燃气体报警": "可燃气体报警",
  "水渍报警": "水渍报警",
  "报警": "报警",
  "高温报警": "高温报警",
  "低温报警": "低温报警",
  "摔倒报警": "摔倒报警",
  "可视门铃触发": "可视门铃触发",
  "检测到人体": "检测到人体",
  "检测到人脸": "检测到人脸",
  "比对人脸": "比对人脸",
  "允许通行": "允许通行",
  "比对人脸，拒绝通行": "比对人脸，拒绝通行",
  "比对人脸，陌生人": "比对人脸，陌生人",
  "发现老鼠": "发现老鼠",
  "电子围栏越界": "电子围栏越界",
  "路径监护异常": "路径监护异常",
  "血压数据异常": "血压数据异常",
  "心率数据异常": "心率数据异常",
  "体温数据异常": "体温数据异常",
  "血糖数据异常": "血糖数据异常",
  "固件升级失败": "固件升级失败",
  "设备上线": "设备上线",
  "设备离线报警": "设备离线报警",
  "打开": "打开",
  "接通，闭合": "接通，闭合",
  "门锁，开关，灯，插座": "门锁，开关，灯，插座",
  "关闭": "关闭",
  "断开": "断开",
  "普通门铃触发": "普通门铃触发",
  "门磁打开": "门磁打开",
  "门磁关闭": "门磁关闭",
  "已佩戴": "已佩戴",
  "未佩戴": "未佩戴",
  "投食": "投食",
  "宠物喂食器": "宠物喂食器",
  "设备充电中": "设备充电中",
  "外部供电": "外部供电",
  "云存文件上传完成": "云存文件上传完成",
  "从有人变为无人": "从有人变为无人",
  "人体感应传感器": "人体感应传感器",
  "感应到有人": "感应到有人",
  "端穿戴温度监测汇总信息": "端穿戴温度监测汇总信息",
  "这是消息内容，这个内容是使用": "这是消息内容，这个内容是使用",
  "富文本编辑器": "富文本编辑器",
  "编辑的，所以你可以看到一些": "编辑的，所以你可以看到一些",
  "格式": "格式",
  "你可以查看": "你可以查看",
  "返回的数据格式，和": "返回的数据格式，和",
  "请求的接口，来确定你的后端接口的开发": "请求的接口，来确定你的后端接口的开发",
  "使用你的真实接口后，前端页面基本不需要修改即可满足基本需求": "使用你的真实接口后，前端页面基本不需要修改即可满足基本需求",
  "快来试试吧": "快来试试吧",
  "配置": "配置",
  "请求延时，可用来测试网络延迟大时项目中一些效果": "请求延时，可用来测试网络延迟大时项目中一些效果",
  "登录相关和获取用户信息": "登录相关和获取用户信息",
  "加载时错误执行报错的禁用": "加载时错误执行报错的禁用",
  "后": "后",
  "出现置顶的情况": "出现置顶的情况",
  "表格间距": "表格间距",
  "多级": "多级",
  "下": "下",
  "的按钮类型": "的按钮类型",
  "高宽分别对应横竖滚动条的尺寸": "高宽分别对应横竖滚动条的尺寸",
  "重新排列搜索的列表": "重新排列搜索的列表",
  "得到两个数组的交集": "得到两个数组的交集",
  "两个数组的元素为数值或字符串": "两个数组的元素为数值或字符串",
  "得到两个数组的并集": "得到两个数组的并集",
  "目标数组": "目标数组",
  "需要查询的数组": "需要查询的数组",
  "判断要查询的数组是否至少有一个元素包含在目标数组中": "判断要查询的数组是否至少有一个元素包含在目标数组中",
  "要验证的字符串或数值": "要验证的字符串或数值",
  "用来验证的列表": "用来验证的列表",
  "判断时间戳格式是否是毫秒": "判断时间戳格式是否是毫秒",
  "传入的时间戳": "传入的时间戳",
  "当前时间时间戳": "当前时间时间戳",
  "传入的时间戳是否早于当前时间戳": "传入的时间戳是否早于当前时间戳",
  "数值": "数值",
  "处理后的字符串": "处理后的字符串",
  "如果传入的数值小于": "如果传入的数值小于",
  "，即位数只有": "，即位数只有",
  "位，则在前面补充": "位，则在前面补充",
  "要返回的时间字符串的格式类型，传入": "要返回的时间字符串的格式类型，传入",
  "则返回年开头的完整时间": "则返回年开头的完整时间",
  "时间戳": "时间戳",
  "相对时间字符串": "相对时间字符串",
  "判断当前传入的时间戳是秒格式还是毫秒": "判断当前传入的时间戳是秒格式还是毫秒",
  "如果是毫秒格式则转为秒格式": "如果是毫秒格式则转为秒格式",
  "传入的时间戳可以是数值或字符串类型，这里统一转为数值类型": "传入的时间戳可以是数值或字符串类型，这里统一转为数值类型",
  "获取当前时间时间戳": "获取当前时间时间戳",
  "判断传入时间戳是否早于当前时间戳": "判断传入时间戳是否早于当前时间戳",
  "获取两个时间戳差值": "获取两个时间戳差值",
  "如果": "如果",
  "为": "为",
  "则差值取反": "则差值取反",
  "前": "前",
  "少于等于": "少于等于",
  "秒": "秒",
  "多于": "多于",
  "秒，少于等于": "秒，少于等于",
  "小时": "小时",
  "秒，少于": "秒，少于",
  "秒，且传入的时间戳早于当前": "秒，且传入的时间戳早于当前",
  "当前浏览器名称": "当前浏览器名称",
  "绑定事件": "绑定事件",
  "解绑事件": "解绑事件",
  "判断一个对象是否存在": "判断一个对象是否存在",
  "，如果传入第二个参数": "，如果传入第二个参数",
  "，则是判断这个": "，则是判断这个",
  "对象是否存在": "对象是否存在",
  "这个属性": "这个属性",
  "如果没有传入": "如果没有传入",
  "这个参数，则判断": "这个参数，则判断",
  "对象是否有键值对": "对象是否有键值对",
  "对象": "对象",
  "判断两个对象是否相等，这两个对象的值只能是数字或字符串": "判断两个对象是否相等，这两个对象的值只能是数字或字符串",
  "保存的天数": "保存的天数",
  "本地路由": "本地路由",
  "通过路由列表得到菜单列表": "通过路由列表得到菜单列表",
  "根据": "根据",
  "获取本地的菜单权限": "获取本地的菜单权限",
  "角色配置的路由": "角色配置的路由",
  "所有的路由列表": "所有的路由列表",
  "权限菜单的路由是否在": "权限菜单的路由是否在",
  "中": "中",
  "写入功能权限": "写入功能权限",
  "获取菜单中，保存的": "获取菜单中，保存的",
  "获取的菜单": "获取的菜单",
  "是否有": "是否有",
  "当前路由": "当前路由",
  "去掉首页的显示": "去掉首页的显示",
  "需要添加到": "需要添加到",
  "上时": "上时",
  "本地存储和获取标签导航列表": "本地存储和获取标签导航列表",
  "其中的每个元素只包含路由原信息中的": "其中的每个元素只包含路由原信息中的",
  "三项": "三项",
  "路由列表数组": "路由列表数组",
  "用于找到路由列表中": "用于找到路由列表中",
  "的对象": "的对象",
  "现有标签导航列表": "现有标签导航列表",
  "新添加的路由原信息对象": "新添加的路由原信息对象",
  "如果该": "如果该",
  "已经存在则不再添加": "已经存在则不再添加",
  "用户权限数组，如": "用户权限数组，如",
  "路由列表": "路由列表",
  "权鉴": "权鉴",
  "即将跳转的路由": "即将跳转的路由",
  "用户权限数组": "用户权限数组",
  "用户是否可跳转到该页": "用户是否可跳转到该页",
  "从": "从",
  "中解析参数": "中解析参数",
  "标签列表": "标签列表",
  "当前关闭的标签的": "当前关闭的标签的",
  "回调函数需要执行的次数": "回调函数需要执行的次数",
  "回调函数": "回调函数",
  "从上传组件得到的文件对象": "从上传组件得到的文件对象",
  "参数是解析后的二维数组": "参数是解析后的二维数组",
  "文件中解析出表格，解析成二维数组": "文件中解析出表格，解析成二维数组",
  "以文本格式读取": "以文本格式读取",
  "读到的数据": "读到的数据",
  "你上传的不是": "你上传的不是",
  "表格数据二维数组": "表格数据二维数组",
  "从二维数组中获取表头和表格数据，将第一行作为表头，用于在": "从二维数组中获取表头和表格数据，将第一行作为表头，用于在",
  "的表格中展示数据": "的表格中展示数据",
  "判断两个路由对象是否相等": "判断两个路由对象是否相等",
  "路由对象": "路由对象",
  "判断打开的标签列表里是否已存在这个新添加的路由对象": "判断打开的标签列表里是否已存在这个新添加的路由对象",
  "根据当前跳转的路由设置显示在浏览器标签的": "根据当前跳转的路由设置显示在浏览器标签的",
  "实例": "实例",
  "获取距离当天的时间": "获取距离当天的时间",
  "年": "年",
  "月": "月",
  "日": "日",
  "获取": "获取",
  "的天数": "的天数",
  "获取当前月份的日期": "获取当前月份的日期",
  "时间戳转年月日": "时间戳转年月日",
  "时间戳转年月日时分秒": "时间戳转年月日时分秒",
  "获取距离当天时间的年月日": "获取距离当天时间的年月日",
  "时分秒": "时分秒",
  "根据用的": "根据用的",
  "显示用户操作权限": "显示用户操作权限",
  "显示用户角色": "显示用户角色",
  "请求回调工厂": "请求回调工厂",
  "遍历整个路由": "遍历整个路由",
  "获取时间之差的天数": "获取时间之差的天数",
  "深拷贝": "深拷贝",
  "封装接口返回": "封装接口返回",
  "根据时间差返回天时分秒": "根据时间差返回天时分秒",
  "得到时间差": "得到时间差",
  "计算出相差天数": "计算出相差天数",
  "计算出小时数": "计算出小时数",
  "计算天数后剩余的毫秒数": "计算天数后剩余的毫秒数",
  "小时前": "小时前",
  "计算相差分钟数": "计算相差分钟数",
  "计算小时数后剩余的毫秒数": "计算小时数后剩余的毫秒数",
  "分钟前": "分钟前",
  "计算相差秒数": "计算相差秒数",
  "计算分钟数后剩余的毫秒数": "计算分钟数后剩余的毫秒数",
  "秒前": "秒前",
  "递归菜单列表": "递归菜单列表",
  "获取当前的年月日时分秒": "获取当前的年月日时分秒",
  "月份": "月份",
  "获取当前的年月日": "获取当前的年月日",
  "根据时获取前后的时间": "根据时获取前后的时间",
  "获取前面": "获取前面",
  "个月": "个月",
  "获取当前月份": "获取当前月份",
  "自定义判断元素类型": "自定义判断元素类型",
  "参数过滤函数": "参数过滤函数",
  "请求拦截": "请求拦截",
  "过滤参数": "过滤参数",
  "添加全局的": "添加全局的",
  "不建议开启，因为界面不友好": "不建议开启，因为界面不友好",
  "响应拦截": "响应拦截",
  "登录过期，重新登录": "登录过期，重新登录",
  "状态，跳转登录页面": "状态，跳转登录页面",
  "登录过期": "登录过期",
  "登录过期，请求重新登录": "登录过期，请求重新登录",
  "湖北省荆州市江陵县白马寺镇": "湖北省荆州市江陵县白马寺镇",
  "枣石高速头陀寺南": "枣石高速头陀寺南",
  "米": "米",
  "心跳校验": "心跳校验",
  "每隔三秒发送心跳": "每隔三秒发送心跳",
  "次心跳均未响应重连": "次心跳均未响应重连",
  "这里发送一个心跳，后端收到后，返回一个心跳消息，": "这里发送一个心跳，后端收到后，返回一个心跳消息，",
  "拿到返回的心跳就说明连接正常": "拿到返回的心跳就说明连接正常",
  "心跳包": "心跳包",
  "计算答复的超时次数": "计算答复的超时次数",
  "异常后重新连接": "异常后重新连接",
  "监听推送的数据": "监听推送的数据",
  "拿到任何消息都说明当前连接是正常的": "拿到任何消息都说明当前连接是正常的",
  "创建一个更高度自定义事件，并派发": "创建一个更高度自定义事件，并派发",
  "连接发生错误": "连接发生错误",
  "连接成功": "连接成功",
  "心跳检测重置": "心跳检测重置",
  "发送": "发送",
  "消息": "消息",
  "对外提供": "对外提供",
  "开启": "开启",
  "若是": "若是",
  "正在开启状态，则等待": "正在开启状态，则等待",
  "后重新调用": "后重新调用",
  "未开启": "未开启",
  "重新调用初始化": "重新调用初始化",
  "数据发送": "数据发送",
  "注册": "注册",
  "内置插件": "内置插件",
  "生产环境关掉提示": "生产环境关掉提示",
  "全局注册应用配置": "全局注册应用配置",
  "注册指令": "注册指令",
  "菜单": "菜单",
  "法律法规": "法律法规",
  "服务条款": "服务条款",
  "法律声明及隐私权政策": "法律声明及隐私权政策",
  "登录区域的共用属性和方法": "登录区域的共用属性和方法",
  "请选择服务条款和法律声明": "请选择服务条款和法律声明",
  "国别": "国别",
  "用户注册": "用户注册",
  "找回密码": "找回密码",
  "请登录": "请登录",
  "显示与隐藏密码": "显示与隐藏密码",
  "记住密码": "记住密码",
  "同意并阅读": "同意并阅读",
  "《服务条款》": "《服务条款》",
  "《法律声明及隐私权政策》": "《法律声明及隐私权政策》",
  "邮箱获取验证码": "邮箱获取验证码",
  "你确定要删除吗": "你确定要删除吗",
  "封装带有": "封装带有",
  "和": "和",
  "的": "的",
  "提供二个插槽": "提供二个插槽",
  "如操作按钮组": "如操作按钮组",
  "如排序字段": "如排序字段",
  "常用": "常用",
  "内容": "内容",
  "不常用的": "不常用的",
  "折叠": "折叠",
  "搜索和重置按钮": "搜索和重置按钮",
  "选中的值": "选中的值",
  "是否显示查询区域": "是否显示查询区域",
  "用于显示当前": "用于显示当前",
  "表头的": "表头的",
  "到本地": "到本地",
  "显示查询区域": "显示查询区域",
  "基本样式": "基本样式",
  "单元格之间": "单元格之间",
  "的样式": "的样式",
  "是否显示高级搜索": "是否显示高级搜索",
  "头部操作按钮": "头部操作按钮",
  "表格数据": "表格数据",
  "表格列数据": "表格列数据",
  "是否显示间隔斑马纹": "是否显示间隔斑马纹",
  "是否显示纵向边框": "是否显示纵向边框",
  "是否显示": "是否显示",
  "表格高度": "表格高度",
  "分页总数": "分页总数",
  "分页尺寸": "分页尺寸",
  "分页": "分页",
  "默认需要减去的高度": "默认需要减去的高度",
  "全不选": "全不选",
  "显示的列数": "显示的列数",
  "刷新表格": "刷新表格",
  "重置当前": "重置当前",
  "显示面板": "显示面板",
  "选择改变时触发": "选择改变时触发",
  "输入关键字搜索": "输入关键字搜索",
  "全局设置是否可编辑": "全局设置是否可编辑",
  "是否可搜索": "是否可搜索",
  "搜索控件所在位置，": "搜索控件所在位置，",
  "返回值": "返回值",
  "：同": "：同",
  "函数中的": "函数中的",
  "同上": "同上",
  "：除上面三个参数外，还有一个": "：除上面三个参数外，还有一个",
  "修改后的数据": "修改后的数据",
  "高级搜索": "高级搜索",
  "上一页": "上一页",
  "下一页": "下一页",
  "表头": "表头",
  "返回值：事件对象，但是在事件对象中加入了两个参数：": "返回值：事件对象，但是在事件对象中加入了两个参数：",
  "当前是否在最小值处": "当前是否在最小值处",
  "当前是否在最大值处": "当前是否在最大值处",
  "事件列表为": "事件列表为",
  "编辑器的事件，更多事件类型，请参考：": "编辑器的事件，更多事件类型，请参考：",
  "起始值，即动画开始前显示的数值": "起始值，即动画开始前显示的数值",
  "结束值，即动画结束后显示的数值": "结束值，即动画结束后显示的数值",
  "保留几位小数": "保留几位小数",
  "分隔整数和小数的符号，默认是小数点": "分隔整数和小数的符号，默认是小数点",
  "动画持续的时间，单位是秒": "动画持续的时间，单位是秒",
  "动画延迟开始的时间，单位是秒": "动画延迟开始的时间，单位是秒",
  "是否禁用": "是否禁用",
  "动画效果": "动画效果",
  "是否使用分组，分组后每三位会用一个符号分隔": "是否使用分组，分组后每三位会用一个符号分隔",
  "用于分组": "用于分组",
  "的符号": "的符号",
  "是否简化显示，设为": "是否简化显示，设为",
  "后会使用": "后会使用",
  "单位来做相关省略": "单位来做相关省略",
  "自定义单位，如": "自定义单位，如",
  "即大于": "即大于",
  "位数小于": "位数小于",
  "位数的用": "位数的用",
  "来做省略": "来做省略",
  "即显示为": "即显示为",
  "上传图片": "上传图片",
  "裁剪": "裁剪",
  "轴渐变": "轴渐变",
  "不显示刻度": "不显示刻度",
  "坐标轴两边留白策略": "坐标轴两边留白策略",
  "区域中分隔线": "区域中分隔线",
  "提示组件框": "提示组件框",
  "相关行为": "相关行为",
  "长宽比": "长宽比",
  "自定义名称映射": "自定义名称映射",
  "是否开启鼠标缩放和平移漫游": "是否开启鼠标缩放和平移漫游",
  "初始化": "初始化",
  "报警信息": "报警信息",
  "触发数据": "触发数据",
  "单选": "单选",
  "高温与还原": "高温与还原",
  "报警数据": "报警数据",
  "多米尼加": "多米尼加",
  "巴勒斯坦": "巴勒斯坦",
  "巴哈马": "巴哈马",
  "东帝汶": "东帝汶",
  "阿富汗": "阿富汗",
  "几内亚比绍": "几内亚比绍",
  "科特迪瓦": "科特迪瓦",
  "锡亚琴冰川": "锡亚琴冰川",
  "英属印度洋领土": "英属印度洋领土",
  "安哥拉": "安哥拉",
  "阿尔巴尼亚": "阿尔巴尼亚",
  "阿联酋": "阿联酋",
  "亚美尼亚": "亚美尼亚",
  "法属南半球和南极领地": "法属南半球和南极领地",
  "澳大利亚": "澳大利亚",
  "奥地利": "奥地利",
  "阿塞拜疆": "阿塞拜疆",
  "布隆迪": "布隆迪",
  "比利时": "比利时",
  "贝宁": "贝宁",
  "布基纳法索": "布基纳法索",
  "孟加拉国": "孟加拉国",
  "保加利亚": "保加利亚",
  "波斯尼亚和黑塞哥维那": "波斯尼亚和黑塞哥维那",
  "白俄罗斯": "白俄罗斯",
  "伯利兹": "伯利兹",
  "百慕大": "百慕大",
  "玻利维亚": "玻利维亚",
  "巴西": "巴西",
  "文莱": "文莱",
  "不丹": "不丹",
  "博茨瓦纳": "博茨瓦纳",
  "中非": "中非",
  "加拿大": "加拿大",
  "智利": "智利",
  "象牙海岸": "象牙海岸",
  "喀麦隆": "喀麦隆",
  "刚果民主共和国": "刚果民主共和国",
  "刚果": "刚果",
  "哥伦比亚": "哥伦比亚",
  "哥斯达黎加": "哥斯达黎加",
  "古巴": "古巴",
  "北塞浦路斯": "北塞浦路斯",
  "塞浦路斯": "塞浦路斯",
  "捷克": "捷克",
  "吉布提": "吉布提",
  "丹麦": "丹麦",
  "阿尔及利亚": "阿尔及利亚",
  "厄瓜多尔": "厄瓜多尔",
  "厄立特里亚": "厄立特里亚",
  "爱沙尼亚": "爱沙尼亚",
  "埃塞俄比亚": "埃塞俄比亚",
  "芬兰": "芬兰",
  "斐": "斐",
  "福克兰群岛": "福克兰群岛",
  "加蓬": "加蓬",
  "格鲁吉亚": "格鲁吉亚",
  "加纳": "加纳",
  "几内亚": "几内亚",
  "冈比亚": "冈比亚",
  "赤道几内亚": "赤道几内亚",
  "希腊": "希腊",
  "格陵兰": "格陵兰",
  "危地马拉": "危地马拉",
  "法属圭亚那": "法属圭亚那",
  "圭亚那": "圭亚那",
  "洪都拉斯": "洪都拉斯",
  "克罗地亚": "克罗地亚",
  "海地": "海地",
  "匈牙利": "匈牙利",
  "印度尼西亚": "印度尼西亚",
  "爱尔兰": "爱尔兰",
  "伊朗": "伊朗",
  "伊拉克": "伊拉克",
  "冰岛": "冰岛",
  "以色列": "以色列",
  "牙买加": "牙买加",
  "约旦": "约旦",
  "哈萨克斯坦": "哈萨克斯坦",
  "吉尔吉斯斯坦": "吉尔吉斯斯坦",
  "柬埔寨": "柬埔寨",
  "科索沃": "科索沃",
  "科威特": "科威特",
  "老挝": "老挝",
  "黎巴嫩": "黎巴嫩",
  "利比里亚": "利比里亚",
  "利比亚": "利比亚",
  "斯里兰卡": "斯里兰卡",
  "莱索托": "莱索托",
  "立陶宛": "立陶宛",
  "卢森堡": "卢森堡",
  "拉脱维亚": "拉脱维亚",
  "摩洛哥": "摩洛哥",
  "摩尔多瓦": "摩尔多瓦",
  "马达加斯加": "马达加斯加",
  "马其顿": "马其顿",
  "马里": "马里",
  "缅甸": "缅甸",
  "黑山": "黑山",
  "蒙古": "蒙古",
  "莫桑比克": "莫桑比克",
  "毛里塔尼亚": "毛里塔尼亚",
  "马拉维": "马拉维",
  "纳米比亚": "纳米比亚",
  "新喀里多尼亚": "新喀里多尼亚",
  "尼日尔": "尼日尔",
  "尼日利亚": "尼日利亚",
  "尼加拉瓜": "尼加拉瓜",
  "挪威": "挪威",
  "尼泊尔": "尼泊尔",
  "阿曼": "阿曼",
  "巴基斯坦": "巴基斯坦",
  "巴拿马": "巴拿马",
  "秘鲁": "秘鲁",
  "巴布亚新几内亚": "巴布亚新几内亚",
  "波兰": "波兰",
  "波多黎各": "波多黎各",
  "朝鲜": "朝鲜",
  "葡萄牙": "葡萄牙",
  "巴拉圭": "巴拉圭",
  "卡塔尔": "卡塔尔",
  "罗马尼亚": "罗马尼亚",
  "俄罗斯": "俄罗斯",
  "卢旺达": "卢旺达",
  "西撒哈拉": "西撒哈拉",
  "沙特阿拉伯": "沙特阿拉伯",
  "苏丹": "苏丹",
  "南苏丹": "南苏丹",
  "塞内加尔": "塞内加尔",
  "所罗门群岛": "所罗门群岛",
  "塞拉利昂": "塞拉利昂",
  "萨尔瓦多": "萨尔瓦多",
  "索马里兰": "索马里兰",
  "索马里": "索马里",
  "塞尔维亚": "塞尔维亚",
  "苏里南": "苏里南",
  "斯洛伐克": "斯洛伐克",
  "斯洛文尼亚": "斯洛文尼亚",
  "瑞典": "瑞典",
  "斯威士兰": "斯威士兰",
  "叙利亚": "叙利亚",
  "乍得": "乍得",
  "多哥": "多哥",
  "塔吉克斯坦": "塔吉克斯坦",
  "土库曼斯坦": "土库曼斯坦",
  "特里尼达和多巴哥": "特里尼达和多巴哥",
  "突尼斯": "突尼斯",
  "土耳其": "土耳其",
  "坦桑尼亚": "坦桑尼亚",
  "乌干达": "乌干达",
  "乌克兰": "乌克兰",
  "乌拉圭": "乌拉圭",
  "美国": "美国",
  "乌兹别克斯坦": "乌兹别克斯坦",
  "委内瑞拉": "委内瑞拉",
  "瓦努阿图": "瓦努阿图",
  "西岸": "西岸",
  "也门": "也门",
  "赞比亚": "赞比亚",
  "津巴布韦": "津巴布韦",
  "获取当前的选中状态": "获取当前的选中状态",
  "紫外线信息": "紫外线信息",
  "恢复": "恢复",
  "粘板信息": "粘板信息",
  "大飞虫": "大飞虫",
  "小飞虫": "小飞虫",
  "电量": "电量",
  "温湿度信息": "温湿度信息",
  "温湿度": "温湿度",
  "维保信息": "维保信息",
  "维保": "维保",
  "正常": "正常",
  "刻度标签": "刻度标签",
  "分隔线": "分隔线",
  "坐标轴线": "坐标轴线",
  "多条拆线图": "多条拆线图",
  "显示内容": "显示内容",
  "坐标轴先": "坐标轴先",
  "温度": "温度",
  "湿度": "湿度",
  "海门": "海门",
  "鄂尔多斯": "鄂尔多斯",
  "招远": "招远",
  "舟山": "舟山",
  "齐齐哈尔": "齐齐哈尔",
  "盐城": "盐城",
  "赤峰": "赤峰",
  "青岛": "青岛",
  "乳山": "乳山",
  "金昌": "金昌",
  "泉州": "泉州",
  "莱西": "莱西",
  "日照": "日照",
  "胶南": "胶南",
  "南通": "南通",
  "拉萨": "拉萨",
  "云浮": "云浮",
  "梅州": "梅州",
  "文登": "文登",
  "上海": "上海",
  "攀枝花": "攀枝花",
  "威海": "威海",
  "承德": "承德",
  "厦门": "厦门",
  "汕尾": "汕尾",
  "潮州": "潮州",
  "丹东": "丹东",
  "太仓": "太仓",
  "曲靖": "曲靖",
  "烟台": "烟台",
  "福州": "福州",
  "瓦房店": "瓦房店",
  "即墨": "即墨",
  "抚顺": "抚顺",
  "玉溪": "玉溪",
  "张家口": "张家口",
  "阳泉": "阳泉",
  "莱州": "莱州",
  "湖州": "湖州",
  "汕头": "汕头",
  "昆山": "昆山",
  "宁波": "宁波",
  "湛江": "湛江",
  "揭阳": "揭阳",
  "荣成": "荣成",
  "连云港": "连云港",
  "葫芦岛": "葫芦岛",
  "常熟": "常熟",
  "东莞": "东莞",
  "河源": "河源",
  "淮安": "淮安",
  "泰州": "泰州",
  "南宁": "南宁",
  "营口": "营口",
  "惠州": "惠州",
  "江阴": "江阴",
  "蓬莱": "蓬莱",
  "韶关": "韶关",
  "嘉峪关": "嘉峪关",
  "广州": "广州",
  "延安": "延安",
  "太原": "太原",
  "清远": "清远",
  "中山": "中山",
  "昆明": "昆明",
  "寿光": "寿光",
  "盘锦": "盘锦",
  "长治": "长治",
  "深圳": "深圳",
  "珠海": "珠海",
  "宿迁": "宿迁",
  "咸阳": "咸阳",
  "铜川": "铜川",
  "平度": "平度",
  "佛山": "佛山",
  "海口": "海口",
  "江门": "江门",
  "章丘": "章丘",
  "肇庆": "肇庆",
  "大连": "大连",
  "临汾": "临汾",
  "吴江": "吴江",
  "石嘴山": "石嘴山",
  "沈阳": "沈阳",
  "苏州": "苏州",
  "茂名": "茂名",
  "嘉兴": "嘉兴",
  "长春": "长春",
  "胶州": "胶州",
  "银川": "银川",
  "张家港": "张家港",
  "三门峡": "三门峡",
  "锦州": "锦州",
  "南昌": "南昌",
  "柳州": "柳州",
  "三亚": "三亚",
  "自贡": "自贡",
  "吉林": "吉林",
  "阳江": "阳江",
  "泸州": "泸州",
  "西宁": "西宁",
  "宜宾": "宜宾",
  "呼和浩特": "呼和浩特",
  "成都": "成都",
  "大同": "大同",
  "镇江": "镇江",
  "桂林": "桂林",
  "张家界": "张家界",
  "宜兴": "宜兴",
  "北海": "北海",
  "西安": "西安",
  "金坛": "金坛",
  "东营": "东营",
  "牡丹江": "牡丹江",
  "遵义": "遵义",
  "绍兴": "绍兴",
  "扬州": "扬州",
  "常州": "常州",
  "潍坊": "潍坊",
  "重庆": "重庆",
  "台州": "台州",
  "南京": "南京",
  "滨州": "滨州",
  "贵阳": "贵阳",
  "无锡": "无锡",
  "本溪": "本溪",
  "克拉玛依": "克拉玛依",
  "渭南": "渭南",
  "马鞍山": "马鞍山",
  "宝鸡": "宝鸡",
  "焦作": "焦作",
  "句容": "句容",
  "北京": "北京",
  "徐州": "徐州",
  "衡水": "衡水",
  "包头": "包头",
  "绵阳": "绵阳",
  "乌鲁木齐": "乌鲁木齐",
  "枣庄": "枣庄",
  "杭州": "杭州",
  "淄博": "淄博",
  "鞍山": "鞍山",
  "溧阳": "溧阳",
  "库尔勒": "库尔勒",
  "安阳": "安阳",
  "开封": "开封",
  "济南": "济南",
  "德阳": "德阳",
  "温州": "温州",
  "九江": "九江",
  "邯郸": "邯郸",
  "临安": "临安",
  "兰州": "兰州",
  "沧州": "沧州",
  "临沂": "临沂",
  "南充": "南充",
  "天津": "天津",
  "富阳": "富阳",
  "泰安": "泰安",
  "诸暨": "诸暨",
  "郑州": "郑州",
  "哈尔滨": "哈尔滨",
  "聊城": "聊城",
  "芜湖": "芜湖",
  "唐山": "唐山",
  "平顶山": "平顶山",
  "邢台": "邢台",
  "德州": "德州",
  "济宁": "济宁",
  "荆州": "荆州",
  "宜昌": "宜昌",
  "义乌": "义乌",
  "丽水": "丽水",
  "洛阳": "洛阳",
  "秦皇岛": "秦皇岛",
  "株洲": "株洲",
  "石家庄": "石家庄",
  "莱芜": "莱芜",
  "常德": "常德",
  "保定": "保定",
  "湘潭": "湘潭",
  "金华": "金华",
  "岳阳": "岳阳",
  "长沙": "长沙",
  "衢州": "衢州",
  "廊坊": "廊坊",
  "菏泽": "菏泽",
  "合肥": "合肥",
  "武汉": "武汉",
  "大庆": "大庆",
  "在这里做一个点击事件的监听，绑定的是": "在这里做一个点击事件的监听，绑定的是",
  "方法": "方法",
  "设置样式": "设置样式",
  "雷达图": "雷达图",
  "紫外线灯开": "紫外线灯开",
  "紫外线灯关": "紫外线灯关",
  "强度": "强度",
  "开关": "开关",
  "仪表盘刻度的分割段数": "仪表盘刻度的分割段数",
  "属性": "属性",
  "控制线条样式": "控制线条样式",
  "刻度": "刻度",
  "线": "线",
  "样式": "样式",
  "坐标轴小标记": "坐标轴小标记",
  "控制线长": "控制线长",
  "（详见": "（详见",
  "）控制线条样式": "）控制线条样式",
  "其余属性默认使用全局文本样式，详见": "其余属性默认使用全局文本样式，详见",
  "仪表盘指针。": "仪表盘指针。",
  "是否显示指针": "是否显示指针",
  "。": "。",
  "指针长度，可以是绝对数值，也可以是相对于半径的百分比": "指针长度，可以是绝对数值，也可以是相对于半径的百分比",
  "指针宽度": "指针宽度",
  "仪表盘指针样式": "仪表盘指针样式",
  "仪表盘详情，用于显示数据": "仪表盘详情，用于显示数据",
  "默认全局居中": "默认全局居中",
  "，单位": "，单位",
  "速度": "速度",
  "转速": "转速",
  "油表": "油表",
  "水表": "水表",
  "在线离线": "在线离线",
  "电量趋势": "电量趋势",
  "→": "→",
  "从网页或其他应用软件复制表格数据，粘贴到这里": "从网页或其他应用软件复制表格数据，粘贴到这里",
  "。默认第一行是表头，使用回车键添加新行，使用": "。默认第一行是表头，使用回车键添加新行，使用",
  "键区分列。": "键区分列。",
  "处理粘贴操作": "处理粘贴操作",
  "检查除第一行的每一行列数是否与第一行相同": "检查除第一行的每一行列数是否与第一行相同",
  "标记不符合格式的一行": "标记不符合格式的一行",
  "需要放在菜单上面的内容，如": "需要放在菜单上面的内容，如",
  "，写在": "，写在",
  "标签内部，如下": "标签内部，如下",
  "我的路径": "我的路径",
  "初始化设置面包屑导航和标签导航": "初始化设置面包屑导航和标签导航",
  "设置初始语言": "设置初始语言",
  "如果当前打开页面不在标签栏中，跳到": "如果当前打开页面不在标签栏中，跳到",
  "页": "页",
  "示闲": "示闲",
  "示忙": "示忙",
  "语言": "语言",
  "語言": "語言",
  "中文简体": "中文简体",
  "中文繁体": "中文繁体",
  "重新刷新数据": "重新刷新数据",
  "提交请求": "提交请求",
  "实名认证": "实名认证",
  "实名认证提交成功": "实名认证提交成功",
  "打开帮助中心": "打开帮助中心",
  "点击了个人中心": "点击了个人中心",
  "登录信息": "登录信息",
  "对于": "对于",
  "位，至少包含字母数字其中两种": "位，至少包含字母数字其中两种",
  "新密码与重复新密码不一致": "新密码与重复新密码不一致",
  "用于存储当前上传的文件": "用于存储当前上传的文件",
  "频率不能为空": "频率不能为空",
  "平台中文名不能为空": "平台中文名不能为空",
  "平台英文名不能为空": "平台英文名不能为空",
  "代理商不能为空": "代理商不能为空",
  "个人信息": "个人信息",
  "时区设置不能为空": "时区设置不能为空",
  "美国（中部）": "美国（中部）",
  "美国（山地）": "美国（山地）",
  "美国（太平洋）": "美国（太平洋）",
  "大洋洲": "大洋洲",
  "建议": "建议",
  "反馈": "反馈",
  "购物车": "购物车",
  "退出全屏": "退出全屏",
  "全屏": "全屏",
  "全屏方案": "全屏方案",
  "确保": "确保",
  "是必需的": "是必需的",
  "群呼": "群呼",
  "点呼": "点呼",
  "队列，": "队列，",
  "是否禁用队列开关": "是否禁用队列开关",
  "切换点呼和群呼": "切换点呼和群呼",
  "是否是客服": "是否是客服",
  "不需要国家编码": "不需要国家编码",
  "事件类型是“分机状态”": "事件类型是“分机状态”",
  "是分机的当前状态，可以在每个状态内做一些控制操作。": "是分机的当前状态，可以在每个状态内做一些控制操作。",
  "下线、示闲按钮可用，其余不可用": "下线、示闲按钮可用，其余不可用",
  "上线按钮可用，其余不可用": "上线按钮可用，其余不可用",
  "示闲中": "示闲中",
  "示忙、拨号、下线按钮可用，其余不可用": "示忙、拨号、下线按钮可用，其余不可用",
  "示忙中": "示忙中",
  "示闲、下线按钮可用，其余不可用": "示闲、下线按钮可用，其余不可用",
  "通话结束整理中": "通话结束整理中",
  "此处一般情况会自动调用一次示闲操作。如果不调用，那么每通电话结束后都会是这个状态，话务员需要手工示闲才能打、接电话": "此处一般情况会自动调用一次示闲操作。如果不调用，那么每通电话结束后都会是这个状态，话务员需要手工示闲才能打、接电话",
  "通话中。不论呼入呼出，都是这个状态，在内部根据其它字段进行详细划分": "通话中。不论呼入呼出，都是这个状态，在内部根据其它字段进行详细划分",
  "呼入振铃，此处可": "呼入振铃，此处可",
  "一个页面作为来电弹屏": "一个页面作为来电弹屏",
  "呼出振铃，此处可": "呼出振铃，此处可",
  "一个页面作为电去弹屏": "一个页面作为电去弹屏",
  "话务台已接听，无论是呼入接听还是呼出接听都是这个状态": "话务台已接听，无论是呼入接听还是呼出接听都是这个状态",
  "判断当前角色": "判断当前角色",
  "是客服": "是客服",
  "还是销售": "还是销售",
  "根据手机号获取客户数据": "根据手机号获取客户数据",
  "无此客户": "无此客户",
  "自己客户": "自己客户",
  "别人的客户": "别人的客户",
  "电话被挂断": "电话被挂断",
  "电话挂断后自动示闲": "电话挂断后自动示闲",
  "弹出": "弹出",
  "删除之前打开的模态框": "删除之前打开的模态框",
  "更新客户信息": "更新客户信息",
  "新增客户信息": "新增客户信息",
  "保存成功": "保存成功",
  "设置需要刷新的列表": "设置需要刷新的列表",
  "保存失败：请完善客户信息，或记录信息于私有客户列表中重新添加": "保存失败：请完善客户信息，或记录信息于私有客户列表中重新添加",
  "客户姓名必填": "客户姓名必填",
  "客户情况校验": "客户情况校验",
  "客户情况至少十个字": "客户情况至少十个字",
  "跟进记录为必填内容": "跟进记录为必填内容",
  "跟进记录至少": "跟进记录至少",
  "个字": "个字",
  "跟进类型不能为空": "跟进类型不能为空",
  "下次跟进时间为必填内容": "下次跟进时间为必填内容",
  "当回收客户时，跟进类型为必填内容": "当回收客户时，跟进类型为必填内容",
  "当回收客户时，跟进记录为必填内容": "当回收客户时，跟进记录为必填内容",
  "添加请求参数，保存到": "添加请求参数，保存到",
  "接口": "接口",
  "跟进内容": "跟进内容",
  "资质标签": "资质标签",
  "添加客户或是更新客户信息": "添加客户或是更新客户信息",
  "如果传过来的是": "如果传过来的是",
  "保存资质标签": "保存资质标签",
  "添加跟进": "添加跟进",
  "编辑客户信息时": "编辑客户信息时",
  "保存成功！": "保存成功！",
  "回收客户": "回收客户",
  "判断": "判断",
  "是否为空": "是否为空",
  "客户回访弹屏": "客户回访弹屏",
  "客户回访": "客户回访",
  "添加回访成功": "添加回访成功",
  "请填写回访记录": "请填写回访记录",
  "关闭所有": "关闭所有",
  "关闭其他": "关闭其他",
  "关闭除当前页和": "关闭除当前页和",
  "页的其他页": "页的其他页",
  "标签在可视区域左侧": "标签在可视区域左侧",
  "标签在可视区域": "标签在可视区域",
  "标签在可视区域右侧": "标签在可视区域右侧",
  "绑定的值的类型": "绑定的值的类型",
  "设置": "设置",
  "事件触发时间间隔": "事件触发时间间隔",
  "是否开启本地存储": "是否开启本地存储",
  "这个方法一定要在所有配置项之后调用": "这个方法一定要在所有配置项之后调用",
  "如果本地有存储加载本地存储内容": "如果本地有存储加载本地存储内容",
  "拖拽指令": "拖拽指令",
  "这里传入作为拖拽触发器的": "这里传入作为拖拽触发器的",
  "选择器": "选择器",
  "这里传入需要移动容器的": "这里传入需要移动容器的",
  "拖动结束之后是否恢复到原来的位置": "拖动结束之后是否恢复到原来的位置",
  "在输入框中使用": "在输入框中使用",
  "绑定的值": "绑定的值",
  "复制成功后的回调": "复制成功后的回调",
  "复制失败后的回调": "复制失败后的回调",
  "审核通过": "审核通过",
  "审核不通过": "审核不通过",
  "机构编码不能为空": "机构编码不能为空",
  "检查图片的": "检查图片的",
  "上传之前检查": "上传之前检查",
  "删除文件": "删除文件",
  "结果": "结果",
  "删除上传的对象": "删除上传的对象",
  "文件格式错误": "文件格式错误",
  "类型文件": "类型文件",
  "文件过大": "文件过大",
  "文件大小不能超过": "文件大小不能超过",
  "所属机构": "所属机构",
  "请选择所属机构": "请选择所属机构",
  "机构密码": "机构密码",
  "请输入机构密码": "请输入机构密码",
  "机构密码不能为空": "机构密码不能为空",
  "时间": "时间",
  "请选择时间": "请选择时间",
  "类型": "类型",
  "请选择类型": "请选择类型",
  "公开课": "公开课",
  "专家": "专家",
  "所属机构不能为空": "所属机构不能为空",
  "公开课名称": "公开课名称",
  "当前选择的应用": "当前选择的应用",
  "共用的查询与重置": "共用的查询与重置",
  "共用的右侧添加按钮": "共用的右侧添加按钮",
  "是否企业认证": "是否企业认证",
  "编号": "编号",
  "用户姓名": "用户姓名",
  "性别": "性别",
  "用户电话": "用户电话",
  "预约类型": "预约类型",
  "专题": "专题",
  "意向咨询师": "意向咨询师",
  "意向咨询时间": "意向咨询时间",
  "预约时间": "预约时间",
  "预约状态": "预约状态",
  "预约成功": "预约成功",
  "待确认": "待确认",
  "拒绝": "拒绝",
  "取消预约": "取消预约",
  "审核": "审核",
  "新增": "新增",
  "机构介绍": "机构介绍",
  "机构名称": "机构名称",
  "机构主页": "机构主页",
  "机构负责人": "机构负责人",
  "联系电话": "联系电话",
  "机构地址": "机构地址",
  "请输入机构名称": "请输入机构名称",
  "请输入机构负责人": "请输入机构负责人",
  "请输入联系电话": "请输入联系电话",
  "请输入机构地址": "请输入机构地址",
  "机构": "机构",
  "查看图片": "查看图片",
  "机构名称不能为空": "机构名称不能为空",
  "图片不能为空": "图片不能为空",
  "机构负责人不能为空": "机构负责人不能为空",
  "联系电话不能为空": "联系电话不能为空",
  "机构地址不能为空": "机构地址不能为空",
  "机构简介不能为空": "机构简介不能为空",
  "姓名": "姓名",
  "请输入姓名": "请输入姓名",
  "咨询师头像": "咨询师头像",
  "电话": "电话",
  "请输入电话": "请输入电话",
  "身份证号": "身份证号",
  "请输入身份证号": "请输入身份证号",
  "职位": "职位",
  "请输入职位": "请输入职位",
  "专业": "专业",
  "请输入专业": "请输入专业",
  "擅长": "擅长",
  "请输入擅长": "请输入擅长",
  "简介": "简介",
  "请输入简介": "请输入简介",
  "姓名不能为空": "姓名不能为空",
  "电话号码不能为空": "电话号码不能为空",
  "电话号码格式不合法": "电话号码格式不合法",
  "身份证号码不能为空": "身份证号码不能为空",
  "身份证输入不合法": "身份证输入不合法",
  "职位不能为空": "职位不能为空",
  "专业不能为空": "专业不能为空",
  "擅长不能为空": "擅长不能为空",
  "咨询师头像不能为空": "咨询师头像不能为空",
  "简介不能为空": "简介不能为空",
  "请输入公开课名称": "请输入公开课名称",
  "请选择专题": "请选择专题",
  "讲师": "讲师",
  "请选择讲师": "请选择讲师",
  "请选择开始和结束时间": "请选择开始和结束时间",
  "最大人数": "最大人数",
  "请输入最大人数": "请输入最大人数",
  "标签": "标签",
  "团体咨询": "团体咨询",
  "课程描述": "课程描述",
  "公开课名称不能为空": "公开课名称不能为空",
  "专题不能为空": "专题不能为空",
  "咨询师不能为空": "咨询师不能为空",
  "时间不能为空": "时间不能为空",
  "最大人数不能为空": "最大人数不能为空",
  "课程描述不能为空": "课程描述不能为空",
  "标签不能为空": "标签不能为空",
  "修改机构": "修改机构",
  "或": "或",
  "机构不能为空": "机构不能为空",
  "导入文件不能为空": "导入文件不能为空",
  "查看报名人数": "查看报名人数",
  "所属专题": "所属专题",
  "开课时间": "开课时间",
  "过滤预约记录": "过滤预约记录",
  "您确定要": "您确定要",
  "所属分类": "所属分类",
  "请选择所属分类": "请选择所属分类",
  "题目": "题目",
  "下载模板": "下载模板",
  "测评专题": "测评专题",
  "预约专题": "预约专题",
  "所属分类不能为空": "所属分类不能为空",
  "题目文件不能为空": "题目文件不能为空",
  "测评分类": "测评分类",
  "题目名称": "题目名称",
  "对应机构密码": "对应机构密码",
  "查看对应机构密码": "查看对应机构密码",
  "添加数组": "添加数组",
  "专题名称": "专题名称",
  "专题类型": "专题类型",
  "请输入专题名称": "请输入专题名称",
  "请选择专题类型": "请选择专题类型",
  "专题名称不能为空": "专题名称不能为空",
  "接口名称": "接口名称",
  "请输入接口名称": "请输入接口名称",
  "所属模块": "所属模块",
  "请选择模块": "请选择模块",
  "模块": "模块",
  "接口说明": "接口说明",
  "请输入接口说明": "请输入接口说明",
  "请选择所属模块": "请选择所属模块",
  "接口名称筛选": "接口名称筛选",
  "全部模块": "全部模块",
  "全部状态": "全部状态",
  "请输入模块名": "请输入模块名",
  "请输入模块代码": "请输入模块代码",
  "初始化数据": "初始化数据",
  "重置搜索框": "重置搜索框",
  "翻页": "翻页",
  "控制模态框显示隐藏": "控制模态框显示隐藏",
  "显示隐藏": "显示隐藏",
  "本条数据": "本条数据",
  "新增接口": "新增接口",
  "添加成功！": "添加成功！",
  "编辑接口": "编辑接口",
  "修改成功！": "修改成功！",
  "删除接口": "删除接口",
  "确认删除接口": "确认删除接口",
  "删除成功！": "删除成功！",
  "模块代码": "模块代码",
  "加载": "加载",
  "新增模块": "新增模块",
  "修改模块": "修改模块",
  "删除模块": "删除模块",
  "确认删除模块": "确认删除模块",
  "请输入模块": "请输入模块",
  "模块名称": "模块名称",
  "请输入模块名称": "请输入模块名称",
  "描述": "描述",
  "请输入描述！": "请输入描述！",
  "表单字段": "表单字段",
  "防止表单未注册": "防止表单未注册",
  "当": "当",
  "发生改变时，为表单设置值": "发生改变时，为表单设置值",
  "角色": "角色",
  "是否默认": "是否默认",
  "判断当前行是否可以点击": "判断当前行是否可以点击",
  "控制是否禁用": "控制是否禁用",
  "只有在可编辑的情况下才进行状态变化": "只有在可编辑的情况下才进行状态变化",
  "直接允许状态变化": "直接允许状态变化",
  "开": "开",
  "关": "关",
  "权限配置": "权限配置",
  "获取选中项目获取选中及半选节点": "获取选中项目获取选中及半选节点",
  "数组中是否存在": "数组中是否存在",
  "当没有会选时，将": "当没有会选时，将",
  "强行加入": "强行加入",
  "先取编辑时所先的值": "先取编辑时所先的值",
  "如果没有": "如果没有",
  "再从原信息里面取": "再从原信息里面取",
  "组成的数组": "组成的数组",
  "我的角色管理数据": "我的角色管理数据",
  "新增角色": "新增角色",
  "编辑角色": "编辑角色",
  "编辑提交": "编辑提交",
  "请检查必填项": "请检查必填项",
  "确认删除角色": "确认删除角色",
  "获取相应权限": "获取相应权限",
  "接口配置": "接口配置",
  "当前": "当前",
  "当前所选的列": "当前所选的列",
  "所属于的接口": "所属于的接口",
  "选中的项": "选中的项",
  "当前选中的接口列表": "当前选中的接口列表",
  "初始化接口配置": "初始化接口配置",
  "接口取消": "接口取消",
  "接口保存": "接口保存",
  "当前所选": "当前所选",
  "配置接口": "配置接口",
  "选择配置接口": "选择配置接口",
  "设置当前的": "设置当前的",
  "清空选择项": "清空选择项",
  "选中菜单权限的": "选中菜单权限的",
  "角色说明": "角色说明",
  "请输入角色说明": "请输入角色说明",
  "新增子菜单": "新增子菜单",
  "新增页面": "新增页面",
  "请查看父级模块": "请查看父级模块",
  "模块名必填": "模块名必填",
  "模块说明必填": "模块说明必填",
  "首先判断一下，是页面": "首先判断一下，是页面",
  "还是子菜单": "还是子菜单",
  "子菜单": "子菜单",
  "页面": "页面",
  "判断是否是顶级菜单": "判断是否是顶级菜单",
  "编辑菜单": "编辑菜单",
  "编辑成功！": "编辑成功！",
  "删除菜单": "删除菜单",
  "确定是否删除该菜单？": "确定是否删除该菜单？",
  "添加子页面": "添加子页面",
  "编辑页面": "编辑页面",
  "修改页面": "修改页面",
  "删除页面": "删除页面",
  "确定是否删除该页面？": "确定是否删除该页面？",
  "修改接口配置": "修改接口配置",
  "上级菜单": "上级菜单",
  "页面名称": "页面名称",
  "请输入页面名称": "请输入页面名称",
  "路径": "路径",
  "请输入路径": "请输入路径",
  "排序": "排序",
  "请输入排序": "请输入排序",
  "页面说明": "页面说明",
  "请输入页面说明": "请输入页面说明",
  "请选择接口配置": "请选择接口配置",
  "菜单名称": "菜单名称",
  "请输入菜单名称": "请输入菜单名称",
  "菜单说明": "菜单说明",
  "请输入菜单说明": "请输入菜单说明",
  "设备属性配置": "设备属性配置",
  "用户名称筛选": "用户名称筛选",
  "采购单价": "采购单价",
  "税率": "税率",
  "以下，": "以下，",
  "表示": "表示",
  "手机号": "手机号",
  "用户名称": "用户名称",
  "企业名称": "企业名称",
  "创建日期": "创建日期",
  "详情": "详情",
  "详细信息": "详细信息",
  "您真的想": "您真的想",
  "这个帐号吗？": "这个帐号吗？",
  "帐号信息": "帐号信息",
  "您真的想删除这个": "您真的想删除这个",
  "帐号": "帐号",
  "请输入帐号": "请输入帐号",
  "验证码": "验证码",
  "密码": "密码",
  "请选择角色": "请选择角色",
  "请输入企业名称": "请输入企业名称",
  "获取验证码": "获取验证码",
  "验证码不能为空": "验证码不能为空",
  "重新获取验证码": "重新获取验证码",
  "验证码发送成功": "验证码发送成功",
  "累计预约排名": "累计预约排名",
  "身份证": "身份证",
  "获取机构列表": "获取机构列表",
  "预约用户": "预约用户",
  "人": "人",
  "咨询用户": "咨询用户",
  "人次": "人次",
  "数据详情": "数据详情",
  "周": "周",
  "预约用户（人次）": "预约用户（人次）",
  "测评用户（人次）": "测评用户（人次）",
  "专题预约占比": "专题预约占比",
  "专题预约次数": "专题预约次数",
  "次": "次",
  "评测分类名称": "评测分类名称",
  "请输入评测分类名称": "请输入评测分类名称",
  "评测分类名称为空": "评测分类名称为空",
  "名称": "名称",
  "机构密码吗？": "机构密码吗？",
  "心灵密码": "心灵密码",
  "下载导入模板": "下载导入模板",
  "测评时间": "测评时间",
  "综合评分": "综合评分",
  "综合建议": "综合建议",
  "评测详细": "评测详细",
  "得分": "得分",
  "测评得分": "测评得分",
  "用户": "用户",
  "产品激活占比": "产品激活占比",
  "产品故障占比": "产品故障占比",
  "产品活跃占比": "产品活跃占比",
  "累计设备激活排名": "累计设备激活排名",
  "产品激活数量": "产品激活数量",
  "产品活跃数量": "产品活跃数量",
  "付费产品数量": "付费产品数量",
  "国家": "国家",
  "设备激活": "设备激活",
  "个": "个",
  "商品销售额": "商品销售额",
  "元": "元",
  "总览": "总览",
  "服务": "服务",
  "当前年月日": "当前年月日",
  "产品激活": "产品激活",
  "注册用户": "注册用户",
  "销售总额趋势图": "销售总额趋势图",
  "用户活跃": "用户活跃",
  "设备活跃": "设备活跃",
  "新增商品订单趋势": "新增商品订单趋势",
  "今天": "今天",
  "活跃比例": "活跃比例",
  "故障比例": "故障比例",
  "用户注册占比": "用户注册占比",
  "销售量占比": "销售量占比",
  "销售额占比": "销售额占比",
  "在线的设备数": "在线的设备数",
  "增长": "增长",
  "趋势钱": "趋势钱",
  "数据统计": "数据统计",
  "获取当前时间数据": "获取当前时间数据",
  "判断是否全屏情况": "判断是否全屏情况",
  "移除事件监听": "移除事件监听",
  "设备统计": "设备统计",
  "报警统计": "报警统计",
  "报警总数": "报警总数",
  "近一年新增设备数": "近一年新增设备数",
  "客户负责人": "客户负责人",
  "维保人员": "维保人员",
  "警情记录": "警情记录",
  "项目": "项目",
  "发生【": "发生【",
  "】报警": "】报警",
  "项目列表": "项目列表",
  "项目名称搜索": "项目名称搜索",
  "设备数据详情": "设备数据详情",
  "项目名称：": "项目名称：",
  "坐标": "坐标",
  "在线设备": "在线设备",
  "离线设备": "离线设备",
  "故障设备": "故障设备",
  "告警总数": "告警总数",
  "项目名称": "项目名称",
  "设备数量": "设备数量",
  "获取报警统计": "获取报警统计",
  "近一年的新增设备统计": "近一年的新增设备统计",
  "获取未处理的告警": "获取未处理的告警",
  "您还有": "您还有",
  "条报警信息未处理，请及时处理": "条报警信息未处理，请及时处理",
  "获取告警记录": "获取告警记录",
  "获取项目及设备统计": "获取项目及设备统计",
  "点击行数时": "点击行数时",
  "未在地图上标注": "未在地图上标注",
  "未处理的告警": "未处理的告警",
  "设备名称：": "设备名称：",
  "设备序号：": "设备序号：",
  "报警类型：": "报警类型：",
  "报警时间：": "报警时间：",
  "所属项目：": "所属项目：",
  "防治分类：": "防治分类：",
  "位置：": "位置：",
  "处理状态：": "处理状态：",
  "处理详述：": "处理详述：",
  "查看维保信息": "查看维保信息",
  "处理状态不能为空": "处理状态不能为空",
  "暂无维保信息": "暂无维保信息",
  "处理描述：": "处理描述：",
  "提交": "提交",
  "报警记录": "报警记录",
  "报警内容": "报警内容",
  "信息统计": "信息统计",
  "警情监控": "警情监控",
  "设备激活占比": "设备激活占比",
  "商品销售总额": "商品销售总额",
  "注册用户数": "注册用户数",
  "对比列表": "对比列表",
  "当前设备在线数": "当前设备在线数",
  "新增端口订单趋势": "新增端口订单趋势",
  "地图数据": "地图数据",
  "数据": "数据",
  "底部左": "底部左",
  "底部右": "底部右",
  "下拉国别": "下拉国别",
  "返回控制台": "返回控制台",
  "代理商数量": "代理商数量",
  "用户总数": "用户总数",
  "平台接入设备总数": "平台接入设备总数",
  "点击我": "点击我",
  "商户名称：": "商户名称：",
  "商户负责人：": "商户负责人：",
  "商户联系电话：": "商户联系电话：",
  "控制器数量：": "控制器数量：",
  "探测器数量：": "探测器数量：",
  "巡检时间：最近": "巡检时间：最近",
  "查看照片": "查看照片",
  "设备告警": "设备告警",
  "甲烷": "甲烷",
  "氢气": "氢气",
  "可燃气": "可燃气",
  "硫化氢": "硫化氢",
  "氧气": "氧气",
  "传感器列表": "传感器列表",
  "排行数值列表": "排行数值列表",
  "设备在线数量": "设备在线数量",
  "设备离线数量": "设备离线数量",
  "在线率": "在线率",
  "商户": "商户",
  "管理员": "管理员",
  "普通用户": "普通用户",
  "平台维护": "平台维护",
  "超级管理员": "超级管理员",
  "获取商户列表": "获取商户列表",
  "获取逆解析方法实例": "获取逆解析方法实例",
  "获取自动定位方法": "获取自动定位方法",
  "地图点击事件": "地图点击事件",
  "获取时": "获取时",
  "获取分": "获取分",
  "获取秒": "获取秒",
  "时": "时",
  "分": "分",
  "中部设备地图": "中部设备地图",
  "右边顶部角色统计": "右边顶部角色统计",
  "用户活跃统计": "用户活跃统计",
  "左侧顶部在线率": "左侧顶部在线率",
  "日告警数量分析": "日告警数量分析",
  "告警排行": "告警排行",
  "告警排行分析": "告警排行分析",
  "，": "，",
  "红色；": "红色；",
  "黄色；": "黄色；",
  "其它，绿色": "其它，绿色",
  "设置播放状态": "设置播放状态",
  "如果你还需要水平居中，可以加上这个属性": "如果你还需要水平居中，可以加上这个属性",
  "的高度": "的高度",
  "为了清楚地展示": "为了清楚地展示",
  "的边界": "的边界",
  "的设备屏幕": "的设备屏幕",
  "商品销售额占比": "商品销售额占比",
  "商品订阅占比": "商品订阅占比",
  "商品销售量占比": "商品销售量占比",
  "累计销售排名": "累计销售排名",
  "销售总额": "销售总额",
  "销售总量": "销售总量",
  "新增订阅": "新增订阅",
  "订阅比例": "订阅比例",
  "产品注册占比": "产品注册占比",
  "用户付费占比": "用户付费占比",
  "累计用户注册排名": "累计用户注册排名",
  "注册总数": "注册总数",
  "活跃总数": "活跃总数",
  "付费总数": "付费总数",
  "付费占比": "付费占比",
  "付费比例": "付费比例",
  "注册用户总数": "注册用户总数",
  "活跃用户总数": "活跃用户总数",
  "付费用户总数": "付费用户总数",
  "周一": "周一",
  "周二": "周二",
  "周三": "周三",
  "周四": "周四",
  "周五": "周五",
  "周六": "周六",
  "周日": "周日",
  "运营商": "运营商",
  "网络服务": "网络服务",
  "总量": "总量",
  "银行": "银行",
  "证券": "证券",
  "游戏": "游戏",
  "视频": "视频",
  "餐饮": "餐饮",
  "外卖": "外卖",
  "快递": "快递",
  "电商": "电商",
  "左边": "左边",
  "充放电趋势": "充放电趋势",
  "中间": "中间",
  "右边": "右边",
  "总容量": "总容量",
  "值": "值",
  "右侧告警": "右侧告警",
  "大屏左下方近": "大屏左下方近",
  "日激活": "日激活",
  "仅顶级账号可见": "仅顶级账号可见",
  "大屏左上角在线数据": "大屏左上角在线数据",
  "获取顶部数据": "获取顶部数据",
  "找到时打印": "找到时打印",
  "添加标记到地图": "添加标记到地图",
  "创建自定义样式的": "创建自定义样式的",
  "位置": "位置",
  "创建": "创建",
  "使用自定义样式的内容": "使用自定义样式的内容",
  "添加点击事件": "添加点击事件",
  "我的": "我的",
  "我的大屏数据": "我的大屏数据",
  "我的列表数据": "我的列表数据",
  "顶部数据": "顶部数据",
  "获取大屏左下方近": "获取大屏左下方近",
  "头部": "头部",
  "收缩": "收缩",
  "全屏时": "全屏时",
  "激活状态筛选": "激活状态筛选",
  "所属经销商": "所属经销商",
  "：": "：",
  "总电压：": "总电压：",
  "总电流：": "总电流：",
  "请选择日期": "请选择日期",
  "至": "至",
  "起点：": "起点：",
  "终点：": "终点：",
  "用时": "用时",
  "里程": "里程",
  "耗电": "耗电",
  "起点": "起点",
  "四川省成都市武侯区环球中心": "四川省成都市武侯区环球中心",
  "终点": "终点",
  "四川省成都市龙泉驿区龙泉山": "四川省成都市龙泉驿区龙泉山",
  "公里": "公里",
  "暂停": "暂停",
  "继续": "继续",
  "重放": "重放",
  "拉取行程": "拉取行程",
  "拉取点": "拉取点",
  "拉取其他点": "拉取其他点",
  "拉取轨迹": "拉取轨迹",
  "拉取其他店": "拉取其他店",
  "这里获取了检索的位置并跳转": "这里获取了检索的位置并跳转",
  "创建一个新的图标，可以是任意的图片": "创建一个新的图标，可以是任意的图片",
  "将新的图标应用到标记上": "将新的图标应用到标记上",
  "画轨迹": "画轨迹",
  "先注释掉地图": "先注释掉地图",
  "微软雅黑": "微软雅黑",
  "修改垂直滚动条": "修改垂直滚动条",
  "修改宽度": "修改宽度",
  "修改滚动条轨道背景色": "修改滚动条轨道背景色",
  "修改滚动条滑块颜色": "修改滚动条滑块颜色",
  "修改滚动条滑块悬停时的颜色": "修改滚动条滑块悬停时的颜色",
  "修改滚动条滑块移动时的颜色": "修改滚动条滑块移动时的颜色",
  "修改滚动条滑块的圆角": "修改滚动条滑块的圆角",
  "重点参数：": "重点参数：",
  "轨迹回放控制": "轨迹回放控制",
  "开始动画": "开始动画",
  "暂停动画": "暂停动画",
  "继续动画": "继续动画",
  "停止动画": "停止动画",
  "地图实例": "地图实例",
  "巡航器实例": "巡航器实例",
  "当前播放轨迹下标": "当前播放轨迹下标",
  "轨迹实例": "轨迹实例",
  "是否播放": "是否播放",
  "是否完成": "是否完成",
  "播放器总数": "播放器总数",
  "播放器当前数": "播放器当前数",
  "下次播放轨迹从当前值开始": "下次播放轨迹从当前值开始",
  "每段路的起止坐标": "每段路的起止坐标",
  "轨迹坐标": "轨迹坐标",
  "当前播放速度下标": "当前播放速度下标",
  "速度列表，可自定义配置": "速度列表，可自定义配置",
  "进度": "进度",
  "加载地图": "加载地图",
  "级别": "级别",
  "中心点坐标": "中心点坐标",
  "默认在杭州": "默认在杭州",
  "创建一个": "创建一个",
  "图标尺寸": "图标尺寸",
  "图标的取图地址": "图标的取图地址",
  "图标所用图片大小": "图标所用图片大小",
  "图标取图偏移量": "图标取图偏移量",
  "将": "将",
  "传入": "传入",
  "的路径参数为模块名中": "的路径参数为模块名中",
  "之后的部分": "之后的部分",
  "当前环境不支持": "当前环境不支持",
  "！": "！",
  "启动页面": "启动页面",
  "图片加载成功，重新绘制一次": "图片加载成功，重新绘制一次",
  "图片加载失败！": "图片加载失败！",
  "轨迹线的样式": "轨迹线的样式",
  "巡航器初始化": "巡航器初始化",
  "创建一个巡航器": "创建一个巡航器",
  "判断是否传入": "判断是否传入",
  "关联第": "关联第",
  "条轨迹": "条轨迹",
  "循环播放": "循环播放",
  "清空走过的路线": "清空走过的路线",
  "开始播放": "开始播放",
  "路段未开始并且没有结束的时候": "路段未开始并且没有结束的时候",
  "暂停恢复动画": "暂停恢复动画",
  "并且动画没有完成的时候": "并且动画没有完成的时候",
  "判断是否传入初始坐标": "判断是否传入初始坐标",
  "巡航完成事触发": "巡航完成事触发",
  "暂停播放": "暂停播放",
  "停止": "停止",
  "停止播放": "停止播放",
  "为重新播放准备": "为重新播放准备",
  "查询当前位置": "查询当前位置",
  "创建地图": "创建地图",
  "初始化地图中心点": "初始化地图中心点",
  "修改": "修改",
  "相对于": "相对于",
  "的位置": "的位置",
  "设备当前位置": "设备当前位置",
  "设置文本标注偏移量": "设置文本标注偏移量",
  "时间：": "时间：",
  "详细地址：": "详细地址：",
  "经度：": "经度：",
  "纬度：": "纬度：",
  "设置文本标注内容": "设置文本标注内容",
  "正在播放禁止拖拽播放器": "正在播放禁止拖拽播放器",
  "新的样式": "新的样式",
  "默认使用": "默认使用",
  "模式，如果希望使用带有俯仰角的": "模式，如果希望使用带有俯仰角的",
  "模式，请设置": "模式，请设置",
  "初始化地图层级": "初始化地图层级",
  "打开高德地图": "打开高德地图",
  "所属的地图实例": "所属的地图实例",
  "将点、线相关的": "将点、线相关的",
  "全部置": "全部置",
  "中间点": "中间点",
  "使用图片": "使用图片",
  "经过路径的样式": "经过路径的样式",
  "轨迹回放": "轨迹回放",
  "选中拉": "选中拉",
  "创建标注": "创建标注",
  "将标注添加到地图中": "将标注添加到地图中",
  "指定定位位置。": "指定定位位置。",
  "当标注显示在地图上时，其所指向的地理位置距离图标左上": "当标注显示在地图上时，其所指向的地理位置距离图标左上",
  "角各偏移": "角各偏移",
  "像素和": "像素和",
  "像素。您可以看到在本例中该位置即是": "像素。您可以看到在本例中该位置即是",
  "图标中央下端的尖角位置。": "图标中央下端的尖角位置。",
  "设置图片偏移。": "设置图片偏移。",
  "当您需要从一幅较大的图片中截取某部分作为标注图标时，您": "当您需要从一幅较大的图片中截取某部分作为标注图标时，您",
  "需要指定大图的偏移位置，此做法与": "需要指定大图的偏移位置，此做法与",
  "技术类似。": "技术类似。",
  "设置图片偏移": "设置图片偏移",
  "创建标注对象并添加到地图": "创建标注对象并添加到地图",
  "导出日志记录": "导出日志记录",
  "注：这里只会显示成功保存到服务端的错误日志，而且页面错误日志不会在浏览器持久化存储，刷新页面即会丢失": "注：这里只会显示成功保存到服务端的错误日志，而且页面错误日志不会在浏览器持久化存储，刷新页面即会丢失",
  "信息": "信息",
  "错误日志": "错误日志",
  "请输入现在使用的密码": "请输入现在使用的密码",
  "请输入新密码，至少": "请输入新密码，至少",
  "位字符": "位字符",
  "确认新密码": "确认新密码",
  "请再次输入新密码": "请再次输入新密码",
  "两次输入密码不一致": "两次输入密码不一致",
  "请输入原密码": "请输入原密码",
  "请至少输入": "请至少输入",
  "个字符": "个字符",
  "最多输入": "最多输入",
  "保存编辑后内容": "保存编辑后内容",
  "密码编辑": "密码编辑",
  "编辑密码": "编辑密码",
  "编辑密码模态框显示": "编辑密码模态框显示",
  "是否认证": "是否认证",
  "账号类型": "账号类型",
  "请输入企业编码": "请输入企业编码",
  "企业编码为": "企业编码为",
  "位大字字母和数字": "位大字字母和数字",
  "位字母和数字": "位字母和数字",
  "请输入企业名称（中文": "请输入企业名称（中文",
  "请输入企业名称（英文": "请输入企业名称（英文",
  "请输入手机号": "请输入手机号",
  "手机号格式不对": "手机号格式不对",
  "街道地址必填": "街道地址必填",
  "邮箱必填": "邮箱必填",
  "不正确的电子邮件格式": "不正确的电子邮件格式",
  "判断当前状态": "判断当前状态",
  "判断企业编码是否填写": "判断企业编码是否填写",
  "判断是否进行实名认证": "判断是否进行实名认证",
  "实名认证中": "实名认证中",
  "未配置接口地址，请设置": "未配置接口地址，请设置",
  "升级账号": "升级账号",
  "编辑账号": "编辑账号",
  "拉取区域": "拉取区域",
  "只级一级国家": "只级一级国家",
  "编辑地址": "编辑地址",
  "原账号必填": "原账号必填",
  "新账号必填": "新账号必填",
  "判断帐号类型": "判断帐号类型",
  "接收部门": "接收部门",
  "请选择部门": "请选择部门",
  "接收人": "接收人",
  "请先选部门": "请先选部门",
  "再选接收人": "再选接收人",
  "反馈内容": "反馈内容",
  "请输入反馈内容": "请输入反馈内容",
  "上传附件": "上传附件",
  "限制": "限制",
  "内的": "内的",
  "格式图片": "格式图片",
  "是否匿名": "是否匿名",
  "否": "否",
  "是": "是",
  "选择的部门": "选择的部门",
  "反馈接受对象": "反馈接受对象",
  "附件，用": "附件，用",
  "隔开，如果有多个的话": "隔开，如果有多个的话",
  "请选择反馈": "请选择反馈",
  "意见接收人": "意见接收人",
  "请填写内容": "请填写内容",
  "回复": "回复",
  "查询部门下得人员": "查询部门下得人员",
  "": "",
  "获取组织树": "获取组织树",
  "已经有帐号": "已经有帐号",
  "审核中": "审核中",
  "审核失败": "审核失败",
  "提交成功，我们正在审核，我们会在": "提交成功，我们正在审核，我们会在",
  "小时内给您回复，请耐心等待": "小时内给您回复，请耐心等待",
  "倒计时": "倒计时",
  "尊敬的": "尊敬的",
  "的公司": "的公司",
  "您好！我们很高兴的通知您，您的企业认证已经成功通过审核！您可以完整的使用我们平台提供的服务。祝您使用愉快！": "您好！我们很高兴的通知您，您的企业认证已经成功通过审核！您可以完整的使用我们平台提供的服务。祝您使用愉快！",
  "公司": "公司",
  "您好！我们非常遗憾的通知您，您的企业认证审核失败了！您可以通过修改以下存在的问题，重新发起审核。": "您好！我们非常遗憾的通知您，您的企业认证审核失败了！您可以通过修改以下存在的问题，重新发起审核。",
  "秒转时分秒，求模很重要，数字的下舍入": "秒转时分秒，求模很重要，数字的下舍入",
  "定时器": "定时器",
  "查看企业账号": "查看企业账号",
  "为未提交企业认证，，": "为未提交企业认证，，",
  "为等待审核，": "为等待审核，",
  "为审核通过，": "为审核通过，",
  "为审核失败": "为审核失败",
  "未提交企业认证": "未提交企业认证",
  "切换到添加界面": "切换到添加界面",
  "切换到结果界面": "切换到结果界面",
  "上一步操作": "上一步操作",
  "下一步操作": "下一步操作",
  "提交数据": "提交数据",
  "重新提交企业认证信息": "重新提交企业认证信息",
  "企业编码": "企业编码",
  "位企业编码": "位企业编码",
  "企业编码不能为空": "企业编码不能为空",
  "文件访问前缀": "文件访问前缀",
  "下载链接": "下载链接",
  "…": "…",
  "跳转到确认认证页面": "跳转到确认认证页面",
  "上一步需要回填的数据": "上一步需要回填的数据",
  "确认认证资料": "确认认证资料",
  "社会信用代码": "社会信用代码",
  "请输入社会信用代码": "请输入社会信用代码",
  "法人姓名": "法人姓名",
  "请输入法人姓名": "请输入法人姓名",
  "所在地区": "所在地区",
  "邮箱": "邮箱",
  "授权认证": "授权认证",
  "下载授权认证": "下载授权认证",
  "营业执照": "营业执照",
  "下载营业执照": "下载营业执照",
  "通知公告条件筛选": "通知公告条件筛选",
  "反馈时间": "反馈时间",
  "反馈类型（是或否匿名）": "反馈类型（是或否匿名）",
  "请填写反馈内容": "请填写反馈内容",
  "反馈类型": "反馈类型",
  "匿名": "匿名",
  "实名": "实名",
  "意见反馈人": "意见反馈人",
  "反馈附件": "反馈附件",
  "回复人": "回复人",
  "回复时间": "回复时间",
  "回复内容": "回复内容",
  "是否将弹层放置于": "是否将弹层放置于",
  "内，在": "内，在",
  "、带有": "、带有",
  "列内使用时，建议添加此属性": "列内使用时，建议添加此属性",
  "反馈人：": "反馈人：",
  "反馈时间：": "反馈时间：",
  "反馈内容：": "反馈内容：",
  "附件：": "附件：",
  "升级企业账号": "升级企业账号",
  "企业信息": "企业信息",
  "请填写您的企业信息": "请填写您的企业信息",
  "下载授权认证模板，签订盖好企业公章后上传至平台审核": "下载授权认证模板，签订盖好企业公章后上传至平台审核",
  "上传文件": "上传文件",
  "已上传一个文件": "已上传一个文件",
  "下一步": "下一步",
  "授权认证模板": "授权认证模板",
  "上一步": "上一步",
  "重新填写企业信息": "重新填写企业信息",
  "审核状态": "审核状态",
  "请输入企业信用代码": "请输入企业信用代码",
  "请上传营业执照": "请上传营业执照",
  "具体地址必填": "具体地址必填",
  "请填写邮箱": "请填写邮箱",
  "请上传文件": "请上传文件",
  "认证中": "认证中",
  "显示倒计时": "显示倒计时",
  "上传图显示": "上传图显示",
  "示例图地址": "示例图地址",
  "提交实名认证": "提交实名认证",
  "实名认证成功": "实名认证成功",
  "更新": "更新",
  "获取示例图": "获取示例图",
  "示例图": "示例图",
  "图片": "图片",
  "重新实名认证": "重新实名认证",
  "回填实名认证信息": "回填实名认证信息",
  "您没有浏览这个页面的权限": "您没有浏览这个页面的权限",
  "返回首页": "返回首页",
  "返回上一页": "返回上一页",
  "您的页面好像飞走了": "您的页面好像飞走了",
  "鬼知道服务器经历了什么": "鬼知道服务器经历了什么",
  "基本信息": "基本信息",
  "客户基本信息": "客户基本信息",
  "客户姓名": "客户姓名",
  "客户电话": "客户电话",
  "上门日期": "上门日期",
  "类别": "类别",
  "客户来源": "客户来源",
  "申请贷款金额": "申请贷款金额",
  "签约日期": "签约日期",
  "合同类型": "合同类型",
  "抵押": "抵押",
  "权证": "权证",
  "信贷": "信贷",
  "垫资": "垫资",
  "合同信息": "合同信息",
  "合同": "合同",
  "签约时间": "签约时间",
  "签约金额": "签约金额",
  "合同状态": "合同状态",
  "报审信息": "报审信息",
  "签约数据": "签约数据",
  "收款合计": "收款合计",
  "退款合计": "退款合计",
  "实收款合计": "实收款合计",
  "客服回访": "客服回访",
  "客户回访内容": "客户回访内容",
  "请输入至少": "请输入至少",
  "个字以上": "个字以上",
  "渠道名称": "渠道名称",
  "批款金额": "批款金额",
  "成本": "成本",
  "返点": "返点",
  "渠道成本": "渠道成本",
  "报审人": "报审人",
  "报审时间": "报审时间",
  "放款日期": "放款日期",
  "费用类型": "费用类型",
  "收": "收",
  "退款时间": "退款时间",
  "退款金额": "退款金额",
  "操作类型": "操作类型",
  "客户类型": "客户类型",
  "合同渠道贷款状态": "合同渠道贷款状态",
  "根据枚举值，返回对应的": "根据枚举值，返回对应的",
  "校验必填必": "校验必填必",
  "导出为": "导出为",
  "自定义删除": "自定义删除",
  "图片宽度": "图片宽度",
  "父级距离顶部的高度": "父级距离顶部的高度",
  "内部距离顶部的高度": "内部距离顶部的高度",
  "图片原始宽度高度": "图片原始宽度高度",
  "改变图片的": "改变图片的",
  "加载完成执行": "加载完成执行",
  "打印": "打印",
  "图片的宽度": "图片的宽度",
  "的宽度与高度": "的宽度与高度",
  "时的图片宽度数据": "时的图片宽度数据",
  "监听图片的滚动条滚动，并计算距离顶部的调试": "监听图片的滚动条滚动，并计算距离顶部的调试",
  "父级高度：": "父级高度：",
  "找到元素的屏幕位置": "找到元素的屏幕位置",
  "缩放改变时": "缩放改变时",
  "还原": "还原",
  "放大": "放大",
  "缩小": "缩小",
  "鼠标滑轮滚动": "鼠标滑轮滚动",
  "滑轮向上滚动": "滑轮向上滚动",
  "滑轮向下滚动": "滑轮向下滚动",
  "当前点击位置": "当前点击位置",
  "获取原样的比例": "获取原样的比例",
  "添加位置": "添加位置",
  "通过现在的比例获取原始的": "通过现在的比例获取原始的",
  "轴加上滚动条距离顶部的高度": "轴加上滚动条距离顶部的高度",
  "换算原比例图片": "换算原比例图片",
  "组件基础用法": "组件基础用法",
  "可添加左右文字": "可添加左右文字",
  "自定义样式": "自定义样式",
  "设置数据格式": "设置数据格式",
  "转换单位简化数据": "转换单位简化数据",
  "自定义单位": "自定义单位",
  "原始数据：": "原始数据：",
  "可异步更新数据": "可异步更新数据",
  "综合实例": "综合实例",
  "原始数据": "原始数据",
  "千多": "千多",
  "万多": "万多",
  "十万多": "十万多",
  "十多": "十多",
  "百多": "百多",
  "百万多": "百万多",
  "千万多": "千万多",
  "亿多": "亿多",
  "包装表格和页码": "包装表格和页码",
  "客户池分页信息": "客户池分页信息",
  "表单加载。。。": "表单加载。。。",
  "处理数据": "处理数据",
  "页码改变的回调，返回改变后的页码": "页码改变的回调，返回改变后的页码",
  "设置加载": "设置加载",
  "确认提交": "确认提交",
  "树状表格组件": "树状表格组件",
  "，基于": "，基于",
  "进行开发，修复了一些": "进行开发，修复了一些",
  "，添加了一些新属性": "，添加了一些新属性",
  "支持使用": "支持使用",
  "进行自定义列渲染内容": "进行自定义列渲染内容",
  "文档请看": "文档请看",
  "高级查询面板": "高级查询面板",
  "）实现": "）实现",
  "是否显示面板展开按钮": "是否显示面板展开按钮",
  "默认不显示（": "默认不显示（",
  "面板标题": "面板标题",
  "（默认显示": "（默认显示",
  "“高级查询”）": "“高级查询”）",
  "查询条件内容": "查询条件内容",
  "通过“分发": "通过“分发",
  "”实现": "”实现",
  "参考模版": "参考模版",
  "注：": "注：",
  "上需要添加": "上需要添加",
  "样式，": "样式，",
  "确定事件": "确定事件",
  "面板隐藏": "面板隐藏",
  "取消事件": "取消事件",
  "展开面板（父级组件调用（": "展开面板（父级组件调用（",
  "面板显示切换（需要开启": "面板显示切换（需要开启",
  "，组件内部调用）": "，组件内部调用）",
  "暂时数据": "暂时数据",
  "内置图标": "内置图标",
  "组件支持自定义图标的显示，具体自定义图标字体文件的制作请参考文档。": "组件支持自定义图标的显示，具体自定义图标字体文件的制作请参考文档。",
  "组件同时支持": "组件同时支持",
  "内置图标类型和自定义图标类型，为了区别这两种类型，需要在自定义图标名称前加下划线": "内置图标类型和自定义图标类型，为了区别这两种类型，需要在自定义图标名称前加下划线",
  "添加跟进记录": "添加跟进记录",
  "客户资料": "客户资料",
  "请输入客户姓名": "请输入客户姓名",
  "新增必填）": "新增必填）",
  "需求金额": "需求金额",
  "男": "男",
  "女": "女",
  "客户星级": "客户星级",
  "意向标签": "意向标签",
  "客户情况": "客户情况",
  "请输入客户情况": "请输入客户情况",
  "跟进记录": "跟进记录",
  "跟进类型": "跟进类型",
  "下次跟进记录": "下次跟进记录",
  "请选择下次跟进记录": "请选择下次跟进记录",
  "预约上门时间": "预约上门时间",
  "请选择预约上门时间": "请选择预约上门时间",
  "回收该客户": "回收该客户",
  "请填写备注信息必须大于": "请填写备注信息必须大于",
  "获取客户资质标签失败": "获取客户资质标签失败",
  "请选择下次跟进时间": "请选择下次跟进时间",
  "当前所选时间": "当前所选时间",
  "当前时间": "当前时间",
  "下次跟进时间为": "下次跟进时间为",
  "天以内": "天以内",
  "客户信息": "客户信息",
  "贷款金额": "贷款金额",
  "请输入客户情况至少": "请输入客户情况至少",
  "跟进人": "跟进人",
  "跟进日期": "跟进日期",
  "是否回收用户": "是否回收用户",
  "请填写跟进内容": "请填写跟进内容",
  "跟进内容至少": "跟进内容至少",
  "请选择跟进类型": "请选择跟进类型",
  "客户名称不能为空": "客户名称不能为空",
  "请输入跟进内容": "请输入跟进内容",
  "跟进内容不少于": "跟进内容不少于",
  "请选择预约时间": "请选择预约时间",
  "面谈记录": "面谈记录",
  "显示跟进记录": "显示跟进记录",
  "切记设置": "切记设置",
  "属性时，一定要添加": "属性时，一定要添加",
  "修饰符": "修饰符",
  "待办事项": "待办事项",
  "完成事项": "完成事项",
  "操作记录": "操作记录",
  "修改编辑器内容": "修改编辑器内容",
  "显示可拖动弹窗": "显示可拖动弹窗",
  "这个按钮也是可以拖动的": "这个按钮也是可以拖动的",
  "标题": "标题",
  "拖动这里即可拖动整个弹窗": "拖动这里即可拖动整个弹窗",
  "复制成功": "复制成功",
  "复制失败": "复制失败",
  "这是输入的内容": "这是输入的内容",
  "会自动将你程序中的错误收集起来，你可以将错误日志发给后端保存起来。如果你不需要这个功能，将": "会自动将你程序中的错误收集起来，你可以将错误日志发给后端保存起来。如果你不需要这个功能，将",
  "里的": "里的",
  "属性删掉即可。": "属性删掉即可。",
  "另外在开发环境下，你程序中的错误都会被收集起来，这样可能不利于你排查错误，你可以将": "另外在开发环境下，你程序中的错误都会被收集起来，这样可能不利于你排查错误，你可以将",
  "如果你只是想收集错误日志，不希望登录用户看到错误日志，你可以不提供查看日志的入口，只需将": "如果你只是想收集错误日志，不希望登录用户看到错误日志，你可以不提供查看日志的入口，只需将",
  "点击测试触发程序错误": "点击测试触发程序错误",
  "点击测试触发": "点击测试触发",
  "接口请求错误": "接口请求错误",
  "接口请求是请求": "接口请求是请求",
  "的一个不存在接口，所以服务端会报": "的一个不存在接口，所以服务端会报",
  "错误，错误收集机制会收集这个错误，测试的时候有一定网络延迟，所以点击按钮之后稍等一会才会收集到错误。": "错误，错误收集机制会收集这个错误，测试的时候有一定网络延迟，所以点击按钮之后稍等一会才会收集到错误。",
  "获取下载记录": "获取下载记录",
  "默认开发者帐号": "默认开发者帐号",
  "沛城": "沛城",
  "当前语言": "当前语言",
  "打印切换的语言值": "打印切换的语言值",
  "企业员工提交": "企业员工提交",
  "登录成功": "登录成功",
  "隐私政策": "隐私政策",
  "生效日期：": "生效日期：",
  "更新日期：": "更新日期：",
  "提示条款": "提示条款",
  "您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，（或简称“我们”）制定本《隐私政策》（以下或简称“本政策”）并提醒您：在使用网站的各项服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用服务，将被视为对本政策内容的接受和认可。": "您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，（或简称“我们”）制定本《隐私政策》（以下或简称“本政策”）并提醒您：在使用网站的各项服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用服务，将被视为对本政策内容的接受和认可。",
  "如对本政策内容有任何疑问、意见或建议，您可通过的客服电话（": "如对本政策内容有任何疑问、意见或建议，您可通过的客服电话（",
  "）与我们联系。": "）与我们联系。",
  "定义": "定义",
  "网站：指控制台（域名为：": "网站：指控制台（域名为：",
  "）以及物联客户端（如": "）以及物联客户端（如",
  "）。": "）。",
  "：除非另有约定，指三棵（深圳）物联科技有限公司。": "：除非另有约定，指三棵（深圳）物联科技有限公司。",
  "用户信息：用户信息是指您注册网站账户，使用的服务以及为了向您提供服务，您提交的或者收集的用户会员类信息，如姓名、联系方式等，具体详见隐私权政策第三条所述的信息。": "用户信息：用户信息是指您注册网站账户，使用的服务以及为了向您提供服务，您提交的或者收集的用户会员类信息，如姓名、联系方式等，具体详见隐私权政策第三条所述的信息。",
  "业务数据：不同于用户信息，是指的用户利用的服务上传、下载、分发等通过的技术服务处理的数据。": "业务数据：不同于用户信息，是指的用户利用的服务上传、下载、分发等通过的技术服务处理的数据。",
  "范围": "范围",
  "三棵（深圳）物联科技有限公司附属公司和子公司（以下合称为“我们”或“”）认为您的个人隐私非常重要，也高度重视您的隐私权。本政策说明了我们如何收集、接收、使用、存储、共享、转移和处理您的信息，以及在下列情况下决定我们如何处理收集或持有的与您有关的信息的权利：您访问或使用（": "三棵（深圳）物联科技有限公司附属公司和子公司（以下合称为“我们”或“”）认为您的个人隐私非常重要，也高度重视您的隐私权。本政策说明了我们如何收集、接收、使用、存储、共享、转移和处理您的信息，以及在下列情况下决定我们如何处理收集或持有的与您有关的信息的权利：您访问或使用（",
  "）我们的网站和网络资源，包括": "）我们的网站和网络资源，包括",
  "和我们的职业门户网站（统称为“网站”）；（": "和我们的职业门户网站（统称为“网站”）；（",
  "）我们基于云的物联网（": "）我们基于云的物联网（",
  "）平台，包括": "）平台，包括",
  "和我们向客户、用户和其他人提供的任何仪表板或门户网站（统称为“控制台”）和（": "和我们向客户、用户和其他人提供的任何仪表板或门户网站（统称为“控制台”）和（",
  "）智能云。网站、物联网平台和我们提供的与上述一项或多项业务相关的任何服务统称为“服务”。": "）智能云。网站、物联网平台和我们提供的与上述一项或多项业务相关的任何服务统称为“服务”。",
  "本服务可能包含由第三方运营和维护的，不受我们控制或维护的其他网站或在线服务的链接。本政策不适用于第三方如何收集、使用、披露或保留信息。我们建议您查看这些第三方网站或服务的隐私政策。": "本服务可能包含由第三方运营和维护的，不受我们控制或维护的其他网站或在线服务的链接。本政策不适用于第三方如何收集、使用、披露或保留信息。我们建议您查看这些第三方网站或服务的隐私政策。",
  "本政策还涵盖信息的处理。其中，此类信息是我们代表客户并根据客户的要求，通过": "本政策还涵盖信息的处理。其中，此类信息是我们代表客户并根据客户的要求，通过",
  "品牌移动应用程序和": "品牌移动应用程序和",
  "收集的信息。此类信息的处理仅限于提供客户与我们约定的服务，与其处理的个人数据的所有者没有直接关系。如果您是我们客户的用户，并且您不希望使用我们服务的客户联系您，请直接联系该客户并告知您的诉求。在受限制的情况下，如果您是智能手机应用程序或智能生活手机应用程序的用户，我们可能会为了我们自己的业务利益收集和处理您的一些个人数据。有关详细信息，请参见我们的移动隐私政策。": "收集的信息。此类信息的处理仅限于提供客户与我们约定的服务，与其处理的个人数据的所有者没有直接关系。如果您是我们客户的用户，并且您不希望使用我们服务的客户联系您，请直接联系该客户并告知您的诉求。在受限制的情况下，如果您是智能手机应用程序或智能生活手机应用程序的用户，我们可能会为了我们自己的业务利益收集和处理您的一些个人数据。有关详细信息，请参见我们的移动隐私政策。",
  "在本政策中，“个人数据”是指单独使用或者结合其他信息使用能够识别个人身份的信息。": "在本政策中，“个人数据”是指单独使用或者结合其他信息使用能够识别个人身份的信息。",
  "我们收集哪些个人数据": "我们收集哪些个人数据",
  "您自愿向我们提供的信息": "您自愿向我们提供的信息",
  "•": "•",
  "帐户或个人资料数据：当您注册我们的帐户时，我们可能会收集您的姓名和联系方式，例如您的姓名、电子邮件地址、邮寄地址、电话号码、用户名和登录凭据。": "帐户或个人资料数据：当您注册我们的帐户时，我们可能会收集您的姓名和联系方式，例如您的姓名、电子邮件地址、邮寄地址、电话号码、用户名和登录凭据。",
  "姓名和职位信息：当您访问我们的网站、填写我们的在线表格或与我们的支持团队沟通时，我们可能会收集您的姓名和职位相关信息，如您的姓名、电子邮件地址和工作": "姓名和职位信息：当您访问我们的网站、填写我们的在线表格或与我们的支持团队沟通时，我们可能会收集您的姓名和职位相关信息，如您的姓名、电子邮件地址和工作",
  "公司信息。": "公司信息。",
  "职位申请信息：当您申请我们的职位时，我们可能会收集您的教育和专业经验相关信息，如就读学校、学习课程、获得的学位、成绩、工作经历、获得的专业证书": "职位申请信息：当您申请我们的职位时，我们可能会收集您的教育和专业经验相关信息，如就读学校、学习课程、获得的学位、成绩、工作经历、获得的专业证书",
  "证明。": "证明。",
  "我们自动收集的信息": "我们自动收集的信息",
  "当您使用我们的网站和服务时，我们可能会收集您使用网站和服务的某些信息，包括个人数据：": "当您使用我们的网站和服务时，我们可能会收集您使用网站和服务的某些信息，包括个人数据：",
  "设备信息：当您通过硬件与我们的网站和服务交互时，我们会自动收集设备信息，例如设备的唯一设备标识标识符（“": "设备信息：当您通过硬件与我们的网站和服务交互时，我们会自动收集设备信息，例如设备的唯一设备标识标识符（“",
  "”）、": "”）、",
  "地址、": "地址、",
  '协议列表名称(中文)': '协议列表名称(中文)',
  '协议列表名称筛选': '协议列表名称筛选',
  '通道0': '通道0',
  '通道1': '通道1',
  '未分配': '未分配',
  '已分配': '已分配',
  '产品类型不能为空': '产品类型不能为空',
  '硬件版本号不能为空': '硬件版本号不能为空',
  '备注不能为空': '备注不能为空',
  '产品名称必须': '产品名称必须',
  '产品项目号必须': '产品项目号必须',
  '硬件版本号必须': '硬件版本号必须',
  '协议配置必须': '协议配置必须',
  '协议列表名称必须': '协议列表名称必须',
  '说明': '说明',
  '请选择协议列表名称': '请选择协议列表名称',
  '协议列表名称': '协议列表名称',
  '新建产品（产品模型）': '新建产品（产品模型）',
  '协议配置': '协议配置',
  '产品名称': '产品名称',
  '产品项目号': '产品项目号',
  '请输入产品项目号': '请输入产品项目号',
  '逆变器': '逆变器',
  '高压户储': '高压户储',
  '低压户储': '低压户储',
  '请选择产品名称': '请选择产品名称',
  '请选择协议配置': '请选择协议配置',
  '默认': '默认',
  '自定义': '自定义',
  '全部': '全部',
  '新增硬件版本': '新增硬件版本',
  '请选择产品类型': '请选择产品类型',
  '产品类型': '产品类型',
  '请输入硬件版本号': '请输入硬件版本号',
  '硬件版本号筛选': '硬件版本号筛选',
  '请选择产品型号': '请选择产品型号',
  '产品型号': '产品型号',
  '导出产测成功设备': "导出产测成功设备",
  '暂无数据': '暂无数据',
  '请选择代理商': '请选择代理商',
  '请输入设备ID/设备名称/IMEI': '请输入设备ID/设备名称/IMEI',
  '批量分配': '批量分配',
  '导出产测成功设备id': '导出产测成功设备id',
  '生产管理': '生产管理',
  '告警内容': '告警内容',
  '告警时间': '告警时间',
  '搜索': '搜索',
  shebeizongshu: '设备总数',
  zaixianshebeishu: '在线设备数',
  dailishangzongshu: '代理商总数',
  platformnamezh: '平台名称(中文)',
  platformnameen: '平台名称(英文)',
  platformlogo: '平台logo',
  refreshrate: '刷新频率',
  enter: '请输入',
  save: '保存',
  tripTimestart: '行程开始时间',
  tripTimeend: '行程结束时间',
  startaddress: '开始地址',
  endaddress: '结束地址',
  area: '区域管理',
  jingxiaoshang: '代理商管理',
  alarmManage: '告警列表',
  deviceman: '设备管理',
  userman: '用户管理',
  dictman: '逆变器字典管理',
  thingsuser: '物联网用户列表',
  devicedistribution: '设备列表',
  distributionLog: '历史记录',
  auth: '权限管理',
  account: '帐号管理',
  role: '角色管理',
  role_name: '角色名称',
  role_name_input: '请输入角色名称',
  menu: '菜单管理',
  interface: '接口管理',
  console: '控制台',
  project: '项目管理',
  person: '维保人员管理',
  area: '区域管理',
  jingxiaoshang: '代理商管理',
  alarmManage: '告警列表',
  deviceman: '设备管理',
  userman: '用户管理',
  dictman: '逆变器字典管理',
  thingsuser: '物联网用户列表',
  devicedistribution: '设备列表',
  distributionLog: '历史记录',
  accountAuth: '账号权限',
  moduleManage: '模块管理',
  interfaceManage: '接口管理',
  menuManage: '菜单管理',
  roleManage: '角色管理',
  accountManage: '帐号管理',
  details: '查看',
  control: '控制',
  homeTitle: '沛城能源管理平台',
  bigData: '大屏数据',
  controlConsole: "控制台",
  backman: '后台管理',
  Logout: '退出登录',
  add: '添加',
  import: '导入',
  export: '导出',
  upload: '下载',
  addoutbound: '新增出库',
  addfilename: "新增文件",
  refresh: "刷新",
  query: '查询',
  reset: '重置',
  operation: '操作',
  edit: '编辑',
  delete: '删除',
  nodata: '无数据',
  isdelete: '您确定要删除',
  ma: '吗',
  serialnumber: '序号',
  ok: '确定',
  cancel: '取消',
  protocolman: '协议管理',
  protocollist: '协议管理',
  protocollist2: '查看',
  product: "产品",
  projectprotocollist: '自定义协议',
  hardwareman: "硬件版本管理",
  hardwarelist: '硬件版本管理',
  firmwareman: '固件管理',
  firmwarelist: '固件版本',
  uplist: '升级规则',
  information: '资料',
  areamenu: {
    regional_classification: '区域分类',
    serialnumber: '序号',
    regionname: '区域名称',
    addsubordinatearea: '添加下级区域',
    addarea: '新增区域',
    editarea: '编辑区域',
    superiorregion: '上级区域',
    seletesuperiorregion: '请选择上级区域',
    enterregionname: '请输入区域名称',
    instructions: '说明',
    enterdescription: '请输入说明',
  },
  agentmenu: {
    agent: '代理商',
    area: '区域',
    selectarea: '请选择区域',
    inputagent: '请输入代理商',
    agentlist: "代理商列表",
    serialnumber: '序号',
    agentname: "代理商名称",
    filename: "文件名称",
    filenameprompt: "请输入文件名称",
    addsubagent: "添加子代理商",
    forbidden: '禁用',
    enable: '启用',
    transfer: '转移',
    authority: '权限',
    addagent: '新增代理商',
    agentnameplaceholer: '请输入代理商名称',
    contactperson: '联系人',
    contactpersonplaceholer: '请输入联系人',
    address: '地址',
    addressplaceholer: '请输入地址',
    maplnglat: "地图坐标(请单击地图获取地址)",
    enterlng: "请输入经度",
    enterlat: "请输入纬度",
    entersearchname: '请输入搜索名称',
    aftercontact: '售后联系',
    aftercontactplaceholer: '售后联系',
    loginaccount: '登录账号（手机号或邮箱）',
    loginaccountplaceholer: '请输入登录账号（手机号或邮箱）',
    loginpassword: '登录密码',
    loginpasswordplaceholer: '请输入登录密码',
    paramsconfigpass: '参数设置密码',
    paramsconfigpassplaceholer: '请输入参数设置密码',
    remark: '备注',
    remarkplaceholer: '请输入备注',
    namecannotbenull: '名称不能为空',
    contactcannotbenull: '联系人不能为空',
    areacannotbenull: '区域不能为空',
    addresscannotbenull: '地址不能为空',
    aftercannotbenull: '售后联系不能为空',
    mobileoremailcannotbenull: '手机号或邮箱不能为空',
    loginpasswordcannotbenull: '登录密码不能为空',
    mapcannotbenull: '地图坐标不能为空',
    uploadtime: '上传时间',
    createtime: '创建时间',
  },
  alarmmenu: {
    createtime:'创建时间',
    filename: '文件名',
    alarmmanage: '报警管理',
    agent: '代理商',
    agentplaceholer: '请选择代理商',
    selectstatus: '请选择状态',
    nothandle: '未处理',
    okhandle: '已处理',
    batchprocessing: '批量处理',
    did: '设备ID',
    affiliatedagent: '所属代理商',
    datatype: '数据类型',
    address: '地址',
    alarmcause: '告警原因',
    alarmtime: '告警时间',
    status: '状态',
    handleuser: '处理人',
    handletime: '处理时间',
    handle: '处理',
    nothandle: '未处理',
    okhandle: '已处理',
    alarmhandle: '告警处理',
    handleuserplaceholder: '请输入处理人',
    handletimeplaceholder: '请选择处理时间',
    handleusernotbenull: '处理人名称不能为空',
    handletimenotbenull: '处理时间不能为空'
  },
  devicelist: {
    region: '地区',
    passageway: '通道',
    devicestatus: '设备状态',
    deviceallocationstatus: '设备分配状态',
    did: '设备ID',
    deviceidfiltering: '设备ID筛选',
    agent: '代理商',
    selectagent: '请选择代理商',
    deviceallocationstatus: '设备分配状态',
    did: '设备ID',
    recordtime: '记录时间',
    electriccurrent: '电流',
    totalvoltage: '总电压',
    remainingcapacity: '剩余容量',
    fullchargecapacity: '满充容量',
    datechoose: "选择日期",
    date: '日期',
    version: '版本号',
    status: '状态',
    hardwareversionnumber: '硬件版本号',
    softwareversionnumber: '软件版本号',
    ccstatus: '产测状态',
    cctime: '产测时间',
    lastonlinetime: '最后上线时间',
    activationtime: '激活时间',
    exporthistory: '导出历史记录',
    control: '控制',
    see: '查看',
    viewtrajectory: '查看轨迹',
    distribution: '分配',
    canceldistribution: '取消分配',
    //产品
    index: "序号",
    productprojectid: "产品项目号",
    productname: "产品名称",
    hardwarecode: "硬件版本号",
    connecttype: "联网方式",
    protocolconfiguration: "协议配置",
    createtime: '创建时间',
    handleuser: '操作人',
    alarmlog: "告警记录",
    historylog: "历史记录",
    projectnum: '项目号',
    hardwareversion: '硬件版本号',
    softwareversion: '软件版本号',
    modelcode: '产品型号',
    online: '在线',
    offline: '离线',
    notknow: '未知',
    passman: '密码管理',
    daochuhis: '导出历史记录',
    timechoose: '时间筛选',
    qishijieshu: '起始时间、结束时间',
    qishijieshunotnull: '时间筛选不能为空',
    mostfenpei: '批量分配代理商',
    fenpei: '分配代理商',
    didfile: '设备ID文件',
    uploadxlsx: '请上传xlsx文件',
    downexample: '下载示例文件',
    newpass: '新密码',
    inputnewpass: '请输入新密码',
    newpassnotnull: '新密码必须',
    cancelfenpei: '取消分配',
    quedingcancel: '您确定要取消分配',
    dailinotnull: '代理商必选',
    bms_sn: '请输入bms_sn',
    pack_sn: '请输入pack_sn',
  },
  dictmenu: {
    protocoltype: '协议类型',
    protocolnumber: "协议编号",
    protocolname: "协议名称(中文)",
    protocolnameen: "协议名称(英文)",
    invertertype: '逆变器类型',
    creationtime: '创建时间',
    editiverterdict: '编辑逆变器字典',
    viewdetails: '查看详情',
    protocoltypeholder: '请选择协议类型',
    protocolnumberholder: '请输入协议编号',
    protocolnameholder: '请输入协议名称(中文)',
    protocolnameholderEN: '请输入协议名称(英文)',
    invertertypeholder: '请选择逆变器类型',
    protocolnamefilter: '协议名称筛选',
    addinverterdict: '新增逆变器字典',
    protocoltypenotnull: '协议类型不能为空',
    protocolnumbernotnull: '协议编号不能为空',
    protocolnamenotnull: '协议名称不能为空',
    invertertypenotnull: '逆变器类型不能为空',
    uploadxls: '请选择上传xlsx文件',
    downloadexample: '下载示例文件',
    upload: '上传',
    uploadPlaceHolder: 'xlsx文件不可为空',
    uploadPlaceHolderType: '文件类型不正确',
    sureexport: '您确定要导出当前数据吗？',
    suredelete: '您确定要删除',
    exportTime: '请选择导出时间',
    ma: '吗？',

  },
  loginArea: {
    title: '登录',
    userNameplaceholder: '请输入账号（邮箱/手机号）',
    userNameNotNull: '账号不能为空',
    passwordplaceholder: '请输入密码',
    passwordNotNull: '密码不能为空',
    forgetPassword: '忘记密码',
    haveAccount: '已经有账号',
    ok: '确定',
    emailbackPass: '邮箱找回密码',
    repasswordplaceholder: '重复新密码',
    repasswordNotNull: '重复密码不能为空',
    emailplaceholder: '请输入邮箱',
    emailNotNull: '邮箱不能为空',
    codeplaceholder: '请输入验证码',
    getvcode: '获取邮箱验证码',
    inputAgainPass: "重复新密码不能为空",
    emailIncorrect: '邮箱格式错误',
    getVodeSecondAfter: '秒后重新获取',
    requireFieldsNotice: '请填写必填项'
  },
  productModule: {
    projectcode: '项目号',
    projectcodeholder: '请选择项目号',
    upload: '上传',
    uploadcsv: '请上传csv文件',
    downloadexample: '下载示例文件',
    daoruyulan: '导入结果预览',
    guanliansn: '关联SN',
    totalnum: '总条数',
    exportsn: '导出SN(csv)',
    exportholder: '您确定要导出当前数据吗',
    exportasr: 'ASR下载(JSON)',
  },
  Changelang: {
      '实时数据': '实时数据',
  'PV数据': 'PV数据',
    '实时监测':'实时监测',
    '加热膜故障':'加热膜故障',
    '慢充电继电器粘连':'慢充电继电器粘连',
    '慢充电继电器失效':'慢充电继电器失效',
    '快充电继电器失效':'快充电继电器失效',
    '快充电继电器粘连':'快充电继电器粘连',
    '正级端子高温':'正级端子高温',
    '负级端子高温':'负级端子高温',
    '快充电口高温':'快充电口高温',
    '慢充电口高温':'慢充电口高温',
    '快充电继电器':'快充电继电器',
    '慢充电继电器':'慢充电继电器',
    '严重低压状态':'严重低压状态',
    '已占用':'已占用',
    '快充信号':'快充信号',
    '放电信号':'放电信号',
    '慢充信号':'慢充信号',
    '在线PACK个数':'在线PACK个数',
    '端子温度1':'端子温度1',
    '.端子温度2':'.端子温度2',
    '端子温度3':'端子温度3',
    '端子温度4':'端子温度4',
    '端子温度5':'端子温度5',
    '开启':'开启',
    '关闭':'关闭',
    '一级保护状态':"一级保护状态",
    '二级保护状态':"二级保护状态",
    '三级保护状态':"三级保护状态",
    '开关真实状态':"开关真实状态",
    '正常':"正常",
    '保护':'保护',
    '系统信息':'系统信息',
    '故障':'故障',
    '告警':'告警',
    '电压':'电压',
    '容量':'容量',
    '温度':'温度',
    '状态':'状态',
    '最高电压':'最高电压',
    '最低电压':'最低电压',
    '最高温度':'最高温度',
    '最低温度':'最低温度',
    '汇总数据': '汇总数据',
    'PACK详情数据': 'PACK详情数据',
    '设备信息': '设备信息',
    '堆数据': '堆数据',
    '刷新频率更改': '刷新频率更改',
    '刷新频率更改2': '长时间未操作，刷新频率改为60分钟',
    '簇数据': '簇数据',
    '单体数据': '单体数据',
    '固件升级': '固件升级',
    '产品品类': '产品品类',
    '当前选择的CAN逆变器ID': '当前选择的CAN逆变器ID',
    '家储': '家储',
    '基站': '基站',
    '高压BCU': '高压BCU',
    '高压BAU': '高压BAU',
    '无从机系统': '无从机系统',
    '有从机系统，且本机为主机': '有从机系统，且本机为主机',
    '有从机系统，且本机为从机': '有从机系统，且本机为从机',
    '项目号': '项目号',
    '用作设备管理显示': '用作设备管理显示',
    '协议版本号': '协议版本号',
    '外部软件版本号': '外部软件版本号',
    '内部软件版本号': '内部软件版本号',
    '软件开发版本号': '软件开发版本号',
    '系统SN': '系统SN',
    '配网显示名称(配网SN)': '配网显示名称(配网SN)',
    '当前选择的串口逆变器ID': '当前选择的串口逆变器ID',
    '当前选择的网络逆变器ID': '当前选择的网络逆变器ID',
    '参数设置': '参数设置',
    '历史记录': '历史记录',
    '告警数据': '告警数据',
    '密码管理': '密码管理',
    '历史轨迹': '历史轨迹',
    '无': '无',
    'BMS SN': 'BMS SN',
    'PACK SN': 'PACK SN',
    '单体高压1_保护值': '单体高压1_保护值',
    '单体高压1_保护延时': '单体高压1_保护延时',
    '单体高压1_保护恢复值': '单体高压1_保护恢复值',
    '单体高压1_保护恢复延时': '单体高压1_保护恢复延时',
    '单体高压2_保护值': '单体高压2_保护值',
    '单体高压2_保护延时': '单体高压2_保护延时',
    '单体高压2_保护恢复值': '单体高压2_保护恢复值',
    '单体高压2_保护恢复延时': '单体高压2_保护恢复延时',
    '单体高压3_保护值': '单体高压3_保护值',
    '单体高压3_保护延时': '单体高压3_保护延时',
    '单体高压3_保护恢复值': '单体高压3_保护恢复值',
    '单体高压3_保护恢复延时': '单体高压3_保护恢复延时',
    '单体低压1_保护值': '单体低压1_保护值',
    '单体低压1_保护延时': '单体低压1_保护延时',
    '单体低压1_保护恢复值': '单体低压1_保护恢复值',
    '单体低压1_保护恢复延时': '单体低压1_保护恢复延时',
    '单体低压2_保护值': '单体低压2_保护值',
    '单体低压2_保护延时': '单体低压2_保护延时',
    '单体低压2_保护恢复值': '单体低压2_保护恢复值',
    '单体低压2_保护恢复延时': '单体低压2_保护恢复延时',
    '单体低压3_保护值': '单体低压3_保护值',
    '单体低压3_保护延时': '单体低压3_保护延时',
    '单体低压3_保护恢复值': '单体低压3_保护恢复值',
    '单体低压3_保护恢复延时': '单体低压3_保护恢复延时',
    '电池簇总体高压1_保护值': '电池簇总体高压1_保护值',
    '电池簇总体高压1_保护延时': '电池簇总体高压1_保护延时',
    '电池簇总体高压1_保护恢复值': '电池簇总体高压1_保护恢复值',
    '电池簇总体高压1_保护恢复延时': '电池簇总体高压1_保护恢复延时',
    '电池簇总体高压2_保护值': '电池簇总体高压2_保护值',
    '电池簇总体高压2_保护延时': '电池簇总体高压2_保护延时',
    '电池簇总体高压2_保护恢复值': '电池簇总体高压2_保护恢复值',
    '电池簇总体高压2_保护恢复延时': '电池簇总体高压2_保护恢复延时',
    '电池簇总体高压3_保护值': '电池簇总体高压3_保护值',
    '电池簇总体高压3_保护延时': '电池簇总体高压3_保护延时',
    '电池簇总体高压3_保护恢复值': '电池簇总体高压3_保护恢复值',
    '电池簇总体高压3_保护恢复延时': '电池簇总体高压3_保护恢复延时',
    '电池簇总体低压1_保护值': '电池簇总体低压1_保护值',
    '电池簇总体低压1_保护延时': '电池簇总体低压1_保护延时',
    '电池簇总体低压1_保护恢复值': '电池簇总体低压1_保护恢复值',
    '电池簇总体低压1_保护恢复延时': '电池簇总体低压1_保护恢复延时',
    '电池簇总体低压2_保护值': '电池簇总体低压2_保护值',
    '电池簇总体低压2_保护延时': '电池簇总体低压2_保护延时',
    '电池簇总体低压2_保护恢复值': '电池簇总体低压2_保护恢复值',
    '电池簇总体低压2_保护恢复延时': '电池簇总体低压2_保护恢复延时',
    '电池簇总体低压3_保护值': '电池簇总体低压3_保护值',
    '电池簇总体低压3_保护延时': '电池簇总体低压3_保护延时',
    '电池簇总体低压3_保护恢复值': '电池簇总体低压3_保护恢复值',
    '电池簇总体低压3_保护恢复延时': '电池簇总体低压3_保护恢复延时',
    '充电过流1_保护值': '充电过流1_保护值',
    '充电过流1_保护延时': '充电过流1_保护延时',
    '充电过流1_保护恢复值': '充电过流1_保护恢复值',
    '充电过流1_保护恢复延时': '充电过流1_保护恢复延时',
    '充电过流2_保护值': '充电过流2_保护值',
    '充电过流2_保护延时': '充电过流2_保护延时',
    '充电过流3_保护值': '充电过流3_保护值',
    '充电过流3_保护延时': '充电过流3_保护延时',
    '放电过流1_保护值': '放电过流1_保护值',
    '放电过流1_保护延时': '放电过流1_保护延时',
    '放电过流1_保护恢复值': '放电过流1_保护恢复值',
    '放电过流1_保护恢复延时': '放电过流1_保护恢复延时',
    '放电过流2_保护值': '放电过流2_保护值',
    '放电过流2_保护延时': '放电过流2_保护延时',
    '放电过流3_保护值': '放电过流3_保护值',
    '放电过流3_保护延时': '放电过流3_保护延时',
    '充电高温1_保护值': '充电高温1_保护值',
    '充电高温1_保护延时': '充电高温1_保护延时',
    '充电高温1_保护恢复值': '充电高温1_保护恢复值',
    '充电高温1_保护恢复延时': '充电高温1_保护恢复延时',
    '充电高温2_保护值': '充电高温2_保护值',
    '充电高温2_保护延时': '充电高温2_保护延时',
    '充电高温2_保护恢复值': '充电高温2_保护恢复值',
    '充电高温2_保护恢复延时': '充电高温2_保护恢复延时',
    '充电高温3_保护值': '充电高温3_保护值',
    '充电高温3_保护延时': '充电高温3_保护延时',
    '充电高温3_保护恢复值': '充电高温3_保护恢复值',
    '充电高温3_保护恢复延时': '充电高温3_保护恢复延时',
    '充电低温1_保护值': '充电低温1_保护值',
    '充电低温1_保护延时': '充电低温1_保护延时',
    '充电低温1_保护恢复值': '充电低温1_保护恢复值',
    '充电低温1_保护恢复延时': '充电低温1_保护恢复延时',
    '充电低温2_保护值': '充电低温2_保护值',
    '充电低温2_保护延时': '充电低温2_保护延时',
    '充电低温2_保护恢复值': '充电低温2_保护恢复值',
    '充电低温2_保护恢复延时': '充电低温2_保护恢复延时',
    '充电低温3_保护值': '充电低温3_保护值',
    '充电低温3_保护延时': '充电低温3_保护延时',
    '充电低温3_保护恢复值': '充电低温3_保护恢复值',
    '充电低温3_保护恢复延时': '充电低温3_保护恢复延时',
    '放电高温1_保护值': '放电高温1_保护值',
    '放电高温1_保护延时': '放电高温1_保护延时',
    '放电高温1_保护恢复值': '放电高温1_保护恢复值',
    '放电高温1_保护恢复延时': '放电高温1_保护恢复延时',
    '放电高温2_保护值': '放电高温2_保护值',
    '放电高温2_保护延时': '放电高温2_保护延时',
    '放电高温2_保护恢复值': '放电高温2_保护恢复值',
    '放电高温2_保护恢复延时': '放电高温2_保护恢复延时',
    '放电高温3_保护值': '放电高温3_保护值',
    '放电高温3_保护延时': '放电高温3_保护延时',
    '放电高温3_保护恢复值': '放电高温3_保护恢复值',
    '放电高温3_保护恢复延时': '放电高温3_保护恢复延时',
    '放电低温1_保护值': '放电低温1_保护值',
    '放电低温1_保护延时': '放电低温1_保护延时',
    '放电低温1_保护恢复值': '放电低温1_保护恢复值',
    '放电低温1_保护恢复延时': '放电低温1_保护恢复延时',
    '放电低温2_保护值': '放电低温2_保护值',
    '放电低温2_保护延时': '放电低温2_保护延时',
    '放电低温2_保护恢复值': '放电低温2_保护恢复值',
    '放电低温2_保护恢复延时': '放电低温2_保护恢复延时',
    '放电低温3_保护值': '放电低温3_保护值',
    '放电低温3_保护延时': '放电低温3_保护延时',
    '放电低温3_保护恢复值': '放电低温3_保护恢复值',
    '放电低温3_保护恢复延时': '放电低温3_保护恢复延时',
    '充电温差1_保护值': '充电温差1_保护值',
    '充电温差1_保护延时': '充电温差1_保护延时',
    '充电温差1_保护恢复值': '充电温差1_保护恢复值',
    '充电温差1_保护恢复延时': '充电温差1_保护恢复延时',
    '充电温差2_保护值': '充电温差2_保护值',
    '充电温差2_保护延时': '充电温差2_保护延时',
    '充电温差2_保护恢复值': '充电温差2_保护恢复值',
    '充电温差2_保护恢复延时': '充电温差2_保护恢复延时',
    '充电温差3_保护值': '充电温差3_保护值',
    '充电温差3_保护延时': '充电温差3_保护延时',
    '充电温差3_保护恢复值': '充电温差3_保护恢复值',
    '充电温差3_保护恢复延时': '充电温差3_保护恢复延时',
    '放电温差1_保护值': '放电温差1_保护值',
    '放电温差1_保护延时': '放电温差1_保护延时',
    '放电温差1_保护恢复值': '放电温差1_保护恢复值',
    '放电温差1_保护恢复延时': '放电温差1_保护恢复延时',
    '放电温差2_保护值': '放电温差2_保护值',
    '放电温差2_保护延时': '放电温差2_保护延时',
    '放电温差2_保护恢复值': '放电温差2_保护恢复值',
    '放电温差2_保护恢复延时': '放电温差2_保护恢复延时',
    '放电温差3_保护值': '放电温差3_保护值',
    '放电温差3_保护延时': '放电温差3_保护延时',
    '放电温差3_保护恢复值': '放电温差3_保护恢复值',
    '放电温差3_保护恢复延时': '放电温差3_保护恢复延时',
    '电芯温升1_保护值': '电芯温升1_保护值',
    '电芯温升1_保护延时': '电芯温升1_保护延时',
    '电芯温升1_保护恢复值': '电芯温升1_保护恢复值',
    '电芯温升1_保护恢复延时': '电芯温升1_保护恢复延时',
    '电芯温升2_保护值': '电芯温升2_保护值',
    '电芯温升2_保护延时': '电芯温升2_保护延时',
    '电芯温升2_保护恢复值': '电芯温升2_保护恢复值',
    '电芯温升2_保护恢复延时': '电芯温升2_保护恢复延时',
    '电芯温升3_保护值': '电芯温升3_保护值',
    '电芯温升3_保护延时': '电芯温升3_保护延时',
    '电芯温升3_保护恢复值': '电芯温升3_保护恢复值',
    '电芯温升3_保护恢复延时': '电芯温升3_保护恢复延时',
    'SOC高1_保护值': 'SOC高1_保护值',
    'SOC高1_保护延时': 'SOC高1_保护延时',
    'SOC高1_保护恢复值': 'SOC高1_保护恢复值',
    'SOC高1_保护恢复延时': 'SOC高1_保护恢复延时',
    'SOC高2_保护值': 'SOC高2_保护值',
    'SOC高2_保护延时': 'SOC高2_保护延时',
    'SOC高2_保护恢复值': 'SOC高2_保护恢复值',
    'SOC高2_保护恢复延时': 'SOC高2_保护恢复延时',
    'SOC高3_保护值': 'SOC高3_保护值',
    'SOC高3_保护延时': 'SOC高3_保护延时',
    'SOC高3_保护恢复值': 'SOC高3_保护恢复值',
    'SOC高3_保护恢复延时': 'SOC高3_保护恢复延时',
    'SOC低1_保护值': 'SOC低1_保护值',
    'SOC低1_保护延时': 'SOC低1_保护延时',
    'SOC低1_保护恢复值': 'SOC低1_保护恢复值',
    'SOC低1_保护恢复延时': 'SOC低1_保护恢复延时',
    'SOC低2_保护值': 'SOC低2_保护值',
    'SOC低2_保护延时': 'SOC低2_保护延时',
    'SOC低2_保护恢复值': 'SOC低2_保护恢复值',
    'SOC低2_保护恢复延时': 'SOC低2_保护恢复延时',
    'SOC低3_保护值': 'SOC低3_保护值',
    'SOC低3_保护延时': 'SOC低3_保护延时',
    'SOC低3_保护恢复值': 'SOC低3_保护恢复值',
    'SOC低3_保护恢复延时': 'SOC低3_保护恢复延时',
    '正极绝缘漏电1_保护值': '正极绝缘漏电1_保护值',
    '正极绝缘漏电1_保护延时': '正极绝缘漏电1_保护延时',
    '正极绝缘漏电1_保护恢复值': '正极绝缘漏电1_保护恢复值',
    '正极绝缘漏电1_保护恢复延时': '正极绝缘漏电1_保护恢复延时',
    '正极绝缘漏电2_保护值': '正极绝缘漏电2_保护值',
    '正极绝缘漏电2_保护延时': '正极绝缘漏电2_保护延时',
    '正极绝缘漏电2_保护恢复值': '正极绝缘漏电2_保护恢复值',
    '正极绝缘漏电2_保护恢复延时': '正极绝缘漏电2_保护恢复延时',
    '正极绝缘漏电3_保护值': '正极绝缘漏电3_保护值',
    '正极绝缘漏电3_保护延时': '正极绝缘漏电3_保护延时',
    '正极绝缘漏电3_保护恢复值': '正极绝缘漏电3_保护恢复值',
    '正极绝缘漏电3_保护恢复延时': '正极绝缘漏电3_保护恢复延时',
    '负极绝缘漏电1_保护值': '负极绝缘漏电1_保护值',
    '负极绝缘漏电1_保护延时': '负极绝缘漏电1_保护延时',
    '负极绝缘漏电1_保护恢复值': '负极绝缘漏电1_保护恢复值',
    '负极绝缘漏电1_保护恢复延时': '负极绝缘漏电1_保护恢复延时',
    '负极绝缘漏电2_保护值': '负极绝缘漏电2_保护值',
    '负极绝缘漏电2_保护延时': '负极绝缘漏电2_保护延时',
    '负极绝缘漏电2_保护恢复值': '负极绝缘漏电2_保护恢复值',
    '负极绝缘漏电2_保护恢复延时': '负极绝缘漏电2_保护恢复延时',
    '负极绝缘漏电3_保护值': '负极绝缘漏电3_保护值',
    '负极绝缘漏电3_保护延时': '负极绝缘漏电3_保护延时',
    '负极绝缘漏电3_保护恢复值': '负极绝缘漏电3_保护恢复值',
    '负极绝缘漏电3_保护恢复延时': '负极绝缘漏电3_保护恢复延时',
    '环境高温1_保护值': '环境高温1_保护值',
    '环境高温1_保护延时': '环境高温1_保护延时',
    '环境高温1_保护恢复值': '环境高温1_保护恢复值',
    '环境高温1_保护恢复延时': '环境高温1_保护恢复延时',
    '环境高温2_保护值': '环境高温2_保护值',
    '环境高温2_保护延时': '环境高温2_保护延时',
    '环境高温2_保护恢复值': '环境高温2_保护恢复值',
    '环境高温2_保护恢复延时': '环境高温2_保护恢复延时',
    '环境高温3_保护值': '环境高温3_保护值',
    '环境高温3_保护延时': '环境高温3_保护延时',
    '环境高温3_保护恢复值': '环境高温3_保护恢复值',
    '环境高温3_保护恢复延时': '环境高温3_保护恢复延时',
    '环境低温1_保护值': '环境低温1_保护值',
    '环境低温1_保护延时': '环境低温1_保护延时',
    '环境低温1_保护恢复值': '环境低温1_保护恢复值',
    '环境低温1_保护恢复延时': '环境低温1_保护恢复延时',
    '环境低温2_保护值': '环境低温2_保护值',
    '环境低温2_保护延时': '环境低温2_保护延时',
    '环境低温2_保护恢复值': '环境低温2_保护恢复值',
    '环境低温2_保护恢复延时': '环境低温2_保护恢复延时',
    '环境低温3_保护值': '环境低温3_保护值',
    '环境低温3_保护延时': '环境低温3_保护延时',
    '环境低温3_保护恢复值': '环境低温3_保护恢复值',
    '环境低温3_保护恢复延时': '环境低温3_保护恢复延时',
    '充电压差1_保护值': '充电压差1_保护值',
    '充电压差1_保护延时': '充电压差1_保护延时',
    '充电压差1_保护恢复值': '充电压差1_保护恢复值',
    '充电压差1_保护恢复延时': '充电压差1_保护恢复延时',
    '充电压差2_保护值': '充电压差2_保护值',
    '充电压差2_保护延时': '充电压差2_保护延时',
    '充电压差2_保护恢复值': '充电压差2_保护恢复值',
    '充电压差2_保护恢复延时': '充电压差2_保护恢复延时',
    '充电压差3_保护值': '充电压差3_保护值',
    '充电压差3_保护延时': '充电压差3_保护延时',
    '充电压差3_保护恢复值': '充电压差3_保护恢复值',
    '充电压差3_保护恢复延时': '充电压差3_保护恢复延时',
    '放电压差1_保护值': '放电压差1_保护值',
    '放电压差1_保护延时': '放电压差1_保护延时',
    '放电压差1_保护恢复值': '放电压差1_保护恢复值',
    '放电压差1_保护恢复延时': '放电压差1_保护恢复延时',
    '放电压差2_保护值': '放电压差2_保护值',
    '放电压差2_保护延时': '放电压差2_保护延时',
    '放电压差2_保护恢复值': '放电压差2_保护恢复值',
    '放电压差2_保护恢复延时': '放电压差2_保护恢复延时',
    '放电压差3_保护值': '放电压差3_保护值',
    '放电压差3_保护延时': '放电压差3_保护延时',
    '放电压差3_保护恢复值': '放电压差3_保护恢复值',
    '放电压差3_保护恢复延时': '放电压差3_保护恢复延时',
    '端子高温1_保护值': '端子高温1_保护值',
    '端子高温1_保护延时': '端子高温1_保护延时',
    '端子高温1_保护恢复值': '端子高温1_保护恢复值',
    '端子高温1_保护恢复延时': '端子高温1_保护恢复延时',
    '端子高温2_保护值': '端子高温2_保护值',
    '端子高温2_保护延时': '端子高温2_保护延时',
    '端子高温2_保护恢复值': '端子高温2_保护恢复值',
    '端子高温2_保护恢复延时': '端子高温2_保护恢复延时',
    '端子高温3_保护值': '端子高温3_保护值',
    '端子高温3_保护延时': '端子高温3_保护延时',
    '端子高温3_保护恢复值': '端子高温3_保护恢复值',
    '端子高温3_保护恢复延时': '端子高温3_保护恢复延时',
    '开启风扇_环境温度': '开启风扇_环境温度',
    '开启风扇_端子温度': '开启风扇_端子温度',
    '关闭风扇_环境温度': '关闭风扇_环境温度',
    '关闭风扇_端子温度': '关闭风扇_端子温度',
    '电芯故障_保护值': '电芯故障_保护值',
    '电芯故障_保护延时': '电芯故障_保护延时',
    '电芯故障_保护恢复值': '电芯故障_保护恢复值',
    '电芯故障_保护恢复延时': '电芯故障_保护恢复延时',
    '满充截止电压': '满充截止电压',
    '满充截止电流': '满充截止电流',
    'SOC低告警值': 'SOC低告警值',
    '满充SOC释放值': '满充SOC释放值',
    '均衡开启电压': '均衡开启电压',
    '均衡开启压差': '均衡开启压差',
    '设计容量': '设计容量',
    '剩余容量': '剩余容量',
    '满充容量': '满充容量',
    '短路保护延时': '短路保护延时',
    '掉电单体电压': '掉电单体电压',
    '掉电总体电压': '掉电总体电压',
    '掉电延时时间': '掉电延时时间',
    '单体高压告警值': '单体高压告警值',
    '单体高压保护值': '单体高压保护值',
    '单体高压保护延时': '单体高压保护延时',
    '单体高压恢复值': '单体高压恢复值',
    '单体低压告警值': '单体低压告警值',
    '单体低压保护值': '单体低压保护值',
    '单体低压保护延时': '单体低压保护延时',
    '单体低压恢复值': '单体低压恢复值',
    '总体高压告警': '总体高压告警',
    '总体高压保护值': '总体高压保护值',
    '总体高压保护延时': '总体高压保护延时',
    '总体高压恢复值': '总体高压恢复值',
    '总体低压告警': '总体低压告警',
    '总体低压保护值': '总体低压保护值',
    '总体低压保护延时': '总体低压保护延时',
    '总体低压恢复值': '总体低压恢复值',
    '充电过流告警值': '充电过流告警值',
    '充电过流保护值': '充电过流保护值',
    '充电过流保护延时': '充电过流保护延时',
    '充电过流保护值2': '充电过流保护值2',
    '充电过流保护延时2': '充电过流保护延时2',
    '放电过流告警值': '放电过流告警值',
    '放电过流保护值': '放电过流保护值',
    '放电过流保护延时': '放电过流保护延时',
    '放电过流保护值2': '放电过流保护值2',
    '放电过流保护延时2': '放电过流保护延时2',
    '充电高温告警值': '充电高温告警值',
    '充电高温保护值': '充电高温保护值',
    '充电高温恢复值': '充电高温恢复值',
    '充电低温告警值': '充电低温告警值',
    '充电低温保护值': '充电低温保护值',
    '充电低温恢复值': '充电低温恢复值',
    '放电高温告警值': '放电高温告警值',
    '放电高温保护值': '放电高温保护值',
    '放电高温恢复值': '放电高温恢复值',
    '放电低温告警值': '放电低温告警值',
    '放电低温保护值': '放电低温保护值',
    '放电低温恢复值': '放电低温恢复值',
    '环境高温告警值': '环境高温告警值',
    '环境高温保护值': '环境高温保护值',
    '环境高温恢复值': '环境高温恢复值',
    '环境低温告警值': '环境低温告警值',
    '环境低温保护值': '环境低温保护值',
    '环境低温恢复值': '环境低温恢复值',
    'MOS高温告警值': 'MOS高温告警值',
    'MOS高温保护值': 'MOS高温保护值',
    'MOS高温保护恢复值': 'MOS高温保护恢复值',
    '休眠单体电压': '休眠单体电压',
    '休眠延时时间': '休眠延时时间',
    '弱电开关': '弱电开关',
    '蜂鸣器': '蜂鸣器',
    '限流': '限流',
    'LED告警': 'LED告警',
    '上电BCU编码': '上电BCU编码',
    '上电BMU编码': '上电BMU编码',
    '上电绝缘检测': '上电绝缘检测',
    '上电并机控制': '上电并机控制',
    '绝缘检测使能': '绝缘检测使能',
    '单体高压': '单体高压',
    '单体低压': '单体低压',
    '总体高压': '总体高压',
    '总体低压': '总体低压',
    '充电过流': '充电过流',
    '放电过流': '放电过流',
    '充电高温': '充电高温',
    '放电高温': '放电高温',
    '充电低温': '充电低温',
    '放电低温': '放电低温',
    '环境高温': '环境高温',
    '环境低温': '环境低温',
    '充电继电器高温': '充电继电器高温',
    '放电继电器高温': '放电继电器高温',
    '负极继电器高温': '负极继电器高温',
    'SOC高': 'SOC高',
    'SOC低': 'SOC低',
    '正极绝缘漏电': '正极绝缘漏电',
    '负极绝缘漏电': '负极绝缘漏电',
    '充电压差': '充电压差',
    '放电压差': '放电压差',
    '充电温差': '充电温差',
    '电芯温升': '电芯温升',
    '电芯采样': '电芯采样',
    'NTC采样异常': 'NTC采样异常',
    '电流故障检测': '电流故障检测',
    '充电继电器控制': '充电继电器控制',
    '放电继电器控制': '放电继电器控制',
    '预充继电器控制': '预充继电器控制',
    '负极继电器控制': '负极继电器控制',
    '加热膜继电器控制': '加热膜继电器控制',
    '充电继电器使能': '充电继电器使能',
    '放电继电器使能': '放电继电器使能',
    '预充继电器使能': '预充继电器使能',
    '负极继电器使能': '负极继电器使能',
    '加热膜继电器使能': '加热膜继电器使能',
    '电芯高温': '电芯高温',
    '电芯低温': '电芯低温',
    '环境温度': '环境温度',
    'MOS高温': 'MOS高温',
    '预留': '预留',
    '系统锁功能': '系统锁功能',
    '放电温差': '放电温差',
    '端子高温': '端子高温',
    '充电继电器粘连': '充电继电器粘连',
    '充电继电器失效': '充电继电器失效',
    '放电继电器粘连': '放电继电器粘连',
    '放电继电器失效': '放电继电器失效',
    '预充继电器粘连': '预充继电器粘连',
    '预充继电器失效': '预充继电器失效',
    '负极继电器粘连': '负极继电器粘连',
    '负极继电器失效': '负极继电器失效',
    '加热膜继电器粘连': '加热膜继电器粘连',
    '加热膜继电器失效': '加热膜继电器失效',
    '12V异常': '12V异常',
    '电芯故障': '电芯故障',
    '预充故障': '预充故障',
    '加热膜继电器': '加热膜继电器',
    '绝缘板通信故障': '绝缘板通信故障',
    '采样板通信故障': '采样板通信故障',
    '电流分流器故障': '电流分流器故障',
    'NTC故障': 'NTC故障',
    '急停': '急停',
    '水浸': '水浸',
    '烟感': '烟感',
    '总压故障': '总压故障',
    'AFE通讯故障': 'AFE通讯故障',
    '霍尔故障': '霍尔故障',
    '参数配置失败': '参数配置失败',
    '高压回路故障': '高压回路故障',
    '继电器开关频率高故障': '继电器开关频率高故障',
    '充电继电器': '充电继电器',
    '放电继电器': '放电继电器',
    '预充继电器': '预充继电器',
    '负极继电器': '负极继电器',
    '加热膜': '加热膜',
    '使用Pack供电': '使用Pack供电',
    '充电器反接': '充电器反接',
    '充电器接入': '充电器接入',
    '关机状态': '关机状态',
    '强充指示': '强充指示',
    '预充失败': '预充失败',
    '固件更新成功标志': '固件更新成功标志',
    '并机开始标志': '并机开始标志',
    '并机结束标志': '并机结束标志',
    '并机成功标志': '并机成功标志',
    '并机异常标志': '并机异常标志',
    '绝缘开始标志': '绝缘开始标志',
    '绝缘结束标志': '绝缘结束标志',
    '绝缘检查完成': '绝缘检查完成',
    '绝缘检查异常': '绝缘检查异常',
    '满充': '满充',
    '异常掉电': '异常掉电',
    '485对外通讯失败': '485对外通讯失败',
    '单机模式': '单机模式',
    '并机模式': '并机模式',
    '开关机状态': '开关机状态',
    '满充标志': '满充标志',
    '过放标志': '过放标志',
    'PCS禁充': 'PCS禁充',
    'PCS禁放': 'PCS禁放',
    '模拟数据测试模式': '模拟数据测试模式',
    '继电器并入禁止': '继电器并入禁止',
    '主回路维护模式': '主回路维护模式',
    '继电器开关频率高告警': '继电器开关频率高告警',
    '允许并入': '允许并入',
    '请求并入': '请求并入',
    '补电模式': '补电模式',
    '总电压': '总电压',
    '负载电压': '负载电压',
    'SOH': 'SOH',
    'SOC': 'SOC',
    '最大SOC': '最大SOC',
    '最小SOC': '最小SOC',
    'SOC差值': 'SOC差值',
    '最大SOC BCU地址': '最大SOC BCU地址',
    '最小SOC BCU地址': '最小SOC BCU地址',
    '电流': '电流',
    '最大电流': '最大电流',
    '最小电流': '最小电流',
    '平均电流': '平均电流',
    '最大电流BCU地址': '最大电流BCU地址',
    '最小电流BCU地址': '最小电流BCU地址',
    '单体电压最大值': '单体电压最大值',
    '最大单体电压BCU地址': '最大单体电压BCU地址',
    '最大单体电压BMU地址': '最大单体电压BMU地址',
    '最大单体电压在BMU中的地址(Cell)': '最大单体电压在BMU中的地址(Cell)',
    '单体电压最小值': '单体电压最小值',
    '最小单体电压BCU地址': '最小单体电压BCU地址',
    '最小单体电压BMU地址': '最小单体电压BMU地址',
    '最小单体电压在BMU中的地址(Cell)': '最小单体电压在BMU中的地址(Cell)',
    '单体最大压差': '单体最大压差',
    '电池温度最大值': '电池温度最大值',
    '电池温度最大值BCU地址': '电池温度最大值BCU地址',
    '电池温度最大值BMU地址': '电池温度最大值BMU地址',
    '电池温度最大值在BMU中的地址(Cell)': '电池温度最大值在BMU中的地址(Cell)',
    '单体最大温差': '单体最大温差',
    'BMU最大电压值': 'BMU最大电压值',
    'BMU最小电压值': 'BMU最小电压值',
    'BMU最大电压BCU地址': 'BMU最大电压BCU地址',
    'BMU最大电压地址': 'BMU最大电压地址',
    'BMU最小电压BCU地址': 'BMU最小电压BCU地址',
    'BMU最小电压地址': 'BMU最小电压地址',
    '总体电压最大值': '总体电压最大值',
    '总体电压最大值BCU地址': '总体电压最大值BCU地址',
    '总体电压最小值': '总体电压最小值',
    '总体电压最小值BCU地址': '总体电压最小值BCU地址',
    '总体最大压差': '总体最大压差',
    '在线BCU个数': '在线BCU个数',
    '循环次数': '循环次数',
    '历史充电容量': '历史充电容量',
    '历史放电容量': '历史放电容量',
    'BCU地址编号(0-254)': 'BCU地址编号(0-254)',
    '系统状态': '系统状态',
    '电池状态': '电池状态',
    '电池温度最小值': '电池温度最小值',
    '电池温度最小值BCU地址': '电池温度最小值BCU地址',
    '电池温度最小值BMU地址': '电池温度最小值BMU地址',
    '电池温度最小值在BMU中的地址(Cell)': '电池温度最小值在BMU中的地址(Cell)',
    '总体电压最大值BMU地址': '总体电压最大值BMU地址',
    '总体电压最小值BMU地址': '总体电压最小值BMU地址',
    '在线BMU个数': '在线BMU个数',
    '单体过压保护': '单体过压保护',
    '单体过放保护': '单体过放保护',
    '总压过压保护': '总压过压保护',
    '总压过放保护': '总压过放保护',
    '充电过流保护': '充电过流保护',
    '放电过流保护': '放电过流保护',
    '短路': '短路',
    '充电器高压': '充电器高压',
    '充电高温保护（电芯）': '充电高温保护（电芯）',
    '放电高温保护（电芯）': '放电高温保护（电芯）',
    '充电低温保护（电芯）': '充电低温保护（电芯）',
    '放电低温保护（电芯）': '放电低温保护（电芯）',
    'MOS高温保护': 'MOS高温保护',
    '环境高温保护': '环境高温保护',
    '环境低温保护': '环境低温保护',
    'Fully（充满）': 'Fully（充满）',
    '充电MOS故障': '充电MOS故障',
    '放电MOS故障': '放电MOS故障',
    '温度传感器故障': '温度传感器故障',
    '通讯故障': '通讯故障',
    '采样芯片故障': '采样芯片故障',
    '限流故障': '限流故障',
    '总压过压': '总压过压',
    '温差': '温差',
    '检流电阻': '检流电阻',
    '脱扣器状态': '脱扣器状态',
    '脱扣器': '脱扣器',
    '主从机掉线状态': '主从机掉线状态',
    '12V故障': '12V故障',
    '限流指示': '限流指示',
    '充电指示': '充电指示',
    '放电指示': '放电指示',
    '使用Pack供电指示': '使用Pack供电指示',
    '充电器反接指示': '充电器反接指示',
    'ACin': 'ACin',
    '关机': '关机',
    '加热膜指示': '加热膜指示',
    'PACK地址编号(0-254)': 'PACK地址编号(0-254)',
    '总电压(单体汇总)': '总电压(单体汇总)',
    '最大单体电压PACK地址': '最大单体电压PACK地址',
    '最大单体电压在PACK中的地址(Cell)': '最大单体电压在PACK中的地址(Cell)',
    '最小单体电压PACK地址': '最小单体电压PACK地址',
    '最小单体电压在PACK中的地址(Cell)': '最小单体电压在PACK中的地址(Cell)',
    '电池温度最大值Pack地址': '电池温度最大值Pack地址',
    '电池温度最大值在Pack中的地址(Cell)': '电池温度最大值在Pack中的地址(Cell)',
    '电池温度最小值Pack地址': '电池温度最小值Pack地址',
    '电池温度最小值在Pack中的地址(Cell)': '电池温度最小值在Pack中的地址(Cell)',
    '总体电压最大值Pack地址': '总体电压最大值Pack地址',
    '总体电压最小值Pack地址': '总体电压最小值Pack地址',
    '在线Pack个数': '在线Pack个数',
    '蓝牙连接': '蓝牙连接',
    'WiFi后台连接': 'WiFi后台连接',
    '限流关闭(硬件过压保护)': '限流关闭(硬件过压保护)',
    '电池包锁定': '电池包锁定',
    'MCU过压': 'MCU过压',
    '单体过压告警': '单体过压告警',
    '充电高温告警': '充电高温告警',
    '单体低压告警': '单体低压告警',
    '总压过压告警': '总压过压告警',
    '总压低压告警': '总压低压告警',
    '充电过流告警': '充电过流告警',
    '放电过流告警': '放电过流告警',
    '放电高温告警': '放电高温告警',
    '充电低温告警': '充电低温告警',
    '放电低温告警': '放电低温告警',
    '环境高温告警': '环境高温告警',
    '环境低温告警': '环境低温告警',
    'MOS高温告警': 'MOS高温告警',
    '低电量告警': '低电量告警',
    '总电压2(独立汇总)': '总电压2(独立汇总)',
    '电流2（独立电流）': '电流2（独立电流）',
    '屏蔽告警': '屏蔽告警',

    '换电管理': '换电管理',
    '限流屏蔽': '限流屏蔽',
    '限流挡位': '限流挡位',
    '蜂鸣器告警功能': '蜂鸣器告警功能',
    '均衡状态': '均衡状态',
    '累计充电容量': '累计充电容量',
    '累计放电容量': '累计放电容量',
    '总体高压1_保护值': '总体高压1_保护值',
    '总体高压1_保护延时': '总体高压1_保护延时',
    '总体高压1_保护恢复值': '总体高压1_保护恢复值',
    '总体高压1_保护恢复延时': '总体高压1_保护恢复延时',
    '总体高压2_保护值': '总体高压2_保护值',
    '总体高压2_保护延时': '总体高压2_保护延时',
    '总体高压2_保护恢复值': '总体高压2_保护恢复值',
    '总体高压2_保护恢复延时': '总体高压2_保护恢复延时',
    '总体高压3_保护值': '总体高压3_保护值',
    '总体高压3_保护延时': '总体高压3_保护延时',
    '总体高压3_保护恢复值': '总体高压3_保护恢复值',
    '总体高压3_保护恢复延时': '总体高压3_保护恢复延时',
    '总体低压1_保护值': '总体低压1_保护值',
    '总体低压1_保护延时': '总体低压1_保护延时',
    '总体低压1_保护恢复值': '总体低压1_保护恢复值',
    '总体低压1_保护恢复延时': '总体低压1_保护恢复延时',
    '总体低压2_保护值': '总体低压2_保护值',
    '总体低压2_保护延时': '总体低压2_保护延时',
    '总体低压2_保护恢复值': '总体低压2_保护恢复值',
    '总体低压2_保护恢复延时': '总体低压2_保护恢复延时',
    '总体低压3_保护值': '总体低压3_保护值',
    '总体低压3_保护延时': '总体低压3_保护延时',
    '总体低压3_保护恢复值': '总体低压3_保护恢复值',
    '总体低压3_保护恢复延时': '总体低压3_保护恢复延时',
    '快充口高温1_保护值': '快充口高温1_保护值',
    '快充口高温1_保护延时': '快充口高温1_保护延时',
    '快充口高温1_保护恢复值': '快充口高温1_保护恢复值',
    '快充口高温1_保护恢复延时': '快充口高温1_保护恢复延时',
    '快充口高温2_保护值': '快充口高温2_保护值',
    '快充口高温2_保护延时': '快充口高温2_保护延时',
    '快充口高温2_保护恢复值': '快充口高温2_保护恢复值',
    '快充口高温2_保护恢复延时': '快充口高温2_保护恢复延时',
    '快充口高温3_保护值': '快充口高温3_保护值',
    '快充口高温3_保护延时': '快充口高温3_保护延时',
    '快充口高温3_保护恢复值': '快充口高温3_保护恢复值',
    '快充口高温3_保护恢复延时': '快充口高温3_保护恢复延时',
    '慢充口高温1_保护值': '慢充口高温1_保护值',
    '慢充口高温1_保护延时': '慢充口高温1_保护延时',
    '慢充口高温1_保护恢复值': '慢充口高温1_保护恢复值',
    '慢充口高温1_保护恢复延时': '慢充口高温1_保护恢复延时',
    '慢充口高温2_保护值': '慢充口高温2_保护值',
    '慢充口高温2_保护延时': '慢充口高温2_保护延时',
    '慢充口高温2_保护恢复值': '慢充口高温2_保护恢复值',
    '慢充口高温2_保护恢复延时': '慢充口高温2_保护恢复延时',
    '慢充口高温3_保护值': '慢充口高温3_保护值',
    '慢充口高温3_保护延时': '慢充口高温3_保护延时',
    '慢充口高温3_保护恢复值': '慢充口高温3_保护恢复值',
    '慢充口高温3_保护恢复延时': '慢充口高温3_保护恢复延时',
    '放电口高温1_保护值': '放电口高温1_保护值',
    '放电口高温1_保护延时': '放电口高温1_保护延时',
    '放电口高温1_保护恢复值': '放电口高温1_保护恢复值',
    '放电口高温1_保护恢复延时': '放电口高温1_保护恢复延时',
    '放电口高温2_保护值': '放电口高温2_保护值',
    '放电口高温2_保护延时': '放电口高温2_保护延时',
    '放电口高温2_保护恢复值': '放电口高温2_保护恢复值',
    '放电口高温2_保护恢复延时': '放电口高温2_保护恢复延时',
    '放电口高温3_保护值': '放电口高温3_保护值',
    '放电口高温3_保护延时': '放电口高温3_保护延时',
    '放电口高温3_保护恢复值': '放电口高温3_保护恢复值',
    '放电口高温3_保护恢复延时': '放电口高温3_保护恢复延时',
    '正极端子高温1_保护值': '正极端子高温1_保护值',
    '正极端子高温1_保护延时': '正极端子高温1_保护延时',
    '正极端子高温1_保护恢复值': '正极端子高温1_保护恢复值',
    '正极端子高温1_保护恢复延时': '正极端子高温1_保护恢复延时',
    '正极端子高温2_保护值': '正极端子高温2_保护值',
    '正极端子高温2_保护延时': '正极端子高温2_保护延时',
    '正极端子高温2_保护恢复值': '正极端子高温2_保护恢复值',
    '正极端子高温2_保护恢复延时': '正极端子高温2_保护恢复延时',
    '正极端子高温3_保护值': '正极端子高温3_保护值',
    '正极端子高温3_保护延时': '正极端子高温3_保护延时',
    '正极端子高温3_保护恢复值': '正极端子高温3_保护恢复值',
    '正极端子高温3_保护恢复延时': '正极端子高温3_保护恢复延时',
    '负极端子高温1_保护值': '负极端子高温1_保护值',
    '负极端子高温1_保护延时': '负极端子高温1_保护延时',
    '负极端子高温1_保护恢复值': '负极端子高温1_保护恢复值',
    '负极端子高温1_保护恢复延时': '负极端子高温1_保护恢复延时',
    '负极端子高温2_保护值': '负极端子高温2_保护值',
    '负极端子高温2_保护延时': '负极端子高温2_保护延时',
    '负极端子高温2_保护恢复值': '负极端子高温2_保护恢复值',
    '负极端子高温2_保护恢复延时': '负极端子高温2_保护恢复延时',
    '负极端子高温3_保护值': '负极端子高温3_保护值',
    '负极端子高温3_保护延时': '负极端子高温3_保护延时',
    '负极端子高温3_保护恢复值': '负极端子高温3_保护恢复值',
    '负极端子高温3_保护恢复延时': '负极端子高温3_保护恢复延时',
    '1级保护状态': '1级保护状态',
    '2级保护状态': '2级保护状态',
    '3级保护状态': '3级保护状态',
    '故障状态': '故障状态',
    '开关控制状态': '开关控制状态',
    '开关响应状态': '开关响应状态',
    '继电器真实状态': '继电器真实状态',
    '传感器状态': '传感器状态',
    '特殊状态': '特殊状态',
    '端子温度数量': '端子温度数量',
    '端子温度': '端子温度',
    '最大单体电压在PACK中的地址': '最大单体电压在PACK中的地址',
    '最小单体电压在PACK中的地址': '最小单体电压在PACK中的地址',
    '电芯温度最大值': '电芯温度最大值',
    '电芯温度最小值': '电芯温度最小值',
    '最大电芯温度PACK地址': '最大电芯温度PACK地址',
    '最小电芯温度PACK地址': '最小电芯温度PACK地址',
    '最大电芯温度在PACK中的地址': '最大电芯温度在PACK中的地址',
    '最小电芯温度在PACK中的地址': '最小电芯温度在PACK中的地址',
    'PACK电压最大值': 'PACK电压最大值',
    'PACK电压最小值': 'PACK电压最小值',
    '最大PACK电压PACK地址': '最大PACK电压PACK地址',
    '最小PACK电压PACK地址': '最小PACK电压PACK地址',
    '快充继电器': '快充继电器',
    '慢充继电器': '慢充继电器',
    '快充继电器使能': '快充继电器使能',
    '慢充继电器使能': '慢充继电器使能',
    '预充': '预充',
    '霍尔传感器': '霍尔传感器',
    '快充口高温': '快充口高温',
    '慢充口高温': '慢充口高温',
    '放电口高温': '放电口高温',
    '正极端子高温保护': '正极端子高温保护',
    '负极端子高温保护': '负极端子高温保护',
    'Ntc采样异常1_保护延时': 'Ntc采样异常1_保护延时',
    'Ntc采样异常1_保护恢复延时': 'Ntc采样异常1_保护恢复延时',
    'Ntc采样异常2_保护延时': 'Ntc采样异常2_保护延时',
    'Ntc采样异常2_保护恢复延时': 'Ntc采样异常2_保护恢复延时',
    'Ntc采样异常3_保护延时': 'Ntc采样异常3_保护延时',
    'Ntc采样异常3_保护恢复延时': 'Ntc采样异常3_保护恢复延时',
    '电芯采样异常1_保护延时': '电芯采样异常1_保护延时',
    '电芯采样异常1_保护恢复延时': '电芯采样异常1_保护恢复延时',
    '电芯采样异常2_保护延时': '电芯采样异常2_保护延时',
    '电芯采样异常2_保护恢复延时': '电芯采样异常2_保护恢复延时',
    '电芯采样异常3_保护延时': '电芯采样异常3_保护延时',
    '电芯采样异常3_保护恢复延时': '电芯采样异常3_保护恢复延时',
    '加热膜开启温度': '加热膜开启温度',
    '加热膜关闭温度': '加热膜关闭温度',
    '时区设置': '时区设置',
    '个人中心': '个人中心',
    '重置密码': '重置密码',
    '退出登录': '退出登录',
    '时区': '时区',
    '亚洲': '亚洲',
    '北美洲': '北美洲',
    '欧洲': '欧洲',
    '南美洲': '南美洲',
    '非洲': '非洲',
    '中国': '中国',
    '香港': '香港',
    '日本': '日本',
    '韩国': '韩国',
    '印度': '印度',
    '新加坡': '新加坡',
    '马来西亚': '马来西亚',
    '泰国': '泰国',
    '越南': '越南',
    '台湾地区': '台湾地区',
    '香港地区': '香港地区',
    '澳门地区': '澳门地区',
    '菲律宾': '菲律宾',
    '阿联酋（迪拜）': '阿联酋（迪拜）',
    '美国（东部）': '美国（东部）',
    '加拿大（东部）': '加拿大（东部）',
    '加拿大（西部）': '加拿大（西部）',
    '墨西哥': '墨西哥',
    '英国': '英国',
    '德国': '德国',
    '法国': '法国',
    '意大利': '意大利',
    '西班牙': '西班牙',
    '俄罗斯（莫斯科）': '俄罗斯（莫斯科）',
    '荷兰': '荷兰',
    '瑞士': '瑞士',
    '澳大利亚（东部）': '澳大利亚（东部）',
    '澳大利亚（中部）': '澳大利亚（中部）',
    '新西兰': '新西兰',
    '巴西（圣保罗）': '巴西（圣保罗）',
    '阿根廷': '阿根廷',
    '南非': '南非',
    '埃及': '埃及',
    '肯尼亚': '肯尼亚',
    '时区不能为空': '时区不能为空',
    '重置密码': '重置密码',
    '原密码': '原密码',
    '新密码': '新密码',
    '重复新密码': '重复新密码',
    '原密码不能为空': '原密码不能为空',
    '新密码不能为空': '新密码不能为空',
    '重复新密码': '重复新密码',
    '重复新密码不能为空': '重复新密码不能为空',
    '导出': '导出',
    '搜索': '搜索',
    '请输入设备ID': '请输入设备ID',
    '输入设备ID': '输入设备ID',
    '导入设备ID': '导入设备ID',
    '上传设备ID': '上传设备ID',
    '设备ID不能为空': '设备ID不能为空',
    '设备ID文件不能为空': '设备ID文件不能为空',
    '上传设备ID文件': '上传设备ID文件（xls或xlsx文件）',
    '代理商管理': '代理商管理',
    '出库管理': '出库管理',
    '资料下载': '资料下载',
  },
  deviceId: '设备ID',
  latestLaunchTime: "最新上线时间",
  activationTime: '激活时间',
  columnSet: '列设置',
  selectAll: '全选',
  showQuery: '展开查询',
  hideQuery: '收起查询',
  console: '控制台',
  productionTestingTime: '产测时间',
  productionTestingStatus: '产测状态',
  jihuoqushi: '激活趋势',
  productImg: '产品图',
  viewLargeImg: '查看大图',
  exportSuccess: "导出成功，请在下载记录菜单中查看",
  fileCeateing: '文件生成中',
  fileCeated: '导出成功',
  chacheexport: '叉车导出开发中',
  downloadlist: "导出下载",
  trajectory: "轨迹列表",
  detailsNew: '设备列表'
}
